// Translations for the entire application
const translations = {
  pt: {
    recordingAutoResumed: "Gravação retomada automaticamente após atualizar a página.",
    recordingResumeNeedsClick: "A gravação estava ativa antes de atualizar. Clique em Iniciar para retomar — o navegador exige um clique para capturar o áudio do sistema.",
    authForgotPassword: "Esqueceu a senha?",
    authForgotTitle: "Redefinir senha",
    authForgotDesc: "Informe seu e-mail e enviaremos um link para criar uma nova senha",
    authSendResetLink: "Enviar link de redefinição",
    authResetEmailSent: "Se este e-mail estiver cadastrado, você receberá um link de redefinição em instantes. Verifique também a pasta de spam.",
    authBackToLogin: "← Voltar para o login",
    authResetTitle: "Criar nova senha",
    authResetDesc: "Digite e confirme sua nova senha",
    authNewPassword: "Nova senha",
    authConfirmPassword: "Confirmar nova senha",
    authPasswordsMismatch: "As senhas não coincidem.",
    authPasswordTooShort: "A senha deve ter pelo menos 6 caracteres.",
    authResetSuccess: "Senha redefinida com sucesso! Redirecionando para o login...",
    authResetInvalidToken: "Link inválido ou expirado. Solicite um novo link de redefinição.",
    authResetButton: "Salvar nova senha",
    authGenericError: "Ocorreu um erro. Tente novamente.",
    // Home page
    selectLanguage: "Selecione o seu idioma.",
    selectLanguageEn: "Select your language.",
    continue: "Continuar",
    
    // Language Pair Selection page
    selectTranslationLanguages: "Selecione os 2 idiomas para Tradução em Tempo Real",
    sourceLanguage: "Idioma de Origem",
    targetLanguage: "Idioma de Destino",
    selectTargetLanguage: "Selecione o idioma de destino",
    startTranslation: "Iniciar Tradução",
    languagePairHint: "A tradução será feita automaticamente entre estes dois idiomas",
    
    // Home button
    homeButton: "Início",
    
    // Dashboard
    appTitle: "Tradutor em Tempo Real",
    appSubtitle: "Inglês ↔ Português do Brasil (Detecção automática)",
    controlTab: "Controle",
    settingsTab: "Configurações",
    
    // Header / Navigation
    plans: "Planos",
    account: "Conta",
    logout: "Sair",
    signUp: "Cadastre-se",
    guest: "Convidado",
    free: "Free",
    
    // Footer
    footerCopyright: "Desenvolvido por João Vitor Fernandes Farias. Todos os direitos de uso, reprodução e propriedade intelectual são reservados.",
    backToDashboard: "Voltar para o Dashboard",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "Use traduções como legenda em suas transmissões ao vivo no OBS, Streamlabs e outros softwares de streaming.",
    obsProOnlyText: "Esta funcionalidade está disponível apenas no Plano PRO",
    obsCustomizeLabel: "Personalizar",
    obsPositionLabel: "Posição",
    obsTextShadowLabel: "Sombra no Texto",
    obsTextShadowDesc: "Melhora a legibilidade sobre vídeos",
    obsGenerateUrl: "Gerar URL para OBS",
    obsGeneratedUrlLabel: "URL Gerada para OBS:",
    obsCopied: "URL copiada!",
    obsPreviewBtn: "Visualizar Prévia",
    obsParamsReference: "Parâmetros opcionais na URL (referência)",
    obsParamBg: "Cor do fundo",
    obsParamFontSize: "Tamanho da fonte (px)",
    obsParamColor: "Cor do texto (hex sem #)",
    obsParamPosition: "Posição",
    obsParamShadow: "Sombra no texto",
    obsSettingsPlaceholder: "Configurações de personalização...",
    
    // Audio section
    audioInput: "Entrada de Áudio",
    audioSource: "Fonte de Áudio",
    microphone: "Microfone",
    system: "Sistema",
    both: "Ambos",
    start: "Start",
    stop: "Stop",
    status: "Status",
    statusIdle: "Inativo",
    statusConnecting: "Conectando...",
    statusRecording: "Gravando",
    statusError: "Erro",
    clickToStart: "Clique em Start para iniciar",
    processingAudio: "Processando áudio em tempo real...",
    openTranslationWindow: "Abrir Janela de Tradução",
    openSecondScreen: "Abrir Na Segunda Tela",
    secondScreenDetected: "Segunda tela detectada",
    noSecondScreen: "Nenhuma segunda tela detectada",
    detect: "Detectar",
    
    // Second Window
    secondTranslationWindow: "Segunda Janela de Tradução",
    enableSecondWindow: "Habilitar segunda janela",
    optional: "Opcional",
    openSecondWindowFull: "Abrir Segunda Janela",
    splitScreenButton: "Habilitar segunda janela (50% a 50%)",
    splitScreenSuccess: "Janelas abertas lado a lado na segunda tela (50/50)",
    splitScreenNoScreen: "Segunda tela não detectada",
    splitScreenPermission: "Para posicionar as janelas na segunda tela, permita o acesso de 'Gerenciamento de janelas' quando o navegador solicitar (ou em Configurações do site) e clique no botão novamente.",
    splitScreenPopupBlocked: "O navegador bloqueou a abertura das janelas. Permita pop-ups para este site e clique novamente.",
    splitScreenBraveShields: "O navegador está mascarando as dimensões das telas (proteção anti-fingerprint). No Brave: clique no ícone do leão na barra de endereço → Controles avançados → 'Bloquear impressão digital' → Desativado para este site. Recarregue e tente novamente.",
    secondWindowProOnly: "Esta funcionalidade está disponível apenas no Plano PRO",
    upgradeProSecondWindow: "Exiba traduções em um terceiro idioma simultaneamente. Ideal para eventos com público multilíngue ou para traduções para diferentes idiomas em mais de uma tela.",
    upgradePro: "Upgrade PRO",
    
    // Pricing Page
    pricingTitle: "Escolha seu Plano",
    pricingSubtitle: "Comece gratuitamente ou desbloqueie tradução ilimitada com o Plano PRO",
    planFree: "Plano Free",
    planPro: "Plano PRO",
    currentPlan: "Plano Atual",
    perfectToTry: "Perfeito para experimentar",
    forProfessionalUse: "Para uso profissional",
    freePrice: "Grátis",
    perMonth: "/mês",
    feature10Minutes: "10 minutos de tradução por mês",
    featureBidirectional: "Tradução bidirecional",
    feature20Languages: "20 idiomas suportados",
    featureUnlimited: "Tradução ILIMITADA",
    feature2Screens: "Tradução para 2 idiomas em telas separadas",
    featureOBS: "Integração com OBS para streaming",
    featureQRCode: "Tradução direta no telefone do visitante via QR Code",
    startFree: "Começar Grátis",
    alreadyPro: "Você já é PRO!",
    creditCard: "Cartão",
    payWithCard: "Pagar com Cartão",
    loginToPay: "Fazer Login para Pagar",
    verifyPayment: "Verificar Pagamento",
    amount: "Valor",
    noConversionNeeded: "Envie exatamente o valor em",
    solanaNetwork: "Rede Solana",
    sendTo: "Enviar para",
    tokenOnSolana: "na rede Solana",
    txSignatureLabel: "Assinatura da Transação (após enviar)",
    txSignaturePlaceholder: "Cole a assinatura da transação aqui",
    viewOnSolscan: "Ver transação no Solscan",
    addressCopied: "Endereço copiado!",
    errorRedirectPayment: "Erro ao redirecionar para pagamento",
    errorEnterTxSignature: "Por favor, insira a assinatura da transação",
    errorVerifyTx: "Erro ao verificar transação",
    
    // OBS Integration
    obsIntegration: "Integração com OBS",
    streaming: "Streaming",
    obsDescription: "Use a tradução como legenda em suas transmissões ao vivo. Adicione como \"Browser Source\" no OBS.",
    customizeLegend: "Personalizar Legenda",
    backgroundColor: "Cor de Fundo",
    transparent: "Transparente",
    green: "Verde",
    blue: "Azul",
    magenta: "Magenta",
    black: "Preto",
    fontSize: "Tamanho da Fonte",
    textColor: "Cor do Texto",
    customize: "Personalizar",
    position: "Posição",
    top: "Topo",
    center: "Centro",
    bottom: "Inferior",
    textShadow: "Sombra no Texto",
    textShadowDescription: "Melhora a legibilidade sobre vídeos",
    generateObsUrl: "Gerar URL para OBS",
    optionalUrlParams: "Parâmetros opcionais na URL (referência)",
    obsStepByStep: "Passo a passo OBS",
    obsProOnly: "Esta funcionalidade está disponível apenas no Plano PRO",
    
    // Translation Rooms
    translationRooms: "Salas de Tradução",
    events: "Eventos",
    createRoom: "Criar Sala de Tradução",
    roomDescription: "Crie uma sala para que pessoas em eventos, igrejas ou conferências possam acessar a tradução em seus próprios dispositivos via QR Code ou link.",
    roomProOnly: "Salas de Tradução são exclusivas para usuários PRO",
    upgradeToProRooms: "Crie uma sala e compartilhe um QR Code/link para que visitantes de eventos, igrejas ou conferências vejam a tradução em seus próprios dispositivos.",
    
    // Permanent Links
    permanentLinks: "Links Fixos",
    permanent: "Permanente",
    createPermanentLink: "Criar Link Fixo",
    permanentLinkDescription: "Crie links permanentes para igrejas, conferências e eventos recorrentes. Imprima o QR Code uma vez e use sempre!",
    roomName: "Nome da Sala",
    customCode: "Código Personalizado",
    customCodeOptional: "opcional",
    leaveEmptyToGenerate: "Deixe vazio para gerar automaticamente",
    linkPreview: "Preview do link",
    noPermanentLinksYet: "Nenhum link fixo criado ainda. Crie um link permanente para usar em eventos recorrentes.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR Code - Link Fixo",
    permanentLinkLabel: "Link permanente:",
    qrNeverChanges: "Este QR Code e link nunca mudam! Você pode imprimir e usar sempre.",
    copyLink: "Copiar Link",
    openLink: "Abrir",
    
    // QR Code Modal - Translation Room  
    shareRoom: "Compartilhar Sala",
    roomCode: "Código da sala:",
    shareLink: "Link para compartilhar:",
    visitorsCanScan: "Visitantes podem escanear o QR Code ou acessar o link para ver a tradução ao vivo",
    endRoomConfirm: "Tem certeza que deseja encerrar a sala? Todos os visitantes serão desconectados.",
    share: "Compartilhar",
    
    // Room Config
    roomConfig: "Configuração da Sala",
    presenterLanguages: "Idiomas dos Apresentadores",
    presenterLanguagesDescription: "Selecione todos os idiomas que serão falados pelos apresentadores neste evento. Isso ajuda a melhorar a precisão da detecção de idioma.",
    presenterLanguagesTip: "Dica: Se houver palestrantes que falam diferentes idiomas, selecione todos eles para otimizar a tradução.",
    selected: "selecionado",
    close: "Fechar",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "Sala de Tradução",
    publicRoomBy: "por",
    publicRoomSelectLanguage: "Qual é o seu idioma?",
    publicRoomLanguageHint: "A tradução será apresentada no idioma escolhido",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "Sala Indisponível",
    publicRoomBackHome: "Voltar ao Início",
    publicRoomConnecting: "Conectando à sala",
    publicRoomHeaderRoom: "Sala",
    publicRoomConnected: "Conectado",
    publicRoomReconnecting: "Reconectando...",
    publicRoomChangeLanguage: "Mudar idioma",
    publicRoomSettings: "Configurações",
    publicRoomReadingSpeed: "Velocidade de leitura",
    publicRoomReadingSpeedSlow: "Devagar",
    publicRoomReadingSpeedNormal: "Normal",
    publicRoomReadingSpeedFast: "Rápido",
    publicRoomReadingSpeedUnit: "car/s",
    publicRoomInQueue: "na fila",
    publicRoomFontSize: "Tamanho da fonte",
    publicRoomBgColor: "Cor de fundo",
    publicRoomTextColor: "Cor do texto",
    publicRoomShowOriginal: "Mostrar texto original",
    publicRoomFullscreen: "Tela cheia",
    publicRoomExitFullscreen: "Sair da tela cheia",
    publicRoomWaitingTranslation: "Aguardando tradução...",
    publicRoomViewers: "espectadores",
    publicRoomViewer: "espectador",
    publicRoomWaitingSession: "Aguardando início da sessão...",
    publicRoomSessionWillStart: "A tradução começará automaticamente quando o apresentador iniciar.",
    publicRoomTranslating: "Traduzindo...",
    publicRoomErrorNotFound: "Sala não encontrada. Verifique o código e tente novamente.",
    publicRoomErrorServer: "Erro ao conectar com o servidor. Tente novamente.",
    publicRoomSessionEnded: "O apresentador encerrou a sessão",
    publicRoomDeleted: "Esta sala foi excluída permanentemente.",
    
    // Output mode selection
    publicRoomSelectMode: "Como deseja receber a tradução?",
    publicRoomModeHint: "Escolha o modo de saída da tradução",
    publicRoomTextOnly: "Tradução em Texto",
    publicRoomTextOnlyDesc: "Leia a tradução na tela",
    publicRoomTextVoice: "Tradução em Texto + Voz",
    publicRoomTextVoiceDesc: "Leia e ouça a tradução",
    publicRoomHeadphonesRequired: "Requer fones de ouvido",
    publicRoomHeadphonesOverride: "Tenho fones conectados, mas não foram detectados",
    publicRoomHeadphonesNotDetected: "Conecte fones de ouvido para habilitar esta opção",
    publicRoomHeadphonesDetected: "Fones de ouvido detectados",
    publicRoomCheckingAudio: "Verificando dispositivos de áudio...",
    publicRoomSpeaking: "Falando...",
    publicRoomVoiceEnabled: "Voz ativada",
    publicRoomChangeVoice: "Voz do Tradutor",
    publicRoomVoiceDisabled: "Voz desativada",
    publicRoomSelectVoice: "Escolha a voz",
    publicRoomSelectVoiceHint: "Selecione a voz para a tradução falada",
    publicRoomVoicePreview: "Prévia",
    publicRoomNoVoicesAvailable: "Nenhuma voz disponível para este idioma",
    publicRoomVoiceSelected: "Voz selecionada",
    publicRoomConfirm: "Confirmar",
    publicRoomTestVoice: "Testar voz",
    publicRoomNoNativeVoices: "Seu dispositivo não possui vozes em {language}. Mostrando vozes disponíveis.",
    publicRoomInstallVoices: "Para obter vozes em outros idiomas, instale pacotes de idiomas nas configurações do seu sistema.",
    publicRoomHowToInstallVoices: "Como Instalar Vozes",
    publicRoomVoiceHelpTitle: "Como Instalar Vozes no Seu Dispositivo",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. Abra Configurações (Win + I)\n2. Vá em Hora e Idioma → Fala\n3. Clique em \"Adicionar vozes\"\n4. Selecione os idiomas desejados\n5. Reinicie o navegador",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. Abra Preferências do Sistema\n2. Vá em Acessibilidade → Conteúdo Falado\n3. Clique em \"Voz do Sistema\"\n4. Selecione \"Personalizar\"\n5. Baixe as vozes desejadas",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. Abra Configurações\n2. Vá em Acessibilidade → Texto para Fala\n3. Toque em \"Mecanismo preferencial\"\n4. Instale idiomas adicionais\n5. Reinicie o navegador",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. Abra Ajustes\n2. Vá em Acessibilidade → Conteúdo Falado\n3. Toque em \"Vozes\"\n4. Selecione o idioma desejado\n5. Baixe as vozes disponíveis",
    publicRoomVoiceHelpTip: "Dica: O Google Chrome geralmente oferece mais vozes que outros navegadores.",
    publicRoomVoiceHelpClose: "Fechar",
    
    // Translation preview
    translationPreview: "Prévia da Tradução",
    original: "Original",
    translation: "Tradução",
    waitingAudio: "Aguardando áudio...",
    waitingTranslation: "Aguardando tradução...",
    detecting: "Detectando...",
    portuguese: "Português",
    english: "Inglês",
    
    // Settings
    audioDevice: "Dispositivo de Áudio",
    selectAudioSource: "Selecione a fonte de áudio",
    audioDeviceDescription: "Escolha o microfone ou placa de áudio que será usada para captar o áudio do palestrante.",
    
    delayAdjustment: "Ajuste de Delay",
    translationDelay: "Delay da tradução",
    delayDescription: "Ajuste o tempo de delay entre a captura do áudio e a tradução. Valores maiores podem melhorar a qualidade da transcrição.",
    
    audioGate: "Gate de Áudio (Filtro de Ruído)",
    gateThreshold: "Threshold do Gate",
    gateDescription: "O gate filtra sons abaixo do threshold definido (respiração, ruídos ambientes).",
    recommended: "Valor recomendado: -30dB a -20dB.",
    sensitive: "sensível",
    loud: "alto",

    readingSpeed: "Velocidade de leitura",
    readingSpeedLabel: "Velocidade",
    readingSpeedSlow: "Devagar",
    readingSpeedNormal: "Normal",
    readingSpeedFast: "Rápido",
    readingSpeedUnit: "car/s",
    readingSpeedDescription: "Controla o tempo mínimo que cada tradução fica na janela. Menor = mais tempo para ler; Maior = acompanha melhor o áudio ao vivo.",

    systemTest: "Testar sistema",
    systemTestDescription: "Faz um teste rápido de todo o pipeline (Whisper + GPT + janelas) com um áudio pré-gravado. Ideal para verificar antes de um evento ao vivo.",
    systemTestButton: "Executar teste",
    systemTestRunning: "Executando...",
    systemTestRerun: "Testar novamente",
    systemTestClose: "Fechar",
    systemTestDialogTitle: "Diagnóstico do sistema",
    systemTestDialogDescription: "Rodando o pipeline completo com um áudio de referência.",
    systemTestStepWhisper: "Reconhecimento de voz (Whisper)",
    systemTestStepGpt: "Tradução (GPT)",
    systemTestStepDisplay: "Exibição nas janelas",
    systemTestTotalTime: "Tempo total",
    systemTestPassed: "OK",
    systemTestFailed: "Falhou",
    systemTestFailedGeneric: "Falhou. Verifique os logs do servidor.",
    systemTestFilteredReason: "Filtrado pelo detector de alucinações",
    systemTestDisplayOk: "Traduções escritas para as janelas com sucesso",
    systemTestDisplayFailed: "Não foi possível escrever nas janelas",
    
    overlayMode: "Modo Sobreposição",
    overlayOtherWindows: "Sobrepor outras janelas",
    overlayDescription: "Quando ativado, a janela de tradução tentará permanecer sempre visível sobre outros programas.",
    overlayActive: "Modo Sobreposição Ativado",
    overlayActiveDescription: "A janela de tradução será aberta em modo popup e tentará manter o foco automaticamente.",
    
    slideTime: "Tempo do Slide Traduzido",
    slideDuration: "Duração de cada slide",
    slideDescription: "Define quanto tempo cada slide de tradução permanece na tela antes de avançar automaticamente para o próximo.",
    seconds: "segundos",
    second: "segundo",
    
    translationLines: "Linhas com Tradução",
    maxLinesPerSlide: "Máximo de linhas por slide",
    linesDescription: "Define o número máximo de linhas de texto exibidas em cada slide de tradução.",
    line: "linha",
    lines: "linhas",
    
    translationFontSize: "Tamanho da Fonte da Tradução",
    fontSizeDescription: "Define o tamanho da fonte do texto traduzido na janela de tradução.",
    small: "pequeno",
    large: "grande",
    
    headerBox: "Caixa Superior (Cabeçalho)",
    headerText: "Texto do Cabeçalho",
    footerBox: "Caixa Inferior (Rodapé)",
    footerText: "Texto do Rodapé",
    padding: "Padding",
    roundCorners: "Cantos Arredondados",
    colors: "Cores",
    text: "Texto",
    background: "Fundo",
    preview: "Prévia",
    on: "ON",
    off: "OFF",
    
    // History
    recentHistory: "Histórico Recente",
    
    // Translation window
    overlayActiveIndicator: "Sobreposição Ativa",
    prevSlide: "Slide anterior",
    nextSlide: "Próximo slide",
    goToSlide: "Ir para slide",
    exitFullscreen: "Sair do modo tela cheia",
    enterFullscreen: "Modo tela cheia",
    closeWindow: "Fechar janela",
    disableOverlay: "Desativar sobreposição",
    enableOverlay: "Ativar sobreposição",
    
    // Gate status
    gateOpen: "Gate Aberto - Gravando",
    gateClosed: "Gate Fechado - Aguardando sinal",

    // Auth page
    authSignIn: "Entrar",
    authSignUp: "Criar Conta",
    authSignInSubtitle: "Entre para continuar usando o tradutor",
    authSignUpSubtitle: "Crie sua conta para começar",
    authEmail: "Email",
    authPassword: "Senha",
    authName: "Nome",
    authEmailPlaceholder: "seu@email.com",
    authPasswordPlaceholder: "Sua senha",
    authNamePlaceholder: "Seu nome",
    authOrContinueWith: "OU CONTINUE COM",
    authContinueGoogle: "Continuar com Google",
    authNoAccount: "Não tem conta?",
    authHasAccount: "Já tem conta?",
    authAccessAsGuest: "Acessar como convidado",
    authBackToHome: "Voltar para o início",
    authDiagnostics: "Problemas para acessar? Clique aqui para diagnóstico",
    authWallet: "Carteira",
    authConnectWallet: "Conectar Carteira Solana",
    authConnectWalletDesc: "Conecte sua carteira Phantom para acessar",
    authPhantomNotFound: "Phantom não encontrado",
    authInstallPhantom: "Instalar Phantom",

    // Language names
    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },
  
  en: {
    recordingAutoResumed: "Recording resumed automatically after the page refresh.",
    recordingResumeNeedsClick: "Recording was active before the refresh. Click Start to resume — the browser requires a click to capture system audio.",
    authForgotPassword: "Forgot password?",
    authForgotTitle: "Reset password",
    authForgotDesc: "Enter your email and we'll send you a link to create a new password",
    authSendResetLink: "Send reset link",
    authResetEmailSent: "If this email is registered, you'll receive a reset link shortly. Please also check your spam folder.",
    authBackToLogin: "← Back to login",
    authResetTitle: "Create new password",
    authResetDesc: "Enter and confirm your new password",
    authNewPassword: "New password",
    authConfirmPassword: "Confirm new password",
    authPasswordsMismatch: "Passwords do not match.",
    authPasswordTooShort: "Password must be at least 6 characters.",
    authResetSuccess: "Password reset successfully! Redirecting to login...",
    authResetInvalidToken: "Invalid or expired link. Please request a new reset link.",
    authResetButton: "Save new password",
    authGenericError: "An error occurred. Please try again.",
    selectLanguage: "Select your language.",
    selectLanguageEn: "Selecione o seu idioma.",
    continue: "Continue",
    
    // Language Pair Selection page
    selectTranslationLanguages: "Select the 2 languages for Real-Time Translation",
    sourceLanguage: "Source Language",
    targetLanguage: "Target Language",
    selectTargetLanguage: "Select the target language",
    startTranslation: "Start Translation",
    languagePairHint: "Translation will be done automatically between these two languages",
    
    // Home button
    homeButton: "Home",
    
    appTitle: "Real-time Translator",
    appSubtitle: "English ↔ Brazilian Portuguese (Auto detection)",
    controlTab: "Control",
    settingsTab: "Settings",
    
    // Header / Navigation
    plans: "Plans",
    account: "Account",
    logout: "Logout",
    signUp: "Sign Up",
    guest: "Guest",
    free: "Free",
    
    // Footer
    footerCopyright: "Developed by João Vitor Fernandes Farias. All rights reserved.",
    backToDashboard: "Back to Dashboard",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "Use translations as subtitles in your live streams on OBS, Streamlabs and other streaming software.",
    obsProOnlyText: "This feature is available only on the PRO Plan",
    obsCustomizeLabel: "Customize",
    obsPositionLabel: "Position",
    obsTextShadowLabel: "Text Shadow",
    obsTextShadowDesc: "Improves readability over videos",
    obsGenerateUrl: "Generate URL for OBS",
    obsGeneratedUrlLabel: "Generated URL for OBS:",
    obsCopied: "URL copied!",
    obsPreviewBtn: "Preview",
    obsParamsReference: "Optional URL parameters (reference)",
    obsParamBg: "Background color",
    obsParamFontSize: "Font size (px)",
    obsParamColor: "Text color (hex without #)",
    obsParamPosition: "Position",
    obsParamShadow: "Text shadow",
    obsSettingsPlaceholder: "Customization settings...",
    
    // Audio section
    audioInput: "Audio Input",
    audioSource: "Audio Source",
    microphone: "Microphone",
    system: "System",
    both: "Both",
    start: "Start",
    stop: "Stop",
    status: "Status",
    statusIdle: "Idle",
    statusConnecting: "Connecting...",
    statusRecording: "Recording",
    statusError: "Error",
    clickToStart: "Click Start to begin",
    processingAudio: "Processing audio in real-time...",
    openTranslationWindow: "Open Translation Window",
    openSecondScreen: "Open on Second Screen",
    secondScreenDetected: "Second screen detected",
    noSecondScreen: "No second screen detected",
    detect: "Detect",
    
    // Second Window
    secondTranslationWindow: "Second Translation Window",
    enableSecondWindow: "Enable second window",
    optional: "Optional",
    openSecondWindowFull: "Open Second Window",
    splitScreenButton: "Enable second window (50/50 split)",
    splitScreenSuccess: "Windows opened side by side on the second screen (50/50)",
    splitScreenNoScreen: "Second screen not detected",
    splitScreenPermission: "To position windows on the second screen, allow 'Window management' access when the browser asks (or in Site Settings) and click the button again.",
    splitScreenPopupBlocked: "The browser blocked the windows from opening. Allow pop-ups for this site and click again.",
    splitScreenBraveShields: "The browser is masking screen dimensions (anti-fingerprint protection). In Brave: click the lion icon in the address bar → Advanced controls → 'Block fingerprinting' → Disabled for this site. Reload and try again.",
    secondWindowProOnly: "This feature is available only on the PRO Plan",
    upgradeProSecondWindow: "Display translations in a third language simultaneously. Ideal for events with multilingual audiences or translations for different languages on multiple screens.",
    upgradePro: "Upgrade PRO",
    
    // Pricing Page
    pricingTitle: "Choose your Plan",
    pricingSubtitle: "Start for free or unlock unlimited translation with the PRO Plan",
    planFree: "Free Plan",
    planPro: "PRO Plan",
    currentPlan: "Current Plan",
    perfectToTry: "Perfect to try it out",
    forProfessionalUse: "For professional use",
    freePrice: "Free",
    perMonth: "/month",
    feature10Minutes: "10 minutes of translation per month",
    featureBidirectional: "Bidirectional translation",
    feature20Languages: "20 languages supported",
    featureUnlimited: "UNLIMITED Translation",
    feature2Screens: "Translation to 2 languages on separate screens",
    featureOBS: "OBS integration for streaming",
    featureQRCode: "Direct translation on visitor's phone via QR Code",
    startFree: "Start Free",
    alreadyPro: "You're already PRO!",
    creditCard: "Card",
    payWithCard: "Pay with Card",
    loginToPay: "Login to Pay",
    verifyPayment: "Verify Payment",
    amount: "Amount",
    noConversionNeeded: "Send exactly the amount in",
    solanaNetwork: "Solana Network",
    sendTo: "Send to",
    tokenOnSolana: "on Solana network",
    txSignatureLabel: "Transaction Signature (after sending)",
    txSignaturePlaceholder: "Paste the transaction signature here",
    viewOnSolscan: "View transaction on Solscan",
    addressCopied: "Address copied!",
    errorRedirectPayment: "Error redirecting to payment",
    errorEnterTxSignature: "Please enter the transaction signature",
    errorVerifyTx: "Error verifying transaction",
    
    // OBS Integration
    obsIntegration: "OBS Integration",
    streaming: "Streaming",
    obsDescription: "Use translation as subtitles in your live streams. Add as \"Browser Source\" in OBS.",
    customizeLegend: "Customize Subtitles",
    backgroundColor: "Background Color",
    transparent: "Transparent",
    green: "Green",
    blue: "Blue",
    magenta: "Magenta",
    black: "Black",
    fontSize: "Font Size",
    textColor: "Text Color",
    customize: "Customize",
    position: "Position",
    top: "Top",
    center: "Center",
    bottom: "Bottom",
    textShadow: "Text Shadow",
    textShadowDescription: "Improves readability over videos",
    generateObsUrl: "Generate URL for OBS",
    optionalUrlParams: "Optional URL parameters (reference)",
    obsStepByStep: "OBS Step by Step",
    obsProOnly: "This feature is available only on the PRO Plan",
    
    // Translation Rooms
    translationRooms: "Translation Rooms",
    events: "Events",
    createRoom: "Create Translation Room",
    roomDescription: "Create a room so people at events, churches or conferences can access translation on their own devices via QR Code or link.",
    roomProOnly: "Translation Rooms are exclusive to PRO users",
    upgradeToProRooms: "Create a room and share a QR Code/link so event, church or conference visitors can see the translation on their own devices.",
    
    // Permanent Links
    permanentLinks: "Permanent Links",
    permanent: "Permanent",
    createPermanentLink: "Create Permanent Link",
    permanentLinkDescription: "Create permanent links for churches, conferences and recurring events. Print the QR Code once and use it always!",
    roomName: "Room Name",
    customCode: "Custom Code",
    customCodeOptional: "optional",
    leaveEmptyToGenerate: "Leave empty to auto-generate",
    linkPreview: "Link preview",
    noPermanentLinksYet: "No permanent links created yet. Create a permanent link for recurring events.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR Code - Fixed Link",
    permanentLinkLabel: "Permanent link:",
    qrNeverChanges: "This QR Code and link never change! You can print and use it forever.",
    copyLink: "Copy Link",
    openLink: "Open",
    
    // QR Code Modal - Translation Room  
    shareRoom: "Share Room",
    roomCode: "Room code:",
    shareLink: "Share link:",
    visitorsCanScan: "Visitors can scan the QR Code or access the link to see the live translation",
    endRoomConfirm: "Are you sure you want to end the room? All visitors will be disconnected.",
    share: "Share",
    
    // Room Config
    roomConfig: "Room Configuration",
    presenterLanguages: "Presenter Languages",
    presenterLanguagesDescription: "Select all languages that will be spoken by presenters at this event. This helps improve language detection accuracy.",
    presenterLanguagesTip: "Tip: If there are speakers who speak different languages, select all of them to optimize translation.",
    selected: "selected",
    close: "Close",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "Translation Room",
    publicRoomBy: "by",
    publicRoomSelectLanguage: "What is your language?",
    publicRoomLanguageHint: "The translation will be displayed in the chosen language",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "Room Unavailable",
    publicRoomBackHome: "Back to Home",
    publicRoomConnecting: "Connecting to room",
    publicRoomHeaderRoom: "Room",
    publicRoomConnected: "Connected",
    publicRoomReconnecting: "Reconnecting...",
    publicRoomChangeLanguage: "Change language",
    publicRoomSettings: "Settings",
    publicRoomReadingSpeed: "Reading speed",
    publicRoomReadingSpeedSlow: "Slow",
    publicRoomReadingSpeedNormal: "Normal",
    publicRoomReadingSpeedFast: "Fast",
    publicRoomReadingSpeedUnit: "ch/s",
    publicRoomInQueue: "in queue",
    publicRoomFontSize: "Font size",
    publicRoomBgColor: "Background color",
    publicRoomTextColor: "Text color",
    publicRoomShowOriginal: "Show original text",
    publicRoomFullscreen: "Fullscreen",
    publicRoomExitFullscreen: "Exit fullscreen",
    publicRoomWaitingTranslation: "Waiting for translation...",
    publicRoomViewers: "viewers",
    publicRoomViewer: "viewer",
    publicRoomWaitingSession: "Waiting for session to start...",
    publicRoomSessionWillStart: "Translation will start automatically when the presenter begins.",
    publicRoomTranslating: "Translating...",
    publicRoomErrorNotFound: "Room not found. Please check the code and try again.",
    publicRoomErrorServer: "Failed to connect to server. Please try again.",
    publicRoomSessionEnded: "The presenter has ended the session",
    publicRoomDeleted: "This room has been permanently deleted.",
    
    // Output mode selection
    publicRoomSelectMode: "How do you want to receive the translation?",
    publicRoomModeHint: "Choose the translation output mode",
    publicRoomTextOnly: "Text Translation",
    publicRoomTextOnlyDesc: "Read the translation on screen",
    publicRoomTextVoice: "Text + Voice Translation",
    publicRoomTextVoiceDesc: "Read and listen to the translation",
    publicRoomHeadphonesRequired: "Headphones required",
    publicRoomHeadphonesOverride: "I have headphones connected but they weren't detected",
    publicRoomHeadphonesNotDetected: "Connect headphones to enable this option",
    publicRoomHeadphonesDetected: "Headphones detected",
    publicRoomCheckingAudio: "Checking audio devices...",
    publicRoomSpeaking: "Speaking...",
    publicRoomVoiceEnabled: "Voice enabled",
    publicRoomChangeVoice: "Translator Voice",
    publicRoomVoiceDisabled: "Voice disabled",
    publicRoomSelectVoice: "Choose a voice",
    publicRoomSelectVoiceHint: "Select the voice for spoken translation",
    publicRoomVoicePreview: "Preview",
    publicRoomNoVoicesAvailable: "No voices available for this language",
    publicRoomVoiceSelected: "Voice selected",
    publicRoomConfirm: "Confirm",
    publicRoomTestVoice: "Test voice",
    publicRoomNoNativeVoices: "Your device doesn't have voices in {language}. Showing available voices.",
    publicRoomInstallVoices: "To get voices in other languages, install language packs in your system settings.",
    publicRoomHowToInstallVoices: "How to Install Voices",
    publicRoomVoiceHelpTitle: "How to Install Voices on Your Device",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. Open Settings (Win + I)\n2. Go to Time & Language → Speech\n3. Click \"Add voices\"\n4. Select desired languages\n5. Restart your browser",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. Open System Preferences\n2. Go to Accessibility → Spoken Content\n3. Click \"System Voice\"\n4. Select \"Customize\"\n5. Download desired voices",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. Open Settings\n2. Go to Accessibility → Text-to-Speech\n3. Tap \"Preferred engine\"\n4. Install additional languages\n5. Restart your browser",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. Open Settings\n2. Go to Accessibility → Spoken Content\n3. Tap \"Voices\"\n4. Select desired language\n5. Download available voices",
    publicRoomVoiceHelpTip: "Tip: Google Chrome usually offers more voices than other browsers.",
    publicRoomVoiceHelpClose: "Close",
    
    translationPreview: "Translation Preview",
    original: "Original",
    translation: "Translation",
    waitingAudio: "Waiting for audio...",
    waitingTranslation: "Waiting for translation...",
    detecting: "Detecting...",
    portuguese: "Portuguese",
    english: "English",
    
    audioDevice: "Audio Device",
    selectAudioSource: "Select audio source",
    audioDeviceDescription: "Choose the microphone or audio card to capture the speaker's audio.",
    
    delayAdjustment: "Delay Adjustment",
    translationDelay: "Translation delay",
    delayDescription: "Adjust the delay between audio capture and translation. Higher values may improve transcription quality.",
    
    audioGate: "Audio Gate (Noise Filter)",
    gateThreshold: "Gate Threshold",
    gateDescription: "The gate filters sounds below the defined threshold (breathing, background noise).",
    recommended: "Recommended value: -30dB to -20dB.",
    sensitive: "sensitive",
    loud: "loud",

    readingSpeed: "Reading speed",
    readingSpeedLabel: "Speed",
    readingSpeedSlow: "Slow",
    readingSpeedNormal: "Normal",
    readingSpeedFast: "Fast",
    readingSpeedUnit: "ch/s",
    readingSpeedDescription: "Controls how long each translation stays on the window. Lower = more reading time; Higher = keeps up with live audio.",

    systemTest: "System test",
    systemTestDescription: "Runs a quick end-to-end test (Whisper + GPT + windows) with a pre-recorded audio. Ideal before a live event.",
    systemTestButton: "Run test",
    systemTestRunning: "Running...",
    systemTestRerun: "Run again",
    systemTestClose: "Close",
    systemTestDialogTitle: "System diagnostics",
    systemTestDialogDescription: "Running the full pipeline with a reference audio.",
    systemTestStepWhisper: "Speech recognition (Whisper)",
    systemTestStepGpt: "Translation (GPT)",
    systemTestStepDisplay: "Window display",
    systemTestTotalTime: "Total time",
    systemTestPassed: "OK",
    systemTestFailed: "Failed",
    systemTestFailedGeneric: "Failed. Check server logs.",
    systemTestFilteredReason: "Filtered by hallucination detector",
    systemTestDisplayOk: "Translations written to windows successfully",
    systemTestDisplayFailed: "Could not write to windows",
    
    overlayMode: "Overlay Mode",
    overlayOtherWindows: "Overlay other windows",
    overlayDescription: "When enabled, the translation window will try to stay visible above other programs.",
    overlayActive: "Overlay Mode Active",
    overlayActiveDescription: "The translation window will open in popup mode and try to maintain focus automatically.",
    
    slideTime: "Translated Slide Time",
    slideDuration: "Slide duration",
    slideDescription: "Sets how long each translation slide stays on screen before automatically advancing.",
    seconds: "seconds",
    second: "second",
    
    translationLines: "Translation Lines",
    maxLinesPerSlide: "Maximum lines per slide",
    linesDescription: "Sets the maximum number of text lines displayed in each translation slide.",
    line: "line",
    lines: "lines",
    
    translationFontSize: "Translation Font Size",
    fontSizeDescription: "Sets the font size of the translated text in the translation window.",
    small: "small",
    large: "large",
    
    headerBox: "Header Box",
    headerText: "Header Text",
    footerBox: "Footer Box",
    footerText: "Footer Text",
    padding: "Padding",
    roundCorners: "Round Corners",
    colors: "Colors",
    text: "Text",
    background: "Background",
    preview: "Preview",
    on: "ON",
    off: "OFF",
    
    recentHistory: "Recent History",
    
    overlayActiveIndicator: "Overlay Active",
    prevSlide: "Previous slide",
    nextSlide: "Next slide",
    goToSlide: "Go to slide",
    exitFullscreen: "Exit fullscreen",
    enterFullscreen: "Fullscreen",
    closeWindow: "Close window",
    disableOverlay: "Disable overlay",
    enableOverlay: "Enable overlay",
    
    gateOpen: "Gate Open - Recording",
    gateClosed: "Gate Closed - Waiting for signal",

    // Auth page
    authSignIn: "Sign In",
    authSignUp: "Sign Up",
    authSignInSubtitle: "Sign in to continue using the translator",
    authSignUpSubtitle: "Create your account to get started",
    authEmail: "Email",
    authPassword: "Password",
    authName: "Name",
    authEmailPlaceholder: "your@email.com",
    authPasswordPlaceholder: "Your password",
    authNamePlaceholder: "Your name",
    authOrContinueWith: "OR CONTINUE WITH",
    authContinueGoogle: "Continue with Google",
    authNoAccount: "Don't have an account?",
    authHasAccount: "Already have an account?",
    authAccessAsGuest: "Access as a guest",
    authBackToHome: "Back to home",
    authDiagnostics: "Having trouble? Click here for diagnostics",
    authWallet: "Wallet",
    authConnectWallet: "Connect Solana Wallet",
    authConnectWalletDesc: "Connect your Phantom wallet to access",
    authPhantomNotFound: "Phantom not found",
    authInstallPhantom: "Install Phantom",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },
  
  es: {
    recordingAutoResumed: "Grabación reanudada automáticamente tras actualizar la página.",
    recordingResumeNeedsClick: "La grabación estaba activa antes de actualizar. Haga clic en Iniciar para reanudar — el navegador exige un clic para capturar el audio del sistema.",
    authForgotPassword: "¿Olvidó su contraseña?",
    authForgotTitle: "Restablecer contraseña",
    authForgotDesc: "Ingrese su correo y le enviaremos un enlace para crear una nueva contraseña",
    authSendResetLink: "Enviar enlace",
    authResetEmailSent: "Si este correo está registrado, recibirá un enlace en breve. Revise también la carpeta de spam.",
    authBackToLogin: "← Volver al inicio de sesión",
    authResetTitle: "Crear nueva contraseña",
    authResetDesc: "Escriba y confirme su nueva contraseña",
    authNewPassword: "Nueva contraseña",
    authConfirmPassword: "Confirmar nueva contraseña",
    authPasswordsMismatch: "Las contraseñas no coinciden.",
    authPasswordTooShort: "La contraseña debe tener al menos 6 caracteres.",
    authResetSuccess: "¡Contraseña restablecida! Redirigiendo al inicio de sesión...",
    authResetInvalidToken: "Enlace inválido o expirado. Solicite un nuevo enlace.",
    authResetButton: "Guardar nueva contraseña",
    authGenericError: "Ocurrió un error. Inténtelo de nuevo.",
    selectLanguage: "Seleccione su idioma.",
    selectLanguageEn: "Select your language.",
    continue: "Continuar",
    
    // Language Pair Selection page
    selectTranslationLanguages: "Seleccione los 2 idiomas para Traducción en Tiempo Real",
    sourceLanguage: "Idioma de Origen",
    targetLanguage: "Idioma de Destino",
    selectTargetLanguage: "Seleccione el idioma de destino",
    startTranslation: "Iniciar Traducción",
    languagePairHint: "La traducción se realizará automáticamente entre estos dos idiomas",
    
    // Home button
    homeButton: "Inicio - Home",
    
    appTitle: "Traductor en Tiempo Real",
    appSubtitle: "Inglés ↔ Portugués de Brasil (Detección automática)",
    controlTab: "Control",
    settingsTab: "Configuración",
    
    audioInput: "Entrada de Audio",
    start: "Iniciar",
    stop: "Detener",
    status: "Estado",
    statusIdle: "Inactivo",
    statusConnecting: "Conectando...",
    statusRecording: "Grabando",
    statusError: "Error",
    clickToStart: "Haga clic en Iniciar para comenzar",
    processingAudio: "Procesando audio en tiempo real...",
    openTranslationWindow: "Abrir Ventana de Traducción",
    openSecondScreen: "Abrir en Segunda Pantalla",
    secondScreenDetected: "Segunda pantalla detectada",
    noSecondScreen: "No se detectó segunda pantalla",
    detect: "Detectar",
    
    translationPreview: "Vista Previa de Traducción",
    original: "Original",
    translation: "Traducción",
    waitingAudio: "Esperando audio...",
    waitingTranslation: "Esperando traducción...",
    detecting: "Detectando...",
    portuguese: "Portugués",
    english: "Inglés",
    
    audioDevice: "Dispositivo de Audio",
    selectAudioSource: "Seleccione la fuente de audio",
    audioDeviceDescription: "Elija el micrófono o tarjeta de audio para capturar el audio del orador.",
    
    delayAdjustment: "Ajuste de Retardo",
    translationDelay: "Retardo de traducción",
    delayDescription: "Ajuste el retardo entre la captura de audio y la traducción.",
    
    audioGate: "Puerta de Audio (Filtro de Ruido)",
    gateThreshold: "Umbral de Puerta",
    gateDescription: "La puerta filtra sonidos por debajo del umbral definido.",
    recommended: "Valor recomendado: -30dB a -20dB.",
    sensitive: "sensible",
    loud: "alto",

    readingSpeed: "Velocidad de lectura",
    readingSpeedLabel: "Velocidad",
    readingSpeedSlow: "Lento",
    readingSpeedNormal: "Normal",
    readingSpeedFast: "Rápido",
    readingSpeedUnit: "car/s",
    readingSpeedDescription: "Controla cuánto tiempo permanece cada traducción en la ventana. Menor = más tiempo para leer; Mayor = sigue mejor el audio en vivo.",
    
    overlayMode: "Modo Superposición",
    overlayOtherWindows: "Superponer otras ventanas",
    overlayDescription: "Cuando está activado, la ventana de traducción intentará permanecer visible.",
    overlayActive: "Modo Superposición Activo",
    overlayActiveDescription: "La ventana de traducción se abrirá en modo popup.",
    
    slideTime: "Tiempo del Slide Traducido",
    slideDuration: "Duración del slide",
    slideDescription: "Define cuánto tiempo permanece cada slide en pantalla.",
    seconds: "segundos",
    second: "segundo",
    
    translationLines: "Líneas de Traducción",
    maxLinesPerSlide: "Máximo de líneas por slide",
    linesDescription: "Define el número máximo de líneas de texto por slide.",
    line: "línea",
    lines: "líneas",
    
    translationFontSize: "Tamaño de Fuente de Traducción",
    fontSize: "Tamaño de fuente",
    fontSizeDescription: "Define el tamaño de fuente del texto traducido.",
    small: "pequeño",
    large: "grande",
    
    headerBox: "Caja de Encabezado",
    headerText: "Texto de Encabezado",
    footerBox: "Caja de Pie de Página",
    footerText: "Texto de Pie de Página",
    padding: "Relleno",
    roundCorners: "Esquinas Redondeadas",
    colors: "Colores",
    text: "Texto",
    background: "Fondo",
    preview: "Vista Previa",
    on: "ON",
    off: "OFF",
    
    recentHistory: "Historial Reciente",
    
    overlayActiveIndicator: "Superposición Activa",
    prevSlide: "Slide anterior",
    nextSlide: "Siguiente slide",
    goToSlide: "Ir al slide",
    exitFullscreen: "Salir de pantalla completa",
    enterFullscreen: "Pantalla completa",
    closeWindow: "Cerrar ventana",
    disableOverlay: "Desactivar superposición",
    enableOverlay: "Activar superposición",
    
    gateOpen: "Puerta Abierta - Grabando",
    gateClosed: "Puerta Cerrada - Esperando señal",

    // Header / Navigation
    plans: "Planes",
    account: "Cuenta",
    logout: "Salir",
    signUp: "Registrarse",
    guest: "Invitado",
    free: "Free",
    
    // Footer
    footerCopyright: "Desarrollado por João Vitor Fernandes Farias. Todos los derechos reservados.",
    backToDashboard: "Volver al Dashboard",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "Use traducciones como subtítulos en sus transmisiones en vivo en OBS, Streamlabs y otros software de streaming.",
    obsProOnlyText: "Esta funcionalidad está disponible solo en el Plan PRO",
    obsCustomizeLabel: "Personalizar",
    obsPositionLabel: "Posición",
    obsTextShadowLabel: "Sombra de Texto",
    obsTextShadowDesc: "Mejora la legibilidad sobre videos",
    obsGenerateUrl: "Generar URL para OBS",
    obsGeneratedUrlLabel: "URL Generada para OBS:",
    obsCopied: "¡URL copiada!",
    obsPreviewBtn: "Vista Previa",
    obsParamsReference: "Parámetros opcionales de URL (referencia)",
    obsParamBg: "Color de fondo",
    obsParamFontSize: "Tamaño de fuente (px)",
    obsParamColor: "Color del texto (hex sin #)",
    obsParamPosition: "Posición",
    obsParamShadow: "Sombra de texto",
    obsSettingsPlaceholder: "Configuraciones de personalización...",
    
    // Audio section
    audioSource: "Fuente de Audio",
    microphone: "Micrófono",
    system: "Sistema",
    both: "Ambos",
    
    // Second Window
    secondTranslationWindow: "Segunda Ventana de Traducción",
    enableSecondWindow: "Habilitar segunda ventana",
    optional: "Opcional",
    openSecondWindowFull: "Abrir Segunda Ventana",
    splitScreenButton: "Habilitar segunda ventana (50% a 50%)",
    splitScreenSuccess: "Ventanas abiertas lado a lado en la segunda pantalla (50/50)",
    splitScreenNoScreen: "Segunda pantalla no detectada",
    splitScreenPermission: "Para posicionar las ventanas en la segunda pantalla, permite el acceso de 'Gestión de ventanas' cuando el navegador lo solicite (o en Configuración del sitio) y haz clic en el botón nuevamente.",
    splitScreenPopupBlocked: "El navegador bloqueó la apertura de las ventanas. Permite ventanas emergentes para este sitio y haz clic nuevamente.",
    splitScreenBraveShields: "El navegador está enmascarando las dimensiones de las pantallas (protección anti-fingerprint). En Brave: haz clic en el icono del león en la barra de direcciones → Controles avanzados → 'Bloquear huellas digitales' → Desactivado para este sitio. Recarga e intenta de nuevo.",
    secondWindowProOnly: "Esta funcionalidad está disponible solo en el Plan PRO",
    upgradeProSecondWindow: "Muestre traducciones en un tercer idioma simultáneamente. Ideal para eventos con público multilingüe.",
    upgradePro: "Upgrade PRO",
    
    // Pricing Page
    pricingTitle: "Elige tu Plan",
    pricingSubtitle: "Comienza gratis o desbloquea traducción ilimitada con el Plan PRO",
    planFree: "Plan Free",
    planPro: "Plan PRO",
    currentPlan: "Plan Actual",
    perfectToTry: "Perfecto para probar",
    forProfessionalUse: "Para uso profesional",
    freePrice: "Gratis",
    perMonth: "/mes",
    feature10Minutes: "10 minutos de traducción por mes",
    featureBidirectional: "Traducción bidireccional",
    feature20Languages: "20 idiomas soportados",
    featureUnlimited: "Traducción ILIMITADA",
    feature2Screens: "Traducción a 2 idiomas en pantallas separadas",
    featureOBS: "Integración con OBS para streaming",
    featureQRCode: "Traducción directa en el teléfono del visitante vía QR Code",
    startFree: "Comenzar Gratis",
    alreadyPro: "¡Ya eres PRO!",
    creditCard: "Tarjeta",
    payWithCard: "Pagar con Tarjeta",
    loginToPay: "Iniciar Sesión para Pagar",
    verifyPayment: "Verificar Pago",
    amount: "Monto",
    noConversionNeeded: "Envía exactamente el monto en",
    solanaNetwork: "Red Solana",
    sendTo: "Enviar a",
    tokenOnSolana: "en la red Solana",
    txSignatureLabel: "Firma de la Transacción (después de enviar)",
    txSignaturePlaceholder: "Pega la firma de la transacción aquí",
    viewOnSolscan: "Ver transacción en Solscan",
    addressCopied: "¡Dirección copiada!",
    errorRedirectPayment: "Error al redirigir al pago",
    errorEnterTxSignature: "Por favor, ingresa la firma de la transacción",
    errorVerifyTx: "Error al verificar la transacción",
    
    // OBS Integration
    obsIntegration: "Integración con OBS",
    streaming: "Streaming",
    obsDescription: "Use la traducción como subtítulos en sus transmisiones en vivo. Agregue como \"Browser Source\" en OBS.",
    customizeLegend: "Personalizar Subtítulos",
    backgroundColor: "Color de Fondo",
    transparent: "Transparente",
    green: "Verde",
    blue: "Azul",
    magenta: "Magenta",
    black: "Negro",
    textColor: "Color del Texto",
    customize: "Personalizar",
    position: "Posición",
    top: "Arriba",
    center: "Centro",
    bottom: "Abajo",
    textShadow: "Sombra de Texto",
    textShadowDescription: "Mejora la legibilidad sobre videos",
    generateObsUrl: "Generar URL para OBS",
    optionalUrlParams: "Parámetros opcionales de URL (referencia)",
    obsStepByStep: "Paso a paso OBS",
    obsProOnly: "Esta funcionalidad está disponible solo en el Plan PRO",
    
    // Translation Rooms
    translationRooms: "Salas de Traducción",
    events: "Eventos",
    createRoom: "Crear Sala de Traducción",
    roomDescription: "Cree una sala para que personas en eventos, iglesias o conferencias accedan a la traducción en sus dispositivos vía QR Code o link.",
    roomProOnly: "Las Salas de Traducción son exclusivas para usuarios PRO",
    upgradeToProRooms: "Cree una sala y comparta un QR Code/link para que visitantes vean la traducción en sus dispositivos.",
    
    // Permanent Links
    permanentLinks: "Links Fijos",
    permanent: "Permanente",
    createPermanentLink: "Crear Link Fijo",
    permanentLinkDescription: "Cree links permanentes para iglesias, conferencias y eventos recurrentes. ¡Imprima el QR Code una vez y úselo siempre!",
    roomName: "Nombre de la Sala",
    customCode: "Código Personalizado",
    customCodeOptional: "opcional",
    leaveEmptyToGenerate: "Deje vacío para generar automáticamente",
    linkPreview: "Vista previa del link",
    noPermanentLinksYet: "Ningún enlace fijo creado todavía. Crea un enlace permanente para eventos recurrentes.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "Código QR - Enlace Fijo",
    permanentLinkLabel: "Enlace permanente:",
    qrNeverChanges: "¡Este código QR y enlace nunca cambian! Puedes imprimirlo y usarlo siempre.",
    copyLink: "Copiar Enlace",
    openLink: "Abrir",
    
    // QR Code Modal - Translation Room  
    shareRoom: "Compartir Sala",
    roomCode: "Código de la sala:",
    shareLink: "Enlace para compartir:",
    visitorsCanScan: "Los visitantes pueden escanear el código QR o acceder al enlace para ver la traducción en vivo",
    endRoomConfirm: "¿Estás seguro de que quieres cerrar la sala? Todos los visitantes serán desconectados.",
    share: "Compartir",
    
    // Room Config
    roomConfig: "Configuración de la Sala",
    presenterLanguages: "Idiomas de los Presentadores",
    presenterLanguagesDescription: "Seleccione todos los idiomas que serán hablados por los presentadores en este evento.",
    presenterLanguagesTip: "Consejo: Si hay oradores que hablan diferentes idiomas, seleccione todos para optimizar la traducción.",
    selected: "seleccionado",
    close: "Cerrar",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "Sala de Traducción",
    publicRoomBy: "por",
    publicRoomSelectLanguage: "¿Cuál es tu idioma?",
    publicRoomLanguageHint: "La traducción se mostrará en el idioma elegido",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "Sala No Disponible",
    publicRoomBackHome: "Volver al Inicio",
    publicRoomConnecting: "Conectando a la sala",
    publicRoomHeaderRoom: "Sala",
    publicRoomConnected: "Conectado",
    publicRoomReconnecting: "Reconectando...",
    publicRoomChangeLanguage: "Cambiar idioma",
    publicRoomSettings: "Configuraciones",
    publicRoomReadingSpeed: "Velocidad de lectura",
    publicRoomReadingSpeedSlow: "Lento",
    publicRoomReadingSpeedNormal: "Normal",
    publicRoomReadingSpeedFast: "Rápido",
    publicRoomReadingSpeedUnit: "car/s",
    publicRoomInQueue: "en cola",
    publicRoomFontSize: "Tamaño de fuente",
    publicRoomBgColor: "Color de fondo",
    publicRoomTextColor: "Color del texto",
    publicRoomShowOriginal: "Mostrar texto original",
    publicRoomFullscreen: "Pantalla completa",
    publicRoomExitFullscreen: "Salir de pantalla completa",
    publicRoomWaitingTranslation: "Esperando traducción...",
    publicRoomViewers: "espectadores",
    publicRoomViewer: "espectador",
    publicRoomWaitingSession: "Esperando inicio de la sesión...",
    publicRoomSessionWillStart: "La traducción comenzará automáticamente cuando el presentador inicie.",
    publicRoomTranslating: "Traduciendo...",
    publicRoomErrorNotFound: "Sala no encontrada. Verifica el código e intenta de nuevo.",
    publicRoomErrorServer: "Error al conectar con el servidor. Intenta de nuevo.",
    publicRoomSessionEnded: "El presentador ha terminado la sesión",
    publicRoomDeleted: "Esta sala ha sido eliminada permanentemente.",
    
    // Output mode selection
    publicRoomSelectMode: "¿Cómo desea recibir la traducción?",
    publicRoomModeHint: "Elija el modo de salida de la traducción",
    publicRoomTextOnly: "Traducción en Texto",
    publicRoomTextOnlyDesc: "Lea la traducción en pantalla",
    publicRoomTextVoice: "Traducción en Texto + Voz",
    publicRoomTextVoiceDesc: "Lea y escuche la traducción",
    publicRoomHeadphonesRequired: "Requiere auriculares",
    publicRoomHeadphonesOverride: "Tengo auriculares conectados pero no fueron detectados",
    publicRoomHeadphonesNotDetected: "Conecte auriculares para habilitar esta opción",
    publicRoomHeadphonesDetected: "Auriculares detectados",
    publicRoomCheckingAudio: "Verificando dispositivos de audio...",
    publicRoomSpeaking: "Hablando...",
    publicRoomVoiceEnabled: "Voz activada",
    publicRoomChangeVoice: "Voz del Traductor",
    publicRoomVoiceDisabled: "Voz desactivada",
    publicRoomSelectVoice: "Elige una voz",
    publicRoomSelectVoiceHint: "Selecciona la voz para la traducción hablada",
    publicRoomVoicePreview: "Vista previa",
    publicRoomNoVoicesAvailable: "No hay voces disponibles para este idioma",
    publicRoomVoiceSelected: "Voz seleccionada",
    publicRoomConfirm: "Confirmar",
    publicRoomTestVoice: "Probar voz",
    publicRoomNoNativeVoices: "Tu dispositivo no tiene voces en {language}. Mostrando voces disponibles.",
    publicRoomInstallVoices: "Para obtener voces en otros idiomas, instala paquetes de idiomas en la configuración del sistema.",
    publicRoomHowToInstallVoices: "Cómo Instalar Voces",
    publicRoomVoiceHelpTitle: "Cómo Instalar Voces en Tu Dispositivo",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. Abre Configuración (Win + I)\n2. Ve a Hora e idioma → Voz\n3. Haz clic en \"Agregar voces\"\n4. Selecciona los idiomas deseados\n5. Reinicia el navegador",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. Abre Preferencias del Sistema\n2. Ve a Accesibilidad → Contenido hablado\n3. Haz clic en \"Voz del sistema\"\n4. Selecciona \"Personalizar\"\n5. Descarga las voces deseadas",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. Abre Configuración\n2. Ve a Accesibilidad → Texto a voz\n3. Toca \"Motor preferido\"\n4. Instala idiomas adicionales\n5. Reinicia el navegador",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. Abre Ajustes\n2. Ve a Accesibilidad → Contenido hablado\n3. Toca \"Voces\"\n4. Selecciona el idioma deseado\n5. Descarga las voces disponibles",
    publicRoomVoiceHelpTip: "Consejo: Google Chrome generalmente ofrece más voces que otros navegadores.",
    publicRoomVoiceHelpClose: "Cerrar",
    
    // Auth page
    authSignIn: "Iniciar Sesión",
    authSignUp: "Crear Cuenta",
    authSignInSubtitle: "Inicie sesión para continuar usando el traductor",
    authSignUpSubtitle: "Cree su cuenta para comenzar",
    authEmail: "Correo",
    authPassword: "Contraseña",
    authName: "Nombre",
    authEmailPlaceholder: "su@correo.com",
    authPasswordPlaceholder: "Su contraseña",
    authNamePlaceholder: "Su nombre",
    authOrContinueWith: "O CONTINÚE CON",
    authContinueGoogle: "Continuar con Google",
    authNoAccount: "¿No tiene cuenta?",
    authHasAccount: "¿Ya tiene cuenta?",
    authAccessAsGuest: "Acceder como invitado",
    authBackToHome: "Volver al inicio",
    authDiagnostics: "¿Problemas para acceder? Haga clic aquí para diagnóstico",
    authWallet: "Cartera",
    authConnectWallet: "Conectar Cartera Solana",
    authConnectWalletDesc: "Conecte su cartera Phantom para acceder",
    authPhantomNotFound: "Phantom no encontrado",
    authInstallPhantom: "Instalar Phantom",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },
  
  fr: {
    recordingAutoResumed: "Enregistrement repris automatiquement après le rechargement.",
    recordingResumeNeedsClick: "L'enregistrement était actif avant le rechargement. Cliquez sur Démarrer pour reprendre — le navigateur exige un clic pour capturer l'audio du système.",
    authForgotPassword: "Mot de passe oublié ?",
    authForgotTitle: "Réinitialiser le mot de passe",
    authForgotDesc: "Saisissez votre e-mail et nous vous enverrons un lien pour créer un nouveau mot de passe",
    authSendResetLink: "Envoyer le lien",
    authResetEmailSent: "Si cet e-mail est enregistré, vous recevrez un lien sous peu. Vérifiez aussi vos spams.",
    authBackToLogin: "← Retour à la connexion",
    authResetTitle: "Créer un nouveau mot de passe",
    authResetDesc: "Saisissez et confirmez votre nouveau mot de passe",
    authNewPassword: "Nouveau mot de passe",
    authConfirmPassword: "Confirmer le mot de passe",
    authPasswordsMismatch: "Les mots de passe ne correspondent pas.",
    authPasswordTooShort: "Le mot de passe doit contenir au moins 6 caractères.",
    authResetSuccess: "Mot de passe réinitialisé ! Redirection vers la connexion...",
    authResetInvalidToken: "Lien invalide ou expiré. Demandez un nouveau lien.",
    authResetButton: "Enregistrer",
    authGenericError: "Une erreur est survenue. Veuillez réessayer.",
    selectLanguage: "Sélectionnez votre langue.",
    selectLanguageEn: "Select your language.",
    continue: "Continuer",
    
    // Language Pair Selection page
    selectTranslationLanguages: "Sélectionnez les 2 langues pour la Traduction en Temps Réel",
    sourceLanguage: "Langue Source",
    targetLanguage: "Langue Cible",
    selectTargetLanguage: "Sélectionnez la langue cible",
    startTranslation: "Démarrer la Traduction",
    languagePairHint: "La traduction sera effectuée automatiquement entre ces deux langues",
    
    // Home button
    homeButton: "Accueil",
    
    appTitle: "Traducteur en Temps Réel",
    appSubtitle: "Anglais ↔ Portugais Brésilien (Détection automatique)",
    controlTab: "Contrôle",
    settingsTab: "Paramètres",
    
    audioInput: "Entrée Audio",
    start: "Démarrer",
    stop: "Arrêter",
    status: "Statut",
    statusIdle: "Inactif",
    statusConnecting: "Connexion...",
    statusRecording: "Enregistrement",
    statusError: "Erreur",
    clickToStart: "Cliquez sur Démarrer pour commencer",
    processingAudio: "Traitement audio en temps réel...",
    openTranslationWindow: "Ouvrir la Fenêtre de Traduction",
    openSecondScreen: "Ouvrir sur le Deuxième Écran",
    secondScreenDetected: "Deuxième écran détecté",
    noSecondScreen: "Aucun deuxième écran détecté",
    detect: "Détecter",
    
    translationPreview: "Aperçu de la Traduction",
    original: "Original",
    translation: "Traduction",
    waitingAudio: "En attente d'audio...",
    waitingTranslation: "En attente de traduction...",
    detecting: "Détection...",
    portuguese: "Portugais",
    english: "Anglais",
    
    audioDevice: "Périphérique Audio",
    selectAudioSource: "Sélectionnez la source audio",
    audioDeviceDescription: "Choisissez le microphone ou la carte audio pour capturer l'audio.",
    
    delayAdjustment: "Ajustement du Délai",
    translationDelay: "Délai de traduction",
    delayDescription: "Ajustez le délai entre la capture audio et la traduction.",
    
    audioGate: "Porte Audio (Filtre de Bruit)",
    gateThreshold: "Seuil de Porte",
    gateDescription: "La porte filtre les sons en dessous du seuil défini.",
    recommended: "Valeur recommandée: -30dB à -20dB.",
    sensitive: "sensible",
    loud: "fort",

    readingSpeed: "Vitesse de lecture",
    readingSpeedLabel: "Vitesse",
    readingSpeedSlow: "Lent",
    readingSpeedNormal: "Normal",
    readingSpeedFast: "Rapide",
    readingSpeedUnit: "car/s",
    readingSpeedDescription: "Contrôle la durée d'affichage de chaque traduction. Plus bas = plus de temps de lecture; Plus haut = suit mieux l'audio en direct.",
    
    overlayMode: "Mode Superposition",
    overlayOtherWindows: "Superposer les autres fenêtres",
    overlayDescription: "Lorsque activé, la fenêtre de traduction restera visible.",
    overlayActive: "Mode Superposition Actif",
    overlayActiveDescription: "La fenêtre de traduction s'ouvrira en mode popup.",
    
    slideTime: "Temps de Diapositive Traduite",
    slideDuration: "Durée de diapositive",
    slideDescription: "Définit combien de temps chaque diapositive reste à l'écran.",
    seconds: "secondes",
    second: "seconde",
    
    translationLines: "Lignes de Traduction",
    maxLinesPerSlide: "Maximum de lignes par diapositive",
    linesDescription: "Définit le nombre maximum de lignes par diapositive.",
    line: "ligne",
    lines: "lignes",
    
    translationFontSize: "Taille de Police de Traduction",
    fontSize: "Taille de police",
    fontSizeDescription: "Définit la taille de police du texte traduit.",
    small: "petit",
    large: "grand",
    
    headerBox: "Boîte d'En-tête",
    headerText: "Texte d'En-tête",
    footerBox: "Boîte de Pied de Page",
    footerText: "Texte de Pied de Page",
    padding: "Marge",
    roundCorners: "Coins Arrondis",
    colors: "Couleurs",
    text: "Texte",
    background: "Fond",
    preview: "Aperçu",
    on: "ON",
    off: "OFF",
    
    recentHistory: "Historique Récent",
    
    overlayActiveIndicator: "Superposition Active",
    prevSlide: "Diapositive précédente",
    nextSlide: "Diapositive suivante",
    goToSlide: "Aller à la diapositive",
    exitFullscreen: "Quitter le plein écran",
    enterFullscreen: "Plein écran",
    closeWindow: "Fermer la fenêtre",
    disableOverlay: "Désactiver la superposition",
    enableOverlay: "Activer la superposition",
    
    gateOpen: "Porte Ouverte - Enregistrement",
    gateClosed: "Porte Fermée - En attente de signal",

    // Header / Navigation
    plans: "Plans",
    account: "Compte",
    logout: "Déconnexion",
    signUp: "S'inscrire",
    guest: "Invité",
    free: "Free",
    
    // Footer
    footerCopyright: "Développé par João Vitor Fernandes Farias. Tous droits réservés.",
    backToDashboard: "Retour au Dashboard",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "Utilisez les traductions comme sous-titres dans vos diffusions en direct sur OBS, Streamlabs et autres logiciels de streaming.",
    obsProOnlyText: "Cette fonctionnalité est disponible uniquement dans le Plan PRO",
    obsCustomizeLabel: "Personnaliser",
    obsPositionLabel: "Position",
    obsTextShadowLabel: "Ombre du Texte",
    obsTextShadowDesc: "Améliore la lisibilité sur les vidéos",
    obsGenerateUrl: "Générer l'URL pour OBS",
    obsGeneratedUrlLabel: "URL Générée pour OBS:",
    obsCopied: "URL copiée!",
    obsPreviewBtn: "Aperçu",
    obsParamsReference: "Paramètres URL optionnels (référence)",
    obsParamBg: "Couleur de fond",
    obsParamFontSize: "Taille de police (px)",
    obsParamColor: "Couleur du texte (hex sans #)",
    obsParamPosition: "Position",
    obsParamShadow: "Ombre du texte",
    obsSettingsPlaceholder: "Paramètres de personnalisation...",
    
    // Audio section
    audioSource: "Source Audio",
    microphone: "Microphone",
    system: "Système",
    both: "Les deux",
    
    // Second Window
    secondTranslationWindow: "Deuxième Fenêtre de Traduction",
    enableSecondWindow: "Activer la deuxième fenêtre",
    optional: "Optionnel",
    openSecondWindowFull: "Ouvrir la Deuxième Fenêtre",
    splitScreenButton: "Activer la deuxième fenêtre (50/50)",
    splitScreenSuccess: "Fenêtres ouvertes côte à côte sur le deuxième écran (50/50)",
    splitScreenNoScreen: "Deuxième écran non détecté",
    splitScreenPermission: "Pour positionner les fenêtres sur le deuxième écran, autorisez l'accès 'Gestion des fenêtres' lorsque le navigateur le demande (ou dans les Paramètres du site) et cliquez à nouveau sur le bouton.",
    splitScreenPopupBlocked: "Le navigateur a bloqué l'ouverture des fenêtres. Autorisez les pop-ups pour ce site et cliquez à nouveau.",
    splitScreenBraveShields: "Le navigateur masque les dimensions des écrans (protection anti-empreinte). Dans Brave : cliquez sur l'icône du lion dans la barre d'adresse → Contrôles avancés → 'Bloquer les empreintes numériques' → Désactivé pour ce site. Rechargez et réessayez.",
    secondWindowProOnly: "Cette fonctionnalité est disponible uniquement dans le Plan PRO",
    upgradeProSecondWindow: "Affichez des traductions dans une troisième langue simultanément. Idéal pour les événements multilingues.",
    upgradePro: "Upgrade PRO",
    
    // Pricing Page
    pricingTitle: "Choisissez votre Plan",
    pricingSubtitle: "Commencez gratuitement ou débloquez la traduction illimitée avec le Plan PRO",
    planFree: "Plan Gratuit",
    planPro: "Plan PRO",
    currentPlan: "Plan Actuel",
    perfectToTry: "Parfait pour essayer",
    forProfessionalUse: "Pour usage professionnel",
    freePrice: "Gratuit",
    perMonth: "/mois",
    feature10Minutes: "10 minutes de traduction par mois",
    featureBidirectional: "Traduction bidirectionnelle",
    feature20Languages: "20 langues supportées",
    featureUnlimited: "Traduction ILLIMITÉE",
    feature2Screens: "Traduction vers 2 langues sur écrans séparés",
    featureOBS: "Intégration OBS pour le streaming",
    featureQRCode: "Traduction directe sur le téléphone du visiteur via QR Code",
    startFree: "Commencer Gratuitement",
    alreadyPro: "Vous êtes déjà PRO!",
    creditCard: "Carte",
    payWithCard: "Payer par Carte",
    loginToPay: "Se Connecter pour Payer",
    verifyPayment: "Vérifier le Paiement",
    amount: "Montant",
    noConversionNeeded: "Envoyez exactement le montant en",
    solanaNetwork: "Réseau Solana",
    sendTo: "Envoyer à",
    tokenOnSolana: "sur le réseau Solana",
    txSignatureLabel: "Signature de la Transaction (après envoi)",
    txSignaturePlaceholder: "Collez la signature de la transaction ici",
    viewOnSolscan: "Voir la transaction sur Solscan",
    addressCopied: "Adresse copiée!",
    errorRedirectPayment: "Erreur lors de la redirection vers le paiement",
    errorEnterTxSignature: "Veuillez entrer la signature de la transaction",
    errorVerifyTx: "Erreur lors de la vérification de la transaction",
    
    // OBS Integration
    obsIntegration: "Intégration OBS",
    streaming: "Streaming",
    obsDescription: "Utilisez la traduction comme sous-titres dans vos diffusions en direct. Ajoutez comme \"Browser Source\" dans OBS.",
    customizeLegend: "Personnaliser les Sous-titres",
    backgroundColor: "Couleur de Fond",
    transparent: "Transparent",
    green: "Vert",
    blue: "Bleu",
    magenta: "Magenta",
    black: "Noir",
    textColor: "Couleur du Texte",
    customize: "Personnaliser",
    position: "Position",
    top: "Haut",
    center: "Centre",
    bottom: "Bas",
    textShadow: "Ombre du Texte",
    textShadowDescription: "Améliore la lisibilité sur les vidéos",
    generateObsUrl: "Générer l'URL pour OBS",
    optionalUrlParams: "Paramètres URL optionnels (référence)",
    obsStepByStep: "OBS étape par étape",
    obsProOnly: "Cette fonctionnalité est disponible uniquement dans le Plan PRO",
    
    // Translation Rooms
    translationRooms: "Salles de Traduction",
    events: "Événements",
    createRoom: "Créer une Salle de Traduction",
    roomDescription: "Créez une salle pour que les personnes lors d'événements, églises ou conférences accèdent à la traduction sur leurs appareils via QR Code ou lien.",
    roomProOnly: "Les Salles de Traduction sont exclusives aux utilisateurs PRO",
    upgradeToProRooms: "Créez une salle et partagez un QR Code/lien pour que les visiteurs voient la traduction sur leurs appareils.",
    
    // Permanent Links
    permanentLinks: "Liens Fixes",
    permanent: "Permanent",
    createPermanentLink: "Créer un Lien Fixe",
    permanentLinkDescription: "Créez des liens permanents pour les églises, conférences et événements récurrents. Imprimez le QR Code une fois et utilisez-le toujours!",
    roomName: "Nom de la Salle",
    customCode: "Code Personnalisé",
    customCodeOptional: "optionnel",
    leaveEmptyToGenerate: "Laissez vide pour générer automatiquement",
    linkPreview: "Aperçu du lien",
    noPermanentLinksYet: "Aucun lien permanent créé. Créez un lien permanent pour les événements récurrents.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR Code - Lien Permanent",
    permanentLinkLabel: "Lien permanent:",
    qrNeverChanges: "Ce QR Code et ce lien ne changent jamais! Vous pouvez l'imprimer et l'utiliser pour toujours.",
    copyLink: "Copier le Lien",
    openLink: "Ouvrir",
    
    // QR Code Modal - Translation Room  
    shareRoom: "Partager la Salle",
    roomCode: "Code de la salle:",
    shareLink: "Lien de partage:",
    visitorsCanScan: "Les visiteurs peuvent scanner le QR Code ou accéder au lien pour voir la traduction en direct",
    endRoomConfirm: "Êtes-vous sûr de vouloir fermer la salle? Tous les visiteurs seront déconnectés.",
    share: "Partager",
    
    // Room Config
    roomConfig: "Configuration de la Salle",
    presenterLanguages: "Langues des Présentateurs",
    presenterLanguagesDescription: "Sélectionnez toutes les langues qui seront parlées par les présentateurs lors de cet événement.",
    presenterLanguagesTip: "Conseil: S'il y a des orateurs qui parlent différentes langues, sélectionnez-les tous pour optimiser la traduction.",
    selected: "sélectionné",
    close: "Fermer",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "Salle de Traduction",
    publicRoomBy: "par",
    publicRoomSelectLanguage: "Quelle est votre langue?",
    publicRoomLanguageHint: "La traduction sera affichée dans la langue choisie",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "Salle Indisponible",
    publicRoomBackHome: "Retour à l'Accueil",
    publicRoomConnecting: "Connexion à la salle",
    publicRoomHeaderRoom: "Salle",
    publicRoomConnected: "Connecté",
    publicRoomReconnecting: "Reconnexion...",
    publicRoomChangeLanguage: "Changer de langue",
    publicRoomSettings: "Paramètres",
    publicRoomReadingSpeed: "Vitesse de lecture",
    publicRoomReadingSpeedSlow: "Lent",
    publicRoomReadingSpeedNormal: "Normal",
    publicRoomReadingSpeedFast: "Rapide",
    publicRoomReadingSpeedUnit: "car/s",
    publicRoomInQueue: "en attente",
    publicRoomFontSize: "Taille de police",
    publicRoomBgColor: "Couleur de fond",
    publicRoomTextColor: "Couleur du texte",
    publicRoomShowOriginal: "Afficher le texte original",
    publicRoomFullscreen: "Plein écran",
    publicRoomExitFullscreen: "Quitter le plein écran",
    publicRoomWaitingTranslation: "En attente de traduction...",
    publicRoomViewers: "spectateurs",
    publicRoomViewer: "spectateur",
    publicRoomWaitingSession: "En attente du début de la session...",
    publicRoomSessionWillStart: "La traduction commencera automatiquement lorsque le présentateur démarrera.",
    publicRoomTranslating: "Traduction en cours...",
    publicRoomErrorNotFound: "Salle introuvable. Veuillez vérifier le code et réessayer.",
    publicRoomErrorServer: "Erreur de connexion au serveur. Veuillez réessayer.",
    publicRoomSessionEnded: "Le présentateur a terminé la session",
    publicRoomDeleted: "Cette salle a été définitivement supprimée.",
    
    // Output mode selection
    publicRoomSelectMode: "Comment souhaitez-vous recevoir la traduction?",
    publicRoomModeHint: "Choisissez le mode de sortie de la traduction",
    publicRoomTextOnly: "Traduction Texte",
    publicRoomTextOnlyDesc: "Lisez la traduction à l'écran",
    publicRoomTextVoice: "Traduction Texte + Voix",
    publicRoomTextVoiceDesc: "Lisez et écoutez la traduction",
    publicRoomHeadphonesRequired: "Écouteurs requis",
    publicRoomHeadphonesOverride: "J'ai des écouteurs connectés mais ils n'ont pas été détectés",
    publicRoomHeadphonesNotDetected: "Connectez des écouteurs pour activer cette option",
    publicRoomHeadphonesDetected: "Écouteurs détectés",
    publicRoomCheckingAudio: "Vérification des appareils audio...",
    publicRoomSpeaking: "Parle...",
    publicRoomVoiceEnabled: "Voix activée",
    publicRoomChangeVoice: "Voix du Traducteur",
    publicRoomVoiceDisabled: "Voix désactivée",
    publicRoomSelectVoice: "Choisissez une voix",
    publicRoomSelectVoiceHint: "Sélectionnez la voix pour la traduction parlée",
    publicRoomVoicePreview: "Aperçu",
    publicRoomNoVoicesAvailable: "Aucune voix disponible pour cette langue",
    publicRoomVoiceSelected: "Voix sélectionnée",
    publicRoomConfirm: "Confirmer",
    publicRoomTestVoice: "Tester la voix",
    publicRoomNoNativeVoices: "Votre appareil n'a pas de voix en {language}. Affichage des voix disponibles.",
    publicRoomInstallVoices: "Pour obtenir des voix dans d'autres langues, installez des packs de langues dans les paramètres système.",
    publicRoomHowToInstallVoices: "Comment Installer des Voix",
    publicRoomVoiceHelpTitle: "Comment Installer des Voix sur Votre Appareil",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. Ouvrez Paramètres (Win + I)\n2. Allez dans Heure et langue → Voix\n3. Cliquez sur \"Ajouter des voix\"\n4. Sélectionnez les langues souhaitées\n5. Redémarrez le navigateur",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. Ouvrez Préférences Système\n2. Allez dans Accessibilité → Contenu parlé\n3. Cliquez sur \"Voix système\"\n4. Sélectionnez \"Personnaliser\"\n5. Téléchargez les voix souhaitées",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. Ouvrez Paramètres\n2. Allez dans Accessibilité → Synthèse vocale\n3. Appuyez sur \"Moteur préféré\"\n4. Installez des langues supplémentaires\n5. Redémarrez le navigateur",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. Ouvrez Réglages\n2. Allez dans Accessibilité → Contenu parlé\n3. Appuyez sur \"Voix\"\n4. Sélectionnez la langue souhaitée\n5. Téléchargez les voix disponibles",
    publicRoomVoiceHelpTip: "Conseil: Google Chrome offre généralement plus de voix que les autres navigateurs.",
    publicRoomVoiceHelpClose: "Fermer",
    
    // Auth page
    authSignIn: "Connexion",
    authSignUp: "Créer un Compte",
    authSignInSubtitle: "Connectez-vous pour continuer à utiliser le traducteur",
    authSignUpSubtitle: "Créez votre compte pour commencer",
    authEmail: "Email",
    authPassword: "Mot de passe",
    authName: "Nom",
    authEmailPlaceholder: "votre@email.com",
    authPasswordPlaceholder: "Votre mot de passe",
    authNamePlaceholder: "Votre nom",
    authOrContinueWith: "OU CONTINUEZ AVEC",
    authContinueGoogle: "Continuer avec Google",
    authNoAccount: "Pas de compte?",
    authHasAccount: "Déjà un compte?",
    authAccessAsGuest: "Accéder en tant qu'invité",
    authBackToHome: "Retour à l'accueil",
    authDiagnostics: "Des problèmes d'accès? Cliquez ici pour le diagnostic",
    authWallet: "Portefeuille",
    authConnectWallet: "Connecter le Portefeuille Solana",
    authConnectWalletDesc: "Connectez votre portefeuille Phantom pour accéder",
    authPhantomNotFound: "Phantom non trouvé",
    authInstallPhantom: "Installer Phantom",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },
  
  zh: {
    recordingAutoResumed: "页面刷新后已自动恢复录音。",
    recordingResumeNeedsClick: "刷新前录音处于活动状态。请点击“开始”恢复——浏览器需要点击才能捕获系统音频。",
    authForgotPassword: "忘记密码？",
    authForgotTitle: "重置密码",
    authForgotDesc: "输入您的邮箱，我们将发送创建新密码的链接",
    authSendResetLink: "发送重置链接",
    authResetEmailSent: "如果该邮箱已注册，您将很快收到重置链接。请同时检查垃圾邮件文件夹。",
    authBackToLogin: "← 返回登录",
    authResetTitle: "创建新密码",
    authResetDesc: "输入并确认您的新密码",
    authNewPassword: "新密码",
    authConfirmPassword: "确认新密码",
    authPasswordsMismatch: "两次输入的密码不一致。",
    authPasswordTooShort: "密码至少需要6个字符。",
    authResetSuccess: "密码重置成功！正在跳转到登录...",
    authResetInvalidToken: "链接无效或已过期，请重新申请。",
    authResetButton: "保存新密码",
    authGenericError: "发生错误，请重试。",
    selectLanguage: "选择您的语言。",
    selectLanguageEn: "Select your language.",
    continue: "继续",
    
    // Language Pair Selection page
    selectTranslationLanguages: "选择2种语言进行实时翻译",
    sourceLanguage: "源语言",
    targetLanguage: "目标语言",
    selectTargetLanguage: "选择目标语言",
    startTranslation: "开始翻译",
    languagePairHint: "翻译将在这两种语言之间自动进行",
    
    // Home button
    homeButton: "首页",
    
    appTitle: "实时翻译器",
    appSubtitle: "英语 ↔ 巴西葡萄牙语（自动检测）",
    controlTab: "控制",
    settingsTab: "设置",
    
    audioInput: "音频输入",
    start: "开始",
    stop: "停止",
    status: "状态",
    statusIdle: "空闲",
    statusConnecting: "连接中...",
    statusRecording: "录制中",
    statusError: "错误",
    clickToStart: "点击开始按钮启动",
    processingAudio: "实时处理音频...",
    openTranslationWindow: "打开翻译窗口",
    openSecondScreen: "在第二屏幕上打开",
    secondScreenDetected: "检测到第二屏幕",
    noSecondScreen: "未检测到第二屏幕",
    detect: "检测",
    
    translationPreview: "翻译预览",
    original: "原文",
    translation: "翻译",
    waitingAudio: "等待音频...",
    waitingTranslation: "等待翻译...",
    detecting: "检测中...",
    portuguese: "葡萄牙语",
    english: "英语",
    
    audioDevice: "音频设备",
    selectAudioSource: "选择音频源",
    audioDeviceDescription: "选择麦克风或音频卡来捕获演讲者的音频。",
    
    delayAdjustment: "延迟调整",
    translationDelay: "翻译延迟",
    delayDescription: "调整音频捕获和翻译之间的延迟。",
    
    audioGate: "音频门（噪音过滤器）",
    gateThreshold: "门限阈值",
    gateDescription: "门限过滤低于定义阈值的声音。",
    recommended: "推荐值：-30dB到-20dB。",
    sensitive: "敏感",
    loud: "响亮",

    readingSpeed: "阅读速度",
    readingSpeedLabel: "速度",
    readingSpeedSlow: "慢",
    readingSpeedNormal: "正常",
    readingSpeedFast: "快",
    readingSpeedUnit: "字/秒",
    readingSpeedDescription: "控制每条翻译在窗口上停留的时间。较低 = 更多阅读时间；较高 = 更好地跟随现场音频。",
    
    overlayMode: "叠加模式",
    overlayOtherWindows: "叠加其他窗口",
    overlayDescription: "启用后，翻译窗口将保持可见。",
    overlayActive: "叠加模式已激活",
    overlayActiveDescription: "翻译窗口将以弹出模式打开。",
    
    slideTime: "翻译幻灯片时间",
    slideDuration: "幻灯片持续时间",
    slideDescription: "设置每个翻译幻灯片在屏幕上停留的时间。",
    seconds: "秒",
    second: "秒",
    
    translationLines: "翻译行数",
    maxLinesPerSlide: "每张幻灯片最大行数",
    linesDescription: "设置每张幻灯片显示的最大文本行数。",
    line: "行",
    lines: "行",
    
    translationFontSize: "翻译字体大小",
    fontSize: "字体大小",
    fontSizeDescription: "设置翻译文本的字体大小。",
    small: "小",
    large: "大",
    
    headerBox: "页眉框",
    headerText: "页眉文本",
    footerBox: "页脚框",
    footerText: "页脚文本",
    padding: "内边距",
    roundCorners: "圆角",
    colors: "颜色",
    text: "文本",
    background: "背景",
    preview: "预览",
    on: "开",
    off: "关",
    
    recentHistory: "最近历史",
    
    overlayActiveIndicator: "叠加激活",
    prevSlide: "上一张幻灯片",
    nextSlide: "下一张幻灯片",
    goToSlide: "跳转到幻灯片",
    exitFullscreen: "退出全屏",
    enterFullscreen: "全屏",
    closeWindow: "关闭窗口",
    disableOverlay: "禁用叠加",
    enableOverlay: "启用叠加",
    
    gateOpen: "门开启 - 录制中",
    gateClosed: "门关闭 - 等待信号",

    // Header / Navigation
    plans: "计划",
    account: "账户",
    logout: "退出",
    signUp: "注册",
    guest: "访客",
    free: "免费",
    
    // Footer
    footerCopyright: "由 João Vitor Fernandes Farias 开发。保留所有权利。",
    backToDashboard: "返回仪表板",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "在 OBS、Streamlabs 和其他直播软件中将翻译用作字幕。",
    obsProOnlyText: "此功能仅在 PRO 计划中可用",
    obsCustomizeLabel: "自定义",
    obsPositionLabel: "位置",
    obsTextShadowLabel: "文字阴影",
    obsTextShadowDesc: "提高视频上的可读性",
    obsGenerateUrl: "生成 OBS URL",
    obsGeneratedUrlLabel: "生成的 OBS URL：",
    obsCopied: "URL 已复制！",
    obsPreviewBtn: "预览",
    obsParamsReference: "可选 URL 参数（参考）",
    obsParamBg: "背景颜色",
    obsParamFontSize: "字体大小 (px)",
    obsParamColor: "文字颜色（十六进制，不带 #）",
    obsParamPosition: "位置",
    obsParamShadow: "文字阴影",
    obsSettingsPlaceholder: "自定义设置...",
    
    // Audio section
    audioSource: "音频源",
    microphone: "麦克风",
    system: "系统",
    both: "两者",
    
    // Second Window
    secondTranslationWindow: "第二翻译窗口",
    enableSecondWindow: "启用第二窗口",
    optional: "可选",
    openSecondWindowFull: "打开第二窗口",
    splitScreenButton: "启用第二窗口（50/50 分屏）",
    splitScreenSuccess: "窗口已在第二屏幕上并排打开（50/50）",
    splitScreenNoScreen: "未检测到第二屏幕",
    splitScreenPermission: "要在第二屏幕上定位窗口，请在浏览器询问时允许「窗口管理」权限（或在网站设置中允许），然后再次点击按钮。",
    splitScreenPopupBlocked: "浏览器阻止了窗口打开。请允许此网站的弹出窗口，然后再次点击。",
    splitScreenBraveShields: "浏览器正在屏蔽屏幕尺寸（反指纹保护）。在 Brave 中：点击地址栏中的狮子图标 → 高级控制 → 「阻止指纹识别」→ 为此网站禁用。重新加载后重试。",
    secondWindowProOnly: "此功能仅在PRO计划中可用",
    upgradeProSecondWindow: "同时显示第三种语言的翻译。非常适合多语言观众的活动。",
    upgradePro: "升级PRO",
    
    // Pricing Page
    pricingTitle: "选择您的计划",
    pricingSubtitle: "免费开始或使用PRO计划解锁无限翻译",
    planFree: "免费计划",
    planPro: "PRO计划",
    currentPlan: "当前计划",
    perfectToTry: "非常适合试用",
    forProfessionalUse: "专业使用",
    freePrice: "免费",
    perMonth: "/月",
    feature10Minutes: "每月10分钟翻译",
    featureBidirectional: "双向翻译",
    feature20Languages: "支持20种语言",
    featureUnlimited: "无限翻译",
    feature2Screens: "在不同屏幕上翻译成2种语言",
    featureOBS: "用于直播的OBS集成",
    featureQRCode: "通过二维码直接翻译到访客手机",
    startFree: "免费开始",
    alreadyPro: "您已经是PRO用户！",
    creditCard: "信用卡",
    payWithCard: "使用信用卡支付",
    loginToPay: "登录以支付",
    verifyPayment: "验证支付",
    amount: "金额",
    noConversionNeeded: "发送准确金额",
    solanaNetwork: "Solana网络",
    sendTo: "发送到",
    tokenOnSolana: "在Solana网络上",
    txSignatureLabel: "交易签名（发送后）",
    txSignaturePlaceholder: "在此粘贴交易签名",
    viewOnSolscan: "在Solscan上查看交易",
    addressCopied: "地址已复制！",
    errorRedirectPayment: "重定向到支付时出错",
    errorEnterTxSignature: "请输入交易签名",
    errorVerifyTx: "验证交易时出错",
    
    // OBS Integration
    obsIntegration: "OBS集成",
    streaming: "直播",
    obsDescription: "在您的直播中使用翻译作为字幕。在OBS中添加为\"Browser Source\"。",
    customizeLegend: "自定义字幕",
    backgroundColor: "背景颜色",
    transparent: "透明",
    green: "绿色",
    blue: "蓝色",
    magenta: "品红",
    black: "黑色",
    textColor: "文字颜色",
    customize: "自定义",
    position: "位置",
    top: "顶部",
    center: "中心",
    bottom: "底部",
    textShadow: "文字阴影",
    textShadowDescription: "提高视频上的可读性",
    generateObsUrl: "生成OBS URL",
    optionalUrlParams: "可选URL参数（参考）",
    obsStepByStep: "OBS分步指南",
    obsProOnly: "此功能仅在PRO计划中可用",
    
    // Translation Rooms
    translationRooms: "翻译房间",
    events: "活动",
    createRoom: "创建翻译房间",
    roomDescription: "创建一个房间，让活动、教堂或会议的参与者可以通过二维码或链接在自己的设备上访问翻译。",
    roomProOnly: "翻译房间仅对PRO用户开放",
    upgradeToProRooms: "创建一个房间并分享二维码/链接，让访客在自己的设备上查看翻译。",
    
    // Permanent Links
    permanentLinks: "固定链接",
    permanent: "永久",
    createPermanentLink: "创建固定链接",
    permanentLinkDescription: "为教堂、会议和定期活动创建永久链接。打印一次二维码，永久使用！",
    roomName: "房间名称",
    customCode: "自定义代码",
    customCodeOptional: "可选",
    leaveEmptyToGenerate: "留空自动生成",
    linkPreview: "链接预览",
    noPermanentLinksYet: "尚未创建固定链接。为定期活动创建一个永久链接。",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "二维码 - 固定链接",
    permanentLinkLabel: "永久链接：",
    qrNeverChanges: "此二维码和链接永不改变！您可以打印并永久使用。",
    copyLink: "复制链接",
    openLink: "打开",
    
    // QR Code Modal - Translation Room  
    shareRoom: "分享房间",
    roomCode: "房间代码：",
    shareLink: "分享链接：",
    visitorsCanScan: "访客可以扫描二维码或访问链接查看实时翻译",
    endRoomConfirm: "确定要关闭房间吗？所有访客将被断开连接。",
    share: "分享",
    
    // Room Config
    roomConfig: "房间配置",
    presenterLanguages: "演讲者语言",
    presenterLanguagesDescription: "选择本次活动演讲者将使用的所有语言。",
    presenterLanguagesTip: "提示：如果有演讲者使用不同语言，请全部选择以优化翻译。",
    selected: "已选择",
    close: "关闭",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "翻译室",
    publicRoomBy: "由",
    publicRoomSelectLanguage: "您的语言是什么？",
    publicRoomLanguageHint: "翻译将以所选语言显示",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "房间不可用",
    publicRoomBackHome: "返回首页",
    publicRoomConnecting: "正在连接房间",
    publicRoomHeaderRoom: "房间",
    publicRoomConnected: "已连接",
    publicRoomReconnecting: "重新连接中...",
    publicRoomChangeLanguage: "更改语言",
    publicRoomSettings: "设置",
    publicRoomReadingSpeed: "阅读速度",
    publicRoomReadingSpeedSlow: "慢",
    publicRoomReadingSpeedNormal: "正常",
    publicRoomReadingSpeedFast: "快",
    publicRoomReadingSpeedUnit: "字/秒",
    publicRoomInQueue: "队列中",
    publicRoomFontSize: "字体大小",
    publicRoomBgColor: "背景颜色",
    publicRoomTextColor: "文字颜色",
    publicRoomShowOriginal: "显示原文",
    publicRoomFullscreen: "全屏",
    publicRoomExitFullscreen: "退出全屏",
    publicRoomWaitingTranslation: "等待翻译...",
    publicRoomViewers: "观众",
    publicRoomViewer: "观众",
    publicRoomWaitingSession: "等待会议开始...",
    publicRoomSessionWillStart: "当演示者开始时，翻译将自动开始。",
    publicRoomTranslating: "翻译中...",
    publicRoomErrorNotFound: "房间未找到。请检查代码并重试。",
    publicRoomErrorServer: "连接服务器失败。请重试。",
    publicRoomSessionEnded: "演示者已结束会话",
    publicRoomDeleted: "此房间已被永久删除。",
    
    // Output mode selection
    publicRoomSelectMode: "您希望如何接收翻译？",
    publicRoomModeHint: "选择翻译输出方式",
    publicRoomTextOnly: "文字翻译",
    publicRoomTextOnlyDesc: "在屏幕上阅读翻译",
    publicRoomTextVoice: "文字 + 语音翻译",
    publicRoomTextVoiceDesc: "阅读并收听翻译",
    publicRoomHeadphonesRequired: "需要耳机",
    publicRoomHeadphonesOverride: "我已连接耳机但未被检测到",
    publicRoomHeadphonesNotDetected: "连接耳机以启用此选项",
    publicRoomHeadphonesDetected: "已检测到耳机",
    publicRoomCheckingAudio: "正在检查音频设备...",
    publicRoomSpeaking: "正在播放...",
    publicRoomVoiceEnabled: "语音已启用",
    publicRoomChangeVoice: "翻译语音",
    publicRoomVoiceDisabled: "语音已禁用",
    publicRoomSelectVoice: "选择语音",
    publicRoomSelectVoiceHint: "选择用于语音翻译的声音",
    publicRoomVoicePreview: "预览",
    publicRoomNoVoicesAvailable: "此语言没有可用的语音",
    publicRoomVoiceSelected: "已选择语音",
    publicRoomConfirm: "确认",
    publicRoomTestVoice: "测试语音",
    publicRoomNoNativeVoices: "您的设备没有{language}的语音。显示可用的语音。",
    publicRoomInstallVoices: "要获取其他语言的语音，请在系统设置中安装语言包。",
    publicRoomHowToInstallVoices: "如何安装语音",
    publicRoomVoiceHelpTitle: "如何在您的设备上安装语音",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. 打开设置 (Win + I)\n2. 转到时间和语言 → 语音\n3. 点击\"添加语音\"\n4. 选择所需语言\n5. 重新启动浏览器",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. 打开系统偏好设置\n2. 转到辅助功能 → 语音内容\n3. 点击\"系统语音\"\n4. 选择\"自定义\"\n5. 下载所需语音",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. 打开设置\n2. 转到无障碍 → 文字转语音\n3. 点击\"首选引擎\"\n4. 安装其他语言\n5. 重新启动浏览器",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. 打开设置\n2. 转到辅助功能 → 语音内容\n3. 点击\"语音\"\n4. 选择所需语言\n5. 下载可用语音",
    publicRoomVoiceHelpTip: "提示：Google Chrome 通常比其他浏览器提供更多语音。",
    publicRoomVoiceHelpClose: "关闭",
    
    // Auth page
    authSignIn: "登录",
    authSignUp: "注册",
    authSignInSubtitle: "登录以继续使用翻译器",
    authSignUpSubtitle: "创建您的账户开始使用",
    authEmail: "邮箱",
    authPassword: "密码",
    authName: "姓名",
    authEmailPlaceholder: "your@email.com",
    authPasswordPlaceholder: "您的密码",
    authNamePlaceholder: "您的姓名",
    authOrContinueWith: "或继续使用",
    authContinueGoogle: "使用Google继续",
    authNoAccount: "没有账户？",
    authHasAccount: "已有账户？",
    authAccessAsGuest: "以访客身份访问",
    authBackToHome: "返回首页",
    authDiagnostics: "访问有问题？点击此处进行诊断",
    authWallet: "钱包",
    authConnectWallet: "连接Solana钱包",
    authConnectWalletDesc: "连接您的Phantom钱包以访问",
    authPhantomNotFound: "未找到Phantom",
    authInstallPhantom: "安装Phantom",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
  },
  
  hi: {
    recordingAutoResumed: "पेज रीफ़्रेश के बाद रिकॉर्डिंग स्वतः फिर से शुरू हो गई।",
    recordingResumeNeedsClick: "रीफ़्रेश से पहले रिकॉर्डिंग चालू थी। फिर से शुरू करने के लिए Start पर क्लिक करें — सिस्टम ऑडियो कैप्चर के लिए ब्राउज़र को क्लिक चाहिए।",
    authForgotPassword: "पासवर्ड भूल गए?",
    authForgotTitle: "पासवर्ड रीसेट करें",
    authForgotDesc: "अपना ईमेल दर्ज करें, हम नया पासवर्ड बनाने का लिंक भेजेंगे",
    authSendResetLink: "रीसेट लिंक भेजें",
    authResetEmailSent: "यदि यह ईमेल पंजीकृत है, तो आपको शीघ्र ही लिंक मिलेगा। स्पैम फ़ोल्डर भी जाँचें।",
    authBackToLogin: "← लॉगिन पर वापस जाएँ",
    authResetTitle: "नया पासवर्ड बनाएँ",
    authResetDesc: "अपना नया पासवर्ड दर्ज करें और पुष्टि करें",
    authNewPassword: "नया पासवर्ड",
    authConfirmPassword: "नए पासवर्ड की पुष्टि करें",
    authPasswordsMismatch: "पासवर्ड मेल नहीं खाते।",
    authPasswordTooShort: "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।",
    authResetSuccess: "पासवर्ड सफलतापूर्वक रीसेट हुआ! लॉगिन पर भेजा जा रहा है...",
    authResetInvalidToken: "लिंक अमान्य या समाप्त हो गया है। नया लिंक अनुरोध करें।",
    authResetButton: "नया पासवर्ड सहेजें",
    authGenericError: "एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
    selectLanguage: "अपनी भाषा चुनें।",
    selectLanguageEn: "Select your language.",
    continue: "जारी रखें",
    
    // Language Pair Selection page
    selectTranslationLanguages: "रीयल-टाइम अनुवाद के लिए 2 भाषाएँ चुनें",
    sourceLanguage: "स्रोत भाषा",
    targetLanguage: "लक्ष्य भाषा",
    selectTargetLanguage: "लक्ष्य भाषा चुनें",
    startTranslation: "अनुवाद शुरू करें",
    languagePairHint: "इन दो भाषाओं के बीच स्वचालित रूप से अनुवाद किया जाएगा",
    
    // Home button
    homeButton: "होम",
    
    appTitle: "रीयल-टाइम अनुवादक",
    appSubtitle: "अंग्रेजी ↔ ब्राजीलियाई पुर्तगाली (स्वचालित पहचान)",
    controlTab: "नियंत्रण",
    settingsTab: "सेटिंग्स",
    
    audioInput: "ऑडियो इनपुट",
    start: "शुरू",
    stop: "रुकें",
    status: "स्थिति",
    statusIdle: "निष्क्रिय",
    statusConnecting: "कनेक्ट हो रहा है...",
    statusRecording: "रिकॉर्डिंग",
    statusError: "त्रुटि",
    clickToStart: "शुरू करने के लिए क्लिक करें",
    processingAudio: "वास्तविक समय में ऑडियो प्रोसेसिंग...",
    openTranslationWindow: "अनुवाद विंडो खोलें",
    openSecondScreen: "दूसरी स्क्रीन पर खोलें",
    secondScreenDetected: "दूसरी स्क्रीन पाई गई",
    noSecondScreen: "कोई दूसरी स्क्रीन नहीं मिली",
    detect: "पता लगाएं",
    
    translationPreview: "अनुवाद पूर्वावलोकन",
    original: "मूल",
    translation: "अनुवाद",
    waitingAudio: "ऑडियो की प्रतीक्षा...",
    waitingTranslation: "अनुवाद की प्रतीक्षा...",
    detecting: "पता लगा रहा है...",
    portuguese: "पुर्तगाली",
    english: "अंग्रेज़ी",
    
    audioDevice: "ऑडियो डिवाइस",
    selectAudioSource: "ऑडियो स्रोत चुनें",
    audioDeviceDescription: "वक्ता के ऑडियो को कैप्चर करने के लिए माइक्रोफोन चुनें।",
    
    delayAdjustment: "विलंब समायोजन",
    translationDelay: "अनुवाद विलंब",
    delayDescription: "ऑडियो कैप्चर और अनुवाद के बीच विलंब समायोजित करें।",
    
    audioGate: "ऑडियो गेट (शोर फ़िल्टर)",
    gateThreshold: "गेट थ्रेशोल्ड",
    gateDescription: "गेट परिभाषित थ्रेशोल्ड से नीचे की ध्वनियों को फ़िल्टर करता है।",
    recommended: "अनुशंसित मान: -30dB से -20dB।",
    sensitive: "संवेदनशील",
    loud: "तेज़",

    readingSpeed: "पढ़ने की गति",
    readingSpeedLabel: "गति",
    readingSpeedSlow: "धीमा",
    readingSpeedNormal: "सामान्य",
    readingSpeedFast: "तेज़",
    readingSpeedUnit: "अक्षर/से",
    readingSpeedDescription: "नियंत्रित करता है कि प्रत्येक अनुवाद विंडो पर कितनी देर तक रहता है। कम = अधिक पढ़ने का समय; अधिक = लाइव ऑडियो के साथ बेहतर तालमेल।",
    
    overlayMode: "ओवरले मोड",
    overlayOtherWindows: "अन्य विंडो पर ओवरले",
    overlayDescription: "सक्षम होने पर, अनुवाद विंडो दृश्यमान रहेगी।",
    overlayActive: "ओवरले मोड सक्रिय",
    overlayActiveDescription: "अनुवाद विंडो पॉपअप मोड में खुलेगी।",
    
    slideTime: "अनुवादित स्लाइड समय",
    slideDuration: "स्लाइड अवधि",
    slideDescription: "प्रत्येक अनुवाद स्लाइड स्क्रीन पर कितनी देर रहती है।",
    seconds: "सेकंड",
    second: "सेकंड",
    
    translationLines: "अनुवाद पंक्तियां",
    maxLinesPerSlide: "प्रति स्लाइड अधिकतम पंक्तियां",
    linesDescription: "प्रत्येक स्लाइड में प्रदर्शित टेक्स्ट पंक्तियों की अधिकतम संख्या।",
    line: "पंक्ति",
    lines: "पंक्तियां",
    
    translationFontSize: "अनुवाद फ़ॉन्ट आकार",
    fontSize: "फ़ॉन्ट आकार",
    fontSizeDescription: "अनुवादित टेक्स्ट का फ़ॉन्ट आकार सेट करें।",
    small: "छोटा",
    large: "बड़ा",
    
    headerBox: "हेडर बॉक्स",
    headerText: "हेडर टेक्स्ट",
    footerBox: "फुटर बॉक्स",
    footerText: "फुटर टेक्स्ट",
    padding: "पैडिंग",
    roundCorners: "गोल कोने",
    colors: "रंग",
    text: "टेक्स्ट",
    background: "पृष्ठभूमि",
    preview: "पूर्वावलोकन",
    on: "चालू",
    off: "बंद",
    
    recentHistory: "हाल का इतिहास",
    
    overlayActiveIndicator: "ओवरले सक्रिय",
    prevSlide: "पिछली स्लाइड",
    nextSlide: "अगली स्लाइड",
    goToSlide: "स्लाइड पर जाएं",
    exitFullscreen: "पूर्ण स्क्रीन से बाहर",
    enterFullscreen: "पूर्ण स्क्रीन",
    closeWindow: "विंडो बंद करें",
    disableOverlay: "ओवरले अक्षम",
    enableOverlay: "ओवरले सक्षम",
    
    gateOpen: "गेट खुला - रिकॉर्डिंग",
    gateClosed: "गेट बंद - सिग्नल की प्रतीक्षा",

    // Header / Navigation
    plans: "योजनाएं",
    account: "खाता",
    logout: "लॉगआउट",
    signUp: "साइन अप",
    guest: "अतिथि",
    free: "मुफ्त",
    
    // Footer
    footerCopyright: "João Vitor Fernandes Farias द्वारा विकसित। सर्वाधिकार सुरक्षित।",
    backToDashboard: "डैशबोर्ड पर वापस",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "OBS, Streamlabs और अन्य स्ट्रीमिंग सॉफ़्टवेयर में अपने लाइव स्ट्रीम में अनुवाद को उपशीर्षक के रूप में उपयोग करें।",
    obsProOnlyText: "यह सुविधा केवल PRO प्लान में उपलब्ध है",
    obsCustomizeLabel: "अनुकूलित करें",
    obsPositionLabel: "स्थिति",
    obsTextShadowLabel: "टेक्स्ट छाया",
    obsTextShadowDesc: "वीडियो पर पठनीयता में सुधार करता है",
    obsGenerateUrl: "OBS के लिए URL जनरेट करें",
    obsGeneratedUrlLabel: "OBS के लिए जनरेट किया गया URL:",
    obsCopied: "URL कॉपी हो गया!",
    obsPreviewBtn: "पूर्वावलोकन",
    obsParamsReference: "वैकल्पिक URL पैरामीटर (संदर्भ)",
    obsParamBg: "पृष्ठभूमि रंग",
    obsParamFontSize: "फ़ॉन्ट आकार (px)",
    obsParamColor: "टेक्स्ट रंग (# के बिना हेक्स)",
    obsParamPosition: "स्थिति",
    obsParamShadow: "टेक्स्ट छाया",
    obsSettingsPlaceholder: "अनुकूलन सेटिंग्स...",
    
    // Audio section
    audioSource: "ऑडियो स्रोत",
    microphone: "माइक्रोफोन",
    system: "सिस्टम",
    both: "दोनों",
    
    // Second Window
    secondTranslationWindow: "दूसरी अनुवाद विंडो",
    enableSecondWindow: "दूसरी विंडो सक्षम करें",
    optional: "वैकल्पिक",
    openSecondWindowFull: "दूसरी विंडो खोलें",
    splitScreenButton: "दूसरी विंडो सक्षम करें (50/50 विभाजन)",
    splitScreenSuccess: "दूसरी स्क्रीन पर विंडो साथ-साथ खोली गईं (50/50)",
    splitScreenNoScreen: "दूसरी स्क्रीन का पता नहीं चला",
    splitScreenPermission: "दूसरी स्क्रीन पर विंडो रखने के लिए, ब्राउज़र द्वारा पूछे जाने पर 'विंडो प्रबंधन' की अनुमति दें (या साइट सेटिंग्स में) और बटन पर फिर से क्लिक करें।",
    splitScreenPopupBlocked: "ब्राउज़र ने विंडो खोलने से रोक दिया। इस साइट के लिए पॉप-अप की अनुमति दें और फिर से क्लिक करें।",
    splitScreenBraveShields: "ब्राउज़र स्क्रीन आयामों को छिपा रहा है (एंटी-फिंगरप्रिंट सुरक्षा)। Brave में: एड्रेस बार में शेर के आइकन पर क्लिक करें → उन्नत नियंत्रण → 'फिंगरप्रिंटिंग ब्लॉक करें' → इस साइट के लिए अक्षम। पुनः लोड करें और फिर से प्रयास करें।",
    secondWindowProOnly: "यह सुविधा केवल PRO प्लान में उपलब्ध है",
    upgradeProSecondWindow: "एक साथ तीसरी भाषा में अनुवाद प्रदर्शित करें। बहुभाषी दर्शकों वाले कार्यक्रमों के लिए आदर्श।",
    upgradePro: "PRO में अपग्रेड करें",
    
    // Pricing Page
    pricingTitle: "अपनी योजना चुनें",
    pricingSubtitle: "मुफ्त में शुरू करें या PRO प्लान के साथ असीमित अनुवाद अनलॉक करें",
    planFree: "मुफ्त योजना",
    planPro: "PRO योजना",
    currentPlan: "वर्तमान योजना",
    perfectToTry: "आज़माने के लिए बिल्कुल सही",
    forProfessionalUse: "पेशेवर उपयोग के लिए",
    freePrice: "मुफ्त",
    perMonth: "/महीना",
    feature10Minutes: "प्रति माह 10 मिनट अनुवाद",
    featureBidirectional: "द्विदिशात्मक अनुवाद",
    feature20Languages: "20 भाषाएं समर्थित",
    featureUnlimited: "असीमित अनुवाद",
    feature2Screens: "अलग स्क्रीन पर 2 भाषाओं में अनुवाद",
    featureOBS: "स्ट्रीमिंग के लिए OBS एकीकरण",
    featureQRCode: "QR कोड के माध्यम से आगंतुक के फोन पर सीधे अनुवाद",
    startFree: "मुफ्त शुरू करें",
    alreadyPro: "आप पहले से PRO हैं!",
    creditCard: "कार्ड",
    payWithCard: "कार्ड से भुगतान करें",
    loginToPay: "भुगतान के लिए लॉगिन करें",
    verifyPayment: "भुगतान सत्यापित करें",
    amount: "राशि",
    noConversionNeeded: "सटीक राशि भेजें",
    solanaNetwork: "Solana नेटवर्क",
    sendTo: "भेजें",
    tokenOnSolana: "Solana नेटवर्क पर",
    txSignatureLabel: "लेनदेन हस्ताक्षर (भेजने के बाद)",
    txSignaturePlaceholder: "लेनदेन हस्ताक्षर यहां पेस्ट करें",
    viewOnSolscan: "Solscan पर लेनदेन देखें",
    addressCopied: "पता कॉपी किया गया!",
    errorRedirectPayment: "भुगतान पर रीडायरेक्ट करने में त्रुटि",
    errorEnterTxSignature: "कृपया लेनदेन हस्ताक्षर दर्ज करें",
    errorVerifyTx: "लेनदेन सत्यापित करने में त्रुटि",
    
    // OBS Integration
    obsIntegration: "OBS एकीकरण",
    streaming: "स्ट्रीमिंग",
    obsDescription: "अपने लाइव स्ट्रीम में अनुवाद को उपशीर्षक के रूप में उपयोग करें। OBS में \"Browser Source\" के रूप में जोड़ें।",
    customizeLegend: "उपशीर्षक अनुकूलित करें",
    backgroundColor: "पृष्ठभूमि रंग",
    transparent: "पारदर्शी",
    green: "हरा",
    blue: "नीला",
    magenta: "मैजेंटा",
    black: "काला",
    textColor: "टेक्स्ट रंग",
    customize: "अनुकूलित",
    position: "स्थिति",
    top: "शीर्ष",
    center: "केंद्र",
    bottom: "नीचे",
    textShadow: "टेक्स्ट छाया",
    textShadowDescription: "वीडियो पर पठनीयता में सुधार करता है",
    generateObsUrl: "OBS URL जनरेट करें",
    optionalUrlParams: "वैकल्पिक URL पैरामीटर (संदर्भ)",
    obsStepByStep: "OBS चरण-दर-चरण",
    obsProOnly: "यह सुविधा केवल PRO प्लान में उपलब्ध है",
    
    // Translation Rooms
    translationRooms: "अनुवाद कक्ष",
    events: "कार्यक्रम",
    createRoom: "अनुवाद कक्ष बनाएं",
    roomDescription: "एक कक्ष बनाएं ताकि कार्यक्रमों, चर्चों या सम्मेलनों में लोग QR कोड या लिंक के माध्यम से अपने उपकरणों पर अनुवाद प्राप्त कर सकें।",
    roomProOnly: "अनुवाद कक्ष केवल PRO उपयोगकर्ताओं के लिए उपलब्ध हैं",
    upgradeToProRooms: "एक कक्ष बनाएं और QR कोड/लिंक साझा करें ताकि आगंतुक अपने उपकरणों पर अनुवाद देख सकें।",
    
    // Permanent Links
    permanentLinks: "स्थायी लिंक",
    permanent: "स्थायी",
    createPermanentLink: "स्थायी लिंक बनाएं",
    permanentLinkDescription: "चर्चों, सम्मेलनों और आवर्ती कार्यक्रमों के लिए स्थायी लिंक बनाएं। QR कोड एक बार प्रिंट करें और हमेशा उपयोग करें!",
    roomName: "कक्ष का नाम",
    customCode: "कस्टम कोड",
    customCodeOptional: "वैकल्पिक",
    leaveEmptyToGenerate: "स्वचालित रूप से जनरेट करने के लिए खाली छोड़ें",
    linkPreview: "लिंक पूर्वावलोकन",
    noPermanentLinksYet: "अभी तक कोई स्थायी लिंक नहीं बनाया गया। आवर्ती कार्यक्रमों के लिए एक स्थायी लिंक बनाएं।",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR कोड - स्थायी लिंक",
    permanentLinkLabel: "स्थायी लिंक:",
    qrNeverChanges: "यह QR कोड और लिंक कभी नहीं बदलते! आप इसे प्रिंट करके हमेशा उपयोग कर सकते हैं।",
    copyLink: "लिंक कॉपी करें",
    openLink: "खोलें",
    
    // QR Code Modal - Translation Room  
    shareRoom: "कक्ष साझा करें",
    roomCode: "कक्ष कोड:",
    shareLink: "साझा करने का लिंक:",
    visitorsCanScan: "आगंतुक QR कोड स्कैन कर सकते हैं या लाइव अनुवाद देखने के लिए लिंक एक्सेस कर सकते हैं",
    endRoomConfirm: "क्या आप वाकई कक्ष बंद करना चाहते हैं? सभी आगंतुक डिस्कनेक्ट हो जाएंगे।",
    share: "साझा करें",
    
    // Room Config
    roomConfig: "कक्ष कॉन्फ़िगरेशन",
    presenterLanguages: "प्रस्तुतकर्ता भाषाएं",
    presenterLanguagesDescription: "इस कार्यक्रम में प्रस्तुतकर्ताओं द्वारा बोली जाने वाली सभी भाषाओं का चयन करें।",
    presenterLanguagesTip: "सुझाव: यदि विभिन्न भाषाएं बोलने वाले वक्ता हैं, तो अनुवाद को अनुकूलित करने के लिए सभी का चयन करें।",
    selected: "चयनित",
    close: "बंद करें",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "अनुवाद कक्ष",
    publicRoomBy: "द्वारा",
    publicRoomSelectLanguage: "आपकी भाषा क्या है?",
    publicRoomLanguageHint: "अनुवाद चुनी गई भाषा में दिखाया जाएगा",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "कक्ष उपलब्ध नहीं",
    publicRoomBackHome: "होम पर वापस जाएं",
    publicRoomConnecting: "कक्ष से कनेक्ट हो रहा है",
    publicRoomHeaderRoom: "कक्ष",
    publicRoomConnected: "कनेक्टेड",
    publicRoomReconnecting: "पुनः कनेक्ट हो रहा है...",
    publicRoomChangeLanguage: "भाषा बदलें",
    publicRoomSettings: "सेटिंग्स",
    publicRoomReadingSpeed: "पढ़ने की गति",
    publicRoomReadingSpeedSlow: "धीमा",
    publicRoomReadingSpeedNormal: "सामान्य",
    publicRoomReadingSpeedFast: "तेज़",
    publicRoomReadingSpeedUnit: "अक्षर/से",
    publicRoomInQueue: "कतार में",
    publicRoomFontSize: "फ़ॉन्ट आकार",
    publicRoomBgColor: "पृष्ठभूमि रंग",
    publicRoomTextColor: "टेक्स्ट रंग",
    publicRoomShowOriginal: "मूल पाठ दिखाएं",
    publicRoomFullscreen: "पूर्ण स्क्रीन",
    publicRoomExitFullscreen: "पूर्ण स्क्रीन से बाहर निकलें",
    publicRoomWaitingTranslation: "अनुवाद की प्रतीक्षा...",
    publicRoomViewers: "दर्शक",
    publicRoomViewer: "दर्शक",
    publicRoomWaitingSession: "सत्र शुरू होने की प्रतीक्षा...",
    publicRoomSessionWillStart: "प्रस्तुतकर्ता शुरू करने पर अनुवाद स्वचालित रूप से शुरू हो जाएगा।",
    publicRoomTranslating: "अनुवाद हो रहा है...",
    publicRoomErrorNotFound: "कक्ष नहीं मिला। कृपया कोड जांचें और पुनः प्रयास करें।",
    publicRoomErrorServer: "सर्वर से कनेक्ट करने में विफल। कृपया पुनः प्रयास करें।",
    publicRoomSessionEnded: "प्रस्तुतकर्ता ने सत्र समाप्त कर दिया है",
    publicRoomDeleted: "यह कक्ष स्थायी रूप से हटा दिया गया है।",
    
    // Output mode selection
    publicRoomSelectMode: "आप अनुवाद कैसे प्राप्त करना चाहते हैं?",
    publicRoomModeHint: "अनुवाद आउटपुट मोड चुनें",
    publicRoomTextOnly: "टेक्स्ट अनुवाद",
    publicRoomTextOnlyDesc: "स्क्रीन पर अनुवाद पढ़ें",
    publicRoomTextVoice: "टेक्स्ट + वॉयस अनुवाद",
    publicRoomTextVoiceDesc: "अनुवाद पढ़ें और सुनें",
    publicRoomHeadphonesRequired: "हेडफ़ोन आवश्यक",
    publicRoomHeadphonesOverride: "मेरे हेडफ़ोन कनेक्ट हैं लेकिन पता नहीं चला",
    publicRoomHeadphonesNotDetected: "इस विकल्प को सक्षम करने के लिए हेडफ़ोन कनेक्ट करें",
    publicRoomHeadphonesDetected: "हेडफ़ोन पता चला",
    publicRoomCheckingAudio: "ऑडियो डिवाइस की जांच हो रही है...",
    publicRoomSpeaking: "बोल रहा है...",
    publicRoomVoiceEnabled: "वॉयस सक्षम",
    publicRoomChangeVoice: "अनुवादक की आवाज़",
    publicRoomVoiceDisabled: "वॉयस अक्षम",
    publicRoomSelectVoice: "आवाज़ चुनें",
    publicRoomSelectVoiceHint: "बोली गई अनुवाद के लिए आवाज़ चुनें",
    publicRoomVoicePreview: "पूर्वावलोकन",
    publicRoomNoVoicesAvailable: "इस भाषा के लिए कोई आवाज़ उपलब्ध नहीं",
    publicRoomVoiceSelected: "आवाज़ चयनित",
    publicRoomConfirm: "पुष्टि करें",
    publicRoomTestVoice: "आवाज़ परीक्षण",
    publicRoomNoNativeVoices: "आपके डिवाइस में {language} में आवाज़ नहीं है। उपलब्ध आवाज़ें दिखाई जा रही हैं।",
    publicRoomInstallVoices: "अन्य भाषाओं में आवाज़ प्राप्त करने के लिए, सिस्टम सेटिंग्स में भाषा पैक स्थापित करें।",
    publicRoomHowToInstallVoices: "आवाज़ कैसे इंस्टॉल करें",
    publicRoomVoiceHelpTitle: "अपने डिवाइस पर आवाज़ कैसे इंस्टॉल करें",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. सेटिंग्स खोलें (Win + I)\n2. समय और भाषा → वाक् पर जाएं\n3. \"आवाज़ें जोड़ें\" पर क्लिक करें\n4. इच्छित भाषाएं चुनें\n5. ब्राउज़र पुनः प्रारंभ करें",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. सिस्टम प्राथमिकताएं खोलें\n2. एक्सेसिबिलिटी → स्पोकन कंटेंट पर जाएं\n3. \"सिस्टम वॉयस\" पर क्लिक करें\n4. \"कस्टमाइज़\" चुनें\n5. इच्छित आवाज़ें डाउनलोड करें",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. सेटिंग्स खोलें\n2. एक्सेसिबिलिटी → टेक्स्ट-टू-स्पीच पर जाएं\n3. \"पसंदीदा इंजन\" पर टैप करें\n4. अतिरिक्त भाषाएं इंस्टॉल करें\n5. ब्राउज़र पुनः प्रारंभ करें",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. सेटिंग्स खोलें\n2. एक्सेसिबिलिटी → स्पोकन कंटेंट पर जाएं\n3. \"वॉयस\" पर टैप करें\n4. इच्छित भाषा चुनें\n5. उपलब्ध आवाज़ें डाउनलोड करें",
    publicRoomVoiceHelpTip: "सुझाव: Google Chrome आमतौर पर अन्य ब्राउज़रों की तुलना में अधिक आवाज़ें प्रदान करता है।",
    publicRoomVoiceHelpClose: "बंद करें",
    
    // Auth page
    authSignIn: "साइन इन",
    authSignUp: "साइन अप",
    authSignInSubtitle: "अनुवादक का उपयोग जारी रखने के लिए साइन इन करें",
    authSignUpSubtitle: "शुरू करने के लिए अपना खाता बनाएं",
    authEmail: "ईमेल",
    authPassword: "पासवर्ड",
    authName: "नाम",
    authEmailPlaceholder: "your@email.com",
    authPasswordPlaceholder: "आपका पासवर्ड",
    authNamePlaceholder: "आपका नाम",
    authOrContinueWith: "या इसके साथ जारी रखें",
    authContinueGoogle: "Google के साथ जारी रखें",
    authNoAccount: "खाता नहीं है?",
    authHasAccount: "पहले से खाता है?",
    authAccessAsGuest: "अतिथि के रूप में प्रवेश करें",
    authBackToHome: "होम पर वापस",
    authDiagnostics: "एक्सेस में समस्या? निदान के लिए यहां क्लिक करें",
    authWallet: "वॉलेट",
    authConnectWallet: "Solana वॉलेट कनेक्ट करें",
    authConnectWalletDesc: "एक्सेस के लिए अपना Phantom वॉलेट कनेक्ट करें",
    authPhantomNotFound: "Phantom नहीं मिला",
    authInstallPhantom: "Phantom इंस्टॉल करें",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },

  de: {
    recordingAutoResumed: "Aufnahme nach dem Neuladen automatisch fortgesetzt.",
    recordingResumeNeedsClick: "Die Aufnahme war vor dem Neuladen aktiv. Klicken Sie auf Start, um fortzufahren — der Browser benötigt einen Klick für Systemaudio.",
    authForgotPassword: "Passwort vergessen?",
    authForgotTitle: "Passwort zurücksetzen",
    authForgotDesc: "Geben Sie Ihre E-Mail ein, wir senden Ihnen einen Link für ein neues Passwort",
    authSendResetLink: "Link senden",
    authResetEmailSent: "Wenn diese E-Mail registriert ist, erhalten Sie in Kürze einen Link. Prüfen Sie auch den Spam-Ordner.",
    authBackToLogin: "← Zurück zur Anmeldung",
    authResetTitle: "Neues Passwort erstellen",
    authResetDesc: "Neues Passwort eingeben und bestätigen",
    authNewPassword: "Neues Passwort",
    authConfirmPassword: "Neues Passwort bestätigen",
    authPasswordsMismatch: "Die Passwörter stimmen nicht überein.",
    authPasswordTooShort: "Das Passwort muss mindestens 6 Zeichen haben.",
    authResetSuccess: "Passwort zurückgesetzt! Weiterleitung zur Anmeldung...",
    authResetInvalidToken: "Link ungültig oder abgelaufen. Fordern Sie einen neuen an.",
    authResetButton: "Neues Passwort speichern",
    authGenericError: "Ein Fehler ist aufgetreten. Bitte erneut versuchen.",
    selectLanguage: "Wählen Sie Ihre Sprache.",
    selectLanguageEn: "Select your language.",
    continue: "Fortfahren",
    
    // Language Pair Selection page
    selectTranslationLanguages: "Wählen Sie die 2 Sprachen für Echtzeit-Übersetzung",
    sourceLanguage: "Ausgangssprache",
    targetLanguage: "Zielsprache",
    selectTargetLanguage: "Wählen Sie die Zielsprache",
    startTranslation: "Übersetzung starten",
    languagePairHint: "Die Übersetzung erfolgt automatisch zwischen diesen beiden Sprachen",
    
    // Home button
    homeButton: "Startseite",
    
    appTitle: "Echtzeit-Übersetzer",
    appSubtitle: "Englisch ↔ Brasilianisches Portugiesisch (Automatische Erkennung)",
    controlTab: "Steuerung",
    settingsTab: "Einstellungen",
    
    audioInput: "Audioeingang",
    start: "Start",
    stop: "Stopp",
    status: "Status",
    statusIdle: "Inaktiv",
    statusConnecting: "Verbinde...",
    statusRecording: "Aufnahme",
    statusError: "Fehler",
    clickToStart: "Klicken Sie auf Start, um zu beginnen",
    processingAudio: "Audio wird in Echtzeit verarbeitet...",
    openTranslationWindow: "Übersetzungsfenster öffnen",
    openSecondScreen: "Auf zweitem Bildschirm öffnen",
    secondScreenDetected: "Zweiter Bildschirm erkannt",
    noSecondScreen: "Kein zweiter Bildschirm erkannt",
    detect: "Erkennen",
    
    translationPreview: "Übersetzungsvorschau",
    original: "Original",
    translation: "Übersetzung",
    waitingAudio: "Warte auf Audio...",
    waitingTranslation: "Warte auf Übersetzung...",
    detecting: "Erkennung...",
    portuguese: "Portugiesisch",
    english: "Englisch",
    
    audioDevice: "Audiogerät",
    selectAudioSource: "Audioquelle auswählen",
    audioDeviceDescription: "Wählen Sie das Mikrofon oder die Soundkarte zur Audioaufnahme.",
    
    delayAdjustment: "Verzögerungsanpassung",
    translationDelay: "Übersetzungsverzögerung",
    delayDescription: "Passen Sie die Verzögerung zwischen Audioaufnahme und Übersetzung an.",
    
    audioGate: "Audio-Gate (Rauschfilter)",
    gateThreshold: "Gate-Schwelle",
    gateDescription: "Das Gate filtert Geräusche unterhalb der definierten Schwelle.",
    recommended: "Empfohlener Wert: -30dB bis -20dB.",
    sensitive: "empfindlich",
    loud: "laut",

    readingSpeed: "Lesegeschwindigkeit",
    readingSpeedLabel: "Geschwindigkeit",
    readingSpeedSlow: "Langsam",
    readingSpeedNormal: "Normal",
    readingSpeedFast: "Schnell",
    readingSpeedUnit: "Z/s",
    readingSpeedDescription: "Steuert, wie lange jede Übersetzung im Fenster angezeigt wird. Niedriger = mehr Lesezeit; Höher = folgt dem Live-Audio besser.",
    
    overlayMode: "Overlay-Modus",
    overlayOtherWindows: "Andere Fenster überlagern",
    overlayDescription: "Wenn aktiviert, bleibt das Übersetzungsfenster sichtbar.",
    overlayActive: "Overlay-Modus aktiv",
    overlayActiveDescription: "Das Übersetzungsfenster öffnet sich im Popup-Modus.",
    
    slideTime: "Übersetzungsfolienzeit",
    slideDuration: "Foliendauer",
    slideDescription: "Legt fest, wie lange jede Übersetzungsfolie angezeigt wird.",
    seconds: "Sekunden",
    second: "Sekunde",
    
    translationLines: "Übersetzungszeilen",
    maxLinesPerSlide: "Maximale Zeilen pro Folie",
    linesDescription: "Legt die maximale Anzahl der Textzeilen pro Folie fest.",
    line: "Zeile",
    lines: "Zeilen",
    
    translationFontSize: "Übersetzungsschriftgröße",
    fontSize: "Schriftgröße",
    fontSizeDescription: "Legt die Schriftgröße des übersetzten Textes fest.",
    small: "klein",
    large: "groß",
    
    headerBox: "Kopfzeile",
    headerText: "Kopfzeilentext",
    footerBox: "Fußzeile",
    footerText: "Fußzeilentext",
    padding: "Abstand",
    roundCorners: "Abgerundete Ecken",
    colors: "Farben",
    text: "Text",
    background: "Hintergrund",
    preview: "Vorschau",
    on: "AN",
    off: "AUS",
    
    recentHistory: "Letzte Übersetzungen",
    
    overlayActiveIndicator: "Overlay aktiv",
    prevSlide: "Vorherige Folie",
    nextSlide: "Nächste Folie",
    goToSlide: "Zur Folie gehen",
    exitFullscreen: "Vollbild beenden",
    enterFullscreen: "Vollbild",
    closeWindow: "Fenster schließen",
    disableOverlay: "Overlay deaktivieren",
    enableOverlay: "Overlay aktivieren",
    
    gateOpen: "Gate offen - Aufnahme",
    gateClosed: "Gate geschlossen - Warte auf Signal",

    // Header / Navigation
    plans: "Pläne",
    account: "Konto",
    logout: "Abmelden",
    signUp: "Registrieren",
    guest: "Gast",
    free: "Kostenlos",
    
    // Footer
    footerCopyright: "Entwickelt von João Vitor Fernandes Farias. Alle Rechte vorbehalten.",
    backToDashboard: "Zurück zum Dashboard",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "Verwenden Sie Übersetzungen als Untertitel in Ihren Livestreams auf OBS, Streamlabs und anderer Streaming-Software.",
    obsProOnlyText: "Diese Funktion ist nur im PRO-Plan verfügbar",
    obsCustomizeLabel: "Anpassen",
    obsPositionLabel: "Position",
    obsTextShadowLabel: "Textschatten",
    obsTextShadowDesc: "Verbessert die Lesbarkeit über Videos",
    obsGenerateUrl: "URL für OBS generieren",
    obsGeneratedUrlLabel: "Generierte URL für OBS:",
    obsCopied: "URL kopiert!",
    obsPreviewBtn: "Vorschau",
    obsParamsReference: "Optionale URL-Parameter (Referenz)",
    obsParamBg: "Hintergrundfarbe",
    obsParamFontSize: "Schriftgröße (px)",
    obsParamColor: "Textfarbe (hex ohne #)",
    obsParamPosition: "Position",
    obsParamShadow: "Textschatten",
    obsSettingsPlaceholder: "Anpassungseinstellungen...",
    
    // Audio section
    audioSource: "Audioquelle",
    microphone: "Mikrofon",
    system: "System",
    both: "Beide",
    
    // Second Window
    secondTranslationWindow: "Zweites Übersetzungsfenster",
    enableSecondWindow: "Zweites Fenster aktivieren",
    optional: "Optional",
    openSecondWindowFull: "Zweites Fenster öffnen",
    splitScreenButton: "Zweites Fenster aktivieren (50/50-Teilung)",
    splitScreenSuccess: "Fenster nebeneinander auf dem zweiten Bildschirm geöffnet (50/50)",
    splitScreenNoScreen: "Zweiter Bildschirm nicht erkannt",
    splitScreenPermission: "Um Fenster auf dem zweiten Bildschirm zu positionieren, erlauben Sie den Zugriff auf 'Fensterverwaltung', wenn der Browser danach fragt (oder in den Website-Einstellungen), und klicken Sie erneut auf die Schaltfläche.",
    splitScreenPopupBlocked: "Der Browser hat das Öffnen der Fenster blockiert. Erlauben Sie Pop-ups für diese Website und klicken Sie erneut.",
    splitScreenBraveShields: "Der Browser maskiert die Bildschirmabmessungen (Anti-Fingerprint-Schutz). In Brave: Klicken Sie auf das Löwen-Symbol in der Adressleiste → Erweiterte Steuerung → 'Fingerprinting blockieren' → Deaktiviert für diese Website. Neu laden und erneut versuchen.",
    secondWindowProOnly: "Diese Funktion ist nur im PRO-Plan verfügbar",
    upgradeProSecondWindow: "Zeigen Sie Übersetzungen in einer dritten Sprache gleichzeitig an. Ideal für mehrsprachige Veranstaltungen.",
    upgradePro: "Auf PRO upgraden",
    
    // Pricing Page
    pricingTitle: "Wählen Sie Ihren Plan",
    pricingSubtitle: "Starten Sie kostenlos oder schalten Sie unbegrenzte Übersetzung mit dem PRO-Plan frei",
    planFree: "Kostenloser Plan",
    planPro: "PRO-Plan",
    currentPlan: "Aktueller Plan",
    perfectToTry: "Perfekt zum Ausprobieren",
    forProfessionalUse: "Für professionellen Einsatz",
    freePrice: "Kostenlos",
    perMonth: "/Monat",
    feature10Minutes: "10 Minuten Übersetzung pro Monat",
    featureBidirectional: "Bidirektionale Übersetzung",
    feature20Languages: "20 unterstützte Sprachen",
    featureUnlimited: "UNBEGRENZTE Übersetzung",
    feature2Screens: "Übersetzung in 2 Sprachen auf separaten Bildschirmen",
    featureOBS: "OBS-Integration für Streaming",
    featureQRCode: "Direkte Übersetzung auf dem Handy des Besuchers via QR-Code",
    startFree: "Kostenlos starten",
    alreadyPro: "Sie sind bereits PRO!",
    creditCard: "Karte",
    payWithCard: "Mit Karte bezahlen",
    loginToPay: "Zum Bezahlen anmelden",
    verifyPayment: "Zahlung verifizieren",
    amount: "Betrag",
    noConversionNeeded: "Senden Sie genau den Betrag in",
    solanaNetwork: "Solana-Netzwerk",
    sendTo: "Senden an",
    tokenOnSolana: "im Solana-Netzwerk",
    txSignatureLabel: "Transaktionssignatur (nach dem Senden)",
    txSignaturePlaceholder: "Transaktionssignatur hier einfügen",
    viewOnSolscan: "Transaktion auf Solscan anzeigen",
    addressCopied: "Adresse kopiert!",
    errorRedirectPayment: "Fehler beim Weiterleiten zur Zahlung",
    errorEnterTxSignature: "Bitte geben Sie die Transaktionssignatur ein",
    errorVerifyTx: "Fehler bei der Verifizierung der Transaktion",
    
    // OBS Integration
    obsIntegration: "OBS-Integration",
    streaming: "Streaming",
    obsDescription: "Verwenden Sie die Übersetzung als Untertitel in Ihren Livestreams. Als \"Browser Source\" in OBS hinzufügen.",
    customizeLegend: "Untertitel anpassen",
    backgroundColor: "Hintergrundfarbe",
    transparent: "Transparent",
    green: "Grün",
    blue: "Blau",
    magenta: "Magenta",
    black: "Schwarz",
    textColor: "Textfarbe",
    customize: "Anpassen",
    position: "Position",
    top: "Oben",
    center: "Mitte",
    bottom: "Unten",
    textShadow: "Textschatten",
    textShadowDescription: "Verbessert die Lesbarkeit über Videos",
    generateObsUrl: "OBS-URL generieren",
    optionalUrlParams: "Optionale URL-Parameter (Referenz)",
    obsStepByStep: "OBS Schritt für Schritt",
    obsProOnly: "Diese Funktion ist nur im PRO-Plan verfügbar",
    
    // Translation Rooms
    translationRooms: "Übersetzungsräume",
    events: "Veranstaltungen",
    createRoom: "Übersetzungsraum erstellen",
    roomDescription: "Erstellen Sie einen Raum, damit Personen bei Veranstaltungen, Kirchen oder Konferenzen über QR-Code oder Link auf ihren Geräten auf die Übersetzung zugreifen können.",
    roomProOnly: "Übersetzungsräume sind nur für PRO-Benutzer verfügbar",
    upgradeToProRooms: "Erstellen Sie einen Raum und teilen Sie einen QR-Code/Link, damit Besucher die Übersetzung auf ihren Geräten sehen können.",
    
    // Permanent Links
    permanentLinks: "Permanente Links",
    permanent: "Permanent",
    createPermanentLink: "Permanenten Link erstellen",
    permanentLinkDescription: "Erstellen Sie permanente Links für Kirchen, Konferenzen und wiederkehrende Veranstaltungen. Drucken Sie den QR-Code einmal und verwenden Sie ihn immer!",
    roomName: "Raumname",
    customCode: "Benutzerdefinierter Code",
    customCodeOptional: "optional",
    leaveEmptyToGenerate: "Leer lassen für automatische Generierung",
    linkPreview: "Link-Vorschau",
    noPermanentLinksYet: "Noch keine permanenten Links erstellt. Erstellen Sie einen permanenten Link für wiederkehrende Veranstaltungen.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR-Code - Fester Link",
    permanentLinkLabel: "Permanenter Link:",
    qrNeverChanges: "Dieser QR-Code und Link ändern sich nie! Sie können ihn drucken und für immer verwenden.",
    copyLink: "Link kopieren",
    openLink: "Öffnen",
    
    // QR Code Modal - Translation Room  
    shareRoom: "Raum teilen",
    roomCode: "Raumcode:",
    shareLink: "Link zum Teilen:",
    visitorsCanScan: "Besucher können den QR-Code scannen oder den Link aufrufen, um die Live-Übersetzung zu sehen",
    endRoomConfirm: "Sind Sie sicher, dass Sie den Raum beenden möchten? Alle Besucher werden getrennt.",
    share: "Teilen",
    
    // Room Config
    roomConfig: "Raumkonfiguration",
    presenterLanguages: "Präsentatorsprachen",
    presenterLanguagesDescription: "Wählen Sie alle Sprachen aus, die von Präsentatoren bei dieser Veranstaltung gesprochen werden.",
    presenterLanguagesTip: "Tipp: Wenn es Redner gibt, die verschiedene Sprachen sprechen, wählen Sie alle aus, um die Übersetzung zu optimieren.",
    selected: "ausgewählt",
    close: "Schließen",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "Übersetzungsraum",
    publicRoomBy: "von",
    publicRoomSelectLanguage: "Was ist Ihre Sprache?",
    publicRoomLanguageHint: "Die Übersetzung wird in der gewählten Sprache angezeigt",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "Raum nicht verfügbar",
    publicRoomBackHome: "Zurück zur Startseite",
    publicRoomConnecting: "Verbindung zum Raum wird hergestellt",
    publicRoomHeaderRoom: "Raum",
    publicRoomConnected: "Verbunden",
    publicRoomReconnecting: "Verbindung wird wiederhergestellt...",
    publicRoomChangeLanguage: "Sprache ändern",
    publicRoomSettings: "Einstellungen",
    publicRoomReadingSpeed: "Lesegeschwindigkeit",
    publicRoomReadingSpeedSlow: "Langsam",
    publicRoomReadingSpeedNormal: "Normal",
    publicRoomReadingSpeedFast: "Schnell",
    publicRoomReadingSpeedUnit: "Z/s",
    publicRoomInQueue: "in Warteschlange",
    publicRoomFontSize: "Schriftgröße",
    publicRoomBgColor: "Hintergrundfarbe",
    publicRoomTextColor: "Textfarbe",
    publicRoomShowOriginal: "Originaltext anzeigen",
    publicRoomFullscreen: "Vollbild",
    publicRoomExitFullscreen: "Vollbild beenden",
    publicRoomWaitingTranslation: "Warte auf Übersetzung...",
    publicRoomViewers: "Zuschauer",
    publicRoomViewer: "Zuschauer",
    publicRoomWaitingSession: "Warte auf Sitzungsbeginn...",
    publicRoomSessionWillStart: "Die Übersetzung startet automatisch, wenn der Präsentator beginnt.",
    publicRoomTranslating: "Übersetzen...",
    publicRoomErrorNotFound: "Raum nicht gefunden. Bitte überprüfen Sie den Code und versuchen Sie es erneut.",
    publicRoomErrorServer: "Verbindung zum Server fehlgeschlagen. Bitte versuchen Sie es erneut.",
    publicRoomSessionEnded: "Der Moderator hat die Sitzung beendet",
    publicRoomDeleted: "Dieser Raum wurde dauerhaft gelöscht.",
    
    // Output mode selection
    publicRoomSelectMode: "Wie möchten Sie die Übersetzung erhalten?",
    publicRoomModeHint: "Wählen Sie den Übersetzungsausgabemodus",
    publicRoomTextOnly: "Textübersetzung",
    publicRoomTextOnlyDesc: "Lesen Sie die Übersetzung auf dem Bildschirm",
    publicRoomTextVoice: "Text + Sprachübersetzung",
    publicRoomTextVoiceDesc: "Lesen und hören Sie die Übersetzung",
    publicRoomHeadphonesRequired: "Kopfhörer erforderlich",
    publicRoomHeadphonesOverride: "Ich habe Kopfhörer angeschlossen, aber sie wurden nicht erkannt",
    publicRoomHeadphonesNotDetected: "Verbinden Sie Kopfhörer, um diese Option zu aktivieren",
    publicRoomHeadphonesDetected: "Kopfhörer erkannt",
    publicRoomCheckingAudio: "Audiogeräte werden überprüft...",
    publicRoomSpeaking: "Spricht...",
    publicRoomVoiceEnabled: "Stimme aktiviert",
    publicRoomChangeVoice: "Übersetzer-Stimme",
    publicRoomVoiceDisabled: "Stimme deaktiviert",
    publicRoomSelectVoice: "Wählen Sie eine Stimme",
    publicRoomSelectVoiceHint: "Wählen Sie die Stimme für die gesprochene Übersetzung",
    publicRoomVoicePreview: "Vorschau",
    publicRoomNoVoicesAvailable: "Keine Stimmen für diese Sprache verfügbar",
    publicRoomVoiceSelected: "Stimme ausgewählt",
    publicRoomConfirm: "Bestätigen",
    publicRoomTestVoice: "Stimme testen",
    publicRoomNoNativeVoices: "Ihr Gerät hat keine Stimmen in {language}. Verfügbare Stimmen werden angezeigt.",
    publicRoomInstallVoices: "Um Stimmen in anderen Sprachen zu erhalten, installieren Sie Sprachpakete in den Systemeinstellungen.",
    publicRoomHowToInstallVoices: "Stimmen installieren",
    publicRoomVoiceHelpTitle: "So installieren Sie Stimmen auf Ihrem Gerät",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. Öffnen Sie Einstellungen (Win + I)\n2. Gehen Sie zu Zeit und Sprache → Sprachausgabe\n3. Klicken Sie auf \"Stimmen hinzufügen\"\n4. Wählen Sie gewünschte Sprachen\n5. Starten Sie den Browser neu",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. Öffnen Sie Systemeinstellungen\n2. Gehen Sie zu Bedienungshilfen → Gesprochene Inhalte\n3. Klicken Sie auf \"Systemstimme\"\n4. Wählen Sie \"Anpassen\"\n5. Laden Sie gewünschte Stimmen herunter",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. Öffnen Sie Einstellungen\n2. Gehen Sie zu Bedienungshilfen → Text-zu-Sprache\n3. Tippen Sie auf \"Bevorzugte Engine\"\n4. Installieren Sie zusätzliche Sprachen\n5. Starten Sie den Browser neu",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. Öffnen Sie Einstellungen\n2. Gehen Sie zu Bedienungshilfen → Gesprochene Inhalte\n3. Tippen Sie auf \"Stimmen\"\n4. Wählen Sie die gewünschte Sprache\n5. Laden Sie verfügbare Stimmen herunter",
    publicRoomVoiceHelpTip: "Tipp: Google Chrome bietet in der Regel mehr Stimmen als andere Browser.",
    publicRoomVoiceHelpClose: "Schließen",
    
    // Auth page
    authSignIn: "Anmelden",
    authSignUp: "Registrieren",
    authSignInSubtitle: "Melden Sie sich an, um den Übersetzer weiter zu nutzen",
    authSignUpSubtitle: "Erstellen Sie Ihr Konto, um zu beginnen",
    authEmail: "E-Mail",
    authPassword: "Passwort",
    authName: "Name",
    authEmailPlaceholder: "ihre@email.com",
    authPasswordPlaceholder: "Ihr Passwort",
    authNamePlaceholder: "Ihr Name",
    authOrContinueWith: "ODER FORTFAHREN MIT",
    authContinueGoogle: "Mit Google fortfahren",
    authNoAccount: "Kein Konto?",
    authHasAccount: "Bereits ein Konto?",
    authAccessAsGuest: "Als Gast zugreifen",
    authBackToHome: "Zurück zur Startseite",
    authDiagnostics: "Probleme beim Zugriff? Klicken Sie hier für Diagnose",
    authWallet: "Wallet",
    authConnectWallet: "Solana Wallet verbinden",
    authConnectWalletDesc: "Verbinden Sie Ihr Phantom Wallet für den Zugriff",
    authPhantomNotFound: "Phantom nicht gefunden",
    authInstallPhantom: "Phantom installieren",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },

  ru: {
    recordingAutoResumed: "Запись автоматически возобновлена после обновления страницы.",
    recordingResumeNeedsClick: "Запись была активна до обновления. Нажмите «Старт», чтобы продолжить — браузер требует клик для захвата системного звука.",
    authForgotPassword: "Забыли пароль?",
    authForgotTitle: "Сброс пароля",
    authForgotDesc: "Введите email, и мы отправим ссылку для создания нового пароля",
    authSendResetLink: "Отправить ссылку",
    authResetEmailSent: "Если этот email зарегистрирован, вы скоро получите ссылку. Проверьте также папку «Спам».",
    authBackToLogin: "← Назад ко входу",
    authResetTitle: "Создать новый пароль",
    authResetDesc: "Введите и подтвердите новый пароль",
    authNewPassword: "Новый пароль",
    authConfirmPassword: "Подтвердите новый пароль",
    authPasswordsMismatch: "Пароли не совпадают.",
    authPasswordTooShort: "Пароль должен содержать не менее 6 символов.",
    authResetSuccess: "Пароль изменён! Перенаправление на вход...",
    authResetInvalidToken: "Ссылка недействительна или устарела. Запросите новую.",
    authResetButton: "Сохранить новый пароль",
    authGenericError: "Произошла ошибка. Попробуйте снова.",
    selectLanguage: "Выберите ваш язык.",
    selectLanguageEn: "Select your language.",
    continue: "Продолжить",
    
    // Language Pair Selection page
    selectTranslationLanguages: "Выберите 2 языка для перевода в реальном времени",
    sourceLanguage: "Исходный язык",
    targetLanguage: "Целевой язык",
    selectTargetLanguage: "Выберите целевой язык",
    startTranslation: "Начать перевод",
    languagePairHint: "Перевод будет выполняться автоматически между этими двумя языками",
    
    // Home button
    homeButton: "Главная",
    
    appTitle: "Переводчик в реальном времени",
    appSubtitle: "Английский ↔ Бразильский португальский (Автоопределение)",
    controlTab: "Управление",
    settingsTab: "Настройки",
    
    audioInput: "Аудиовход",
    start: "Старт",
    stop: "Стоп",
    status: "Статус",
    statusIdle: "Неактивен",
    statusConnecting: "Подключение...",
    statusRecording: "Запись",
    statusError: "Ошибка",
    clickToStart: "Нажмите Старт, чтобы начать",
    processingAudio: "Обработка аудио в реальном времени...",
    openTranslationWindow: "Открыть окно перевода",
    openSecondScreen: "Открыть на втором экране",
    secondScreenDetected: "Обнаружен второй экран",
    noSecondScreen: "Второй экран не обнаружен",
    detect: "Обнаружить",
    
    translationPreview: "Предпросмотр перевода",
    original: "Оригинал",
    translation: "Перевод",
    waitingAudio: "Ожидание аудио...",
    waitingTranslation: "Ожидание перевода...",
    detecting: "Определение...",
    portuguese: "Португальский",
    english: "Английский",
    
    audioDevice: "Аудиоустройство",
    selectAudioSource: "Выберите источник аудио",
    audioDeviceDescription: "Выберите микрофон или звуковую карту для записи аудио.",
    
    delayAdjustment: "Настройка задержки",
    translationDelay: "Задержка перевода",
    delayDescription: "Настройте задержку между записью аудио и переводом.",
    
    audioGate: "Аудио-гейт (Фильтр шума)",
    gateThreshold: "Порог гейта",
    gateDescription: "Гейт фильтрует звуки ниже установленного порога.",
    recommended: "Рекомендуемое значение: от -30дБ до -20дБ.",
    sensitive: "чувствительный",
    loud: "громкий",

    readingSpeed: "Скорость чтения",
    readingSpeedLabel: "Скорость",
    readingSpeedSlow: "Медленно",
    readingSpeedNormal: "Обычная",
    readingSpeedFast: "Быстро",
    readingSpeedUnit: "зн/с",
    readingSpeedDescription: "Управляет временем отображения каждого перевода в окне. Меньше = больше времени для чтения; Больше = лучше синхронизация с прямым звуком.",
    
    overlayMode: "Режим наложения",
    overlayOtherWindows: "Поверх других окон",
    overlayDescription: "При включении окно перевода остаётся видимым.",
    overlayActive: "Режим наложения активен",
    overlayActiveDescription: "Окно перевода откроется во всплывающем режиме.",
    
    slideTime: "Время слайда перевода",
    slideDuration: "Длительность слайда",
    slideDescription: "Устанавливает время отображения каждого слайда перевода.",
    seconds: "секунд",
    second: "секунда",
    
    translationLines: "Строки перевода",
    maxLinesPerSlide: "Максимум строк на слайд",
    linesDescription: "Устанавливает максимальное количество строк текста на слайд.",
    line: "строка",
    lines: "строк",
    
    translationFontSize: "Размер шрифта перевода",
    fontSize: "Размер шрифта",
    fontSizeDescription: "Устанавливает размер шрифта переведённого текста.",
    small: "маленький",
    large: "большой",
    
    headerBox: "Верхний блок",
    headerText: "Текст заголовка",
    footerBox: "Нижний блок",
    footerText: "Текст подвала",
    padding: "Отступ",
    roundCorners: "Скруглённые углы",
    colors: "Цвета",
    text: "Текст",
    background: "Фон",
    preview: "Предпросмотр",
    on: "ВКЛ",
    off: "ВЫКЛ",
    
    recentHistory: "Недавняя история",
    
    overlayActiveIndicator: "Наложение активно",
    prevSlide: "Предыдущий слайд",
    nextSlide: "Следующий слайд",
    goToSlide: "Перейти к слайду",
    exitFullscreen: "Выйти из полноэкранного режима",
    enterFullscreen: "Полный экран",
    closeWindow: "Закрыть окно",
    disableOverlay: "Отключить наложение",
    enableOverlay: "Включить наложение",
    
    gateOpen: "Гейт открыт - Запись",
    gateClosed: "Гейт закрыт - Ожидание сигнала",

    // Header / Navigation
    plans: "Планы",
    account: "Аккаунт",
    logout: "Выйти",
    signUp: "Регистрация",
    guest: "Гость",
    free: "Бесплатно",
    
    // Footer
    footerCopyright: "Разработано João Vitor Fernandes Farias. Все права защищены.",
    backToDashboard: "Вернуться к панели",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "Используйте переводы как субтитры в прямых трансляциях на OBS, Streamlabs и других программах для стриминга.",
    obsProOnlyText: "Эта функция доступна только в плане PRO",
    obsCustomizeLabel: "Настроить",
    obsPositionLabel: "Позиция",
    obsTextShadowLabel: "Тень текста",
    obsTextShadowDesc: "Улучшает читаемость на видео",
    obsGenerateUrl: "Сгенерировать URL для OBS",
    obsGeneratedUrlLabel: "Сгенерированный URL для OBS:",
    obsCopied: "URL скопирован!",
    obsPreviewBtn: "Предпросмотр",
    obsParamsReference: "Дополнительные параметры URL (справка)",
    obsParamBg: "Цвет фона",
    obsParamFontSize: "Размер шрифта (px)",
    obsParamColor: "Цвет текста (hex без #)",
    obsParamPosition: "Позиция",
    obsParamShadow: "Тень текста",
    obsSettingsPlaceholder: "Настройки персонализации...",
    
    // Audio section
    audioSource: "Источник аудио",
    microphone: "Микрофон",
    system: "Система",
    both: "Оба",
    
    // Second Window
    secondTranslationWindow: "Второе окно перевода",
    enableSecondWindow: "Включить второе окно",
    optional: "Опционально",
    openSecondWindowFull: "Открыть второе окно",
    splitScreenButton: "Включить второе окно (разделение 50/50)",
    splitScreenSuccess: "Окна открыты рядом на втором экране (50/50)",
    splitScreenNoScreen: "Второй экран не обнаружен",
    splitScreenPermission: "Чтобы разместить окна на втором экране, разрешите доступ 'Управление окнами', когда браузер спросит (или в настройках сайта), и нажмите кнопку ещё раз.",
    splitScreenPopupBlocked: "Браузер заблокировал открытие окон. Разрешите всплывающие окна для этого сайта и нажмите ещё раз.",
    splitScreenBraveShields: "Браузер маскирует размеры экранов (защита от фингерпринтинга). В Brave: нажмите на значок льва в адресной строке → Расширенные настройки → 'Блокировать сбор цифровых отпечатков' → Отключено для этого сайта. Перезагрузите и попробуйте снова.",
    secondWindowProOnly: "Эта функция доступна только в плане PRO",
    upgradeProSecondWindow: "Показывайте переводы на третьем языке одновременно. Идеально для мероприятий с многоязычной аудиторией.",
    upgradePro: "Обновить до PRO",
    
    // Pricing Page
    pricingTitle: "Выберите свой план",
    pricingSubtitle: "Начните бесплатно или разблокируйте неограниченный перевод с планом PRO",
    planFree: "Бесплатный план",
    planPro: "План PRO",
    currentPlan: "Текущий план",
    perfectToTry: "Идеально для пробы",
    forProfessionalUse: "Для профессионального использования",
    freePrice: "Бесплатно",
    perMonth: "/месяц",
    feature10Minutes: "10 минут перевода в месяц",
    featureBidirectional: "Двунаправленный перевод",
    feature20Languages: "Поддержка 20 языков",
    featureUnlimited: "НЕОГРАНИЧЕННЫЙ перевод",
    feature2Screens: "Перевод на 2 языка на отдельных экранах",
    featureOBS: "Интеграция OBS для стриминга",
    featureQRCode: "Прямой перевод на телефон посетителя через QR-код",
    startFree: "Начать бесплатно",
    alreadyPro: "Вы уже PRO!",
    creditCard: "Карта",
    payWithCard: "Оплатить картой",
    loginToPay: "Войдите для оплаты",
    verifyPayment: "Подтвердить платёж",
    amount: "Сумма",
    noConversionNeeded: "Конвертация не требуется - отправьте точную сумму в",
    solanaNetwork: "Сеть Solana",
    sendTo: "Отправить на",
    tokenOnSolana: "в сети Solana",
    txSignatureLabel: "Подпись транзакции (после отправки)",
    txSignaturePlaceholder: "Вставьте подпись транзакции сюда",
    viewOnSolscan: "Посмотреть транзакцию на Solscan",
    addressCopied: "Адрес скопирован!",
    errorRedirectPayment: "Ошибка при перенаправлении на оплату",
    errorEnterTxSignature: "Пожалуйста, введите подпись транзакции",
    errorVerifyTx: "Ошибка при проверке транзакции",
    
    // OBS Integration
    obsIntegration: "Интеграция OBS",
    streaming: "Стриминг",
    obsDescription: "Используйте перевод как субтитры в прямых трансляциях. Добавьте как \"Browser Source\" в OBS.",
    customizeLegend: "Настроить субтитры",
    backgroundColor: "Цвет фона",
    transparent: "Прозрачный",
    green: "Зелёный",
    blue: "Синий",
    magenta: "Пурпурный",
    black: "Чёрный",
    textColor: "Цвет текста",
    customize: "Настроить",
    position: "Позиция",
    top: "Верх",
    center: "Центр",
    bottom: "Низ",
    textShadow: "Тень текста",
    textShadowDescription: "Улучшает читаемость на видео",
    generateObsUrl: "Сгенерировать URL для OBS",
    optionalUrlParams: "Дополнительные параметры URL (справка)",
    obsStepByStep: "OBS пошагово",
    obsProOnly: "Эта функция доступна только в плане PRO",
    
    // Translation Rooms
    translationRooms: "Комнаты перевода",
    events: "Мероприятия",
    createRoom: "Создать комнату перевода",
    roomDescription: "Создайте комнату, чтобы люди на мероприятиях, в церквях или на конференциях могли получить доступ к переводу на своих устройствах через QR-код или ссылку.",
    roomProOnly: "Комнаты перевода доступны только для PRO пользователей",
    upgradeToProRooms: "Создайте комнату и поделитесь QR-кодом/ссылкой, чтобы посетители могли видеть перевод на своих устройствах.",
    
    // Permanent Links
    permanentLinks: "Постоянные ссылки",
    permanent: "Постоянный",
    createPermanentLink: "Создать постоянную ссылку",
    permanentLinkDescription: "Создайте постоянные ссылки для церквей, конференций и регулярных мероприятий. Напечатайте QR-код один раз и используйте всегда!",
    roomName: "Название комнаты",
    customCode: "Пользовательский код",
    customCodeOptional: "опционально",
    leaveEmptyToGenerate: "Оставьте пустым для автоматической генерации",
    linkPreview: "Предпросмотр ссылки",
    noPermanentLinksYet: "Постоянные ссылки ещё не созданы. Создайте постоянную ссылку для регулярных мероприятий.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR-код - Постоянная ссылка",
    permanentLinkLabel: "Постоянная ссылка:",
    qrNeverChanges: "Этот QR-код и ссылка никогда не меняются! Вы можете распечатать и использовать их всегда.",
    copyLink: "Копировать ссылку",
    openLink: "Открыть",
    
    // QR Code Modal - Translation Room  
    shareRoom: "Поделиться комнатой",
    roomCode: "Код комнаты:",
    shareLink: "Ссылка для обмена:",
    visitorsCanScan: "Посетители могут отсканировать QR-код или перейти по ссылке, чтобы увидеть перевод в реальном времени",
    endRoomConfirm: "Вы уверены, что хотите закрыть комнату? Все посетители будут отключены.",
    share: "Поделиться",
    
    // Room Config
    roomConfig: "Настройки комнаты",
    presenterLanguages: "Языки докладчиков",
    presenterLanguagesDescription: "Выберите все языки, на которых будут говорить докладчики на этом мероприятии.",
    presenterLanguagesTip: "Совет: Если есть докладчики, говорящие на разных языках, выберите все для оптимизации перевода.",
    selected: "выбрано",
    close: "Закрыть",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "Комната перевода",
    publicRoomBy: "от",
    publicRoomSelectLanguage: "Какой ваш язык?",
    publicRoomLanguageHint: "Перевод будет отображаться на выбранном языке",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "Комната недоступна",
    publicRoomBackHome: "Вернуться на главную",
    publicRoomConnecting: "Подключение к комнате",
    publicRoomHeaderRoom: "Комната",
    publicRoomConnected: "Подключено",
    publicRoomReconnecting: "Переподключение...",
    publicRoomChangeLanguage: "Сменить язык",
    publicRoomSettings: "Настройки",
    publicRoomReadingSpeed: "Скорость чтения",
    publicRoomReadingSpeedSlow: "Медленно",
    publicRoomReadingSpeedNormal: "Обычная",
    publicRoomReadingSpeedFast: "Быстро",
    publicRoomReadingSpeedUnit: "зн/с",
    publicRoomInQueue: "в очереди",
    publicRoomFontSize: "Размер шрифта",
    publicRoomBgColor: "Цвет фона",
    publicRoomTextColor: "Цвет текста",
    publicRoomShowOriginal: "Показать оригинальный текст",
    publicRoomFullscreen: "Полноэкранный режим",
    publicRoomExitFullscreen: "Выйти из полноэкранного режима",
    publicRoomWaitingTranslation: "Ожидание перевода...",
    publicRoomViewers: "зрителей",
    publicRoomViewer: "зритель",
    publicRoomWaitingSession: "Ожидание начала сессии...",
    publicRoomSessionWillStart: "Перевод начнётся автоматически, когда ведущий начнёт.",
    publicRoomTranslating: "Перевод...",
    publicRoomErrorNotFound: "Комната не найдена. Пожалуйста, проверьте код и попробуйте снова.",
    publicRoomErrorServer: "Не удалось подключиться к серверу. Пожалуйста, попробуйте снова.",
    publicRoomSessionEnded: "Ведущий завершил сессию",
    publicRoomDeleted: "Эта комната была удалена навсегда.",
    
    // Output mode selection
    publicRoomSelectMode: "Как вы хотите получать перевод?",
    publicRoomModeHint: "Выберите режим вывода перевода",
    publicRoomTextOnly: "Текстовый перевод",
    publicRoomTextOnlyDesc: "Читайте перевод на экране",
    publicRoomTextVoice: "Текст + голосовой перевод",
    publicRoomTextVoiceDesc: "Читайте и слушайте перевод",
    publicRoomHeadphonesRequired: "Требуются наушники",
    publicRoomHeadphonesOverride: "У меня подключены наушники, но они не обнаружены",
    publicRoomHeadphonesNotDetected: "Подключите наушники, чтобы включить эту опцию",
    publicRoomHeadphonesDetected: "Наушники обнаружены",
    publicRoomCheckingAudio: "Проверка аудиоустройств...",
    publicRoomSpeaking: "Говорит...",
    publicRoomVoiceEnabled: "Голос включен",
    publicRoomChangeVoice: "Голос переводчика",
    publicRoomVoiceDisabled: "Голос отключен",
    publicRoomSelectVoice: "Выберите голос",
    publicRoomSelectVoiceHint: "Выберите голос для озвучивания перевода",
    publicRoomVoicePreview: "Предпросмотр",
    publicRoomNoVoicesAvailable: "Нет голосов для этого языка",
    publicRoomVoiceSelected: "Голос выбран",
    publicRoomConfirm: "Подтвердить",
    publicRoomTestVoice: "Тест голоса",
    publicRoomNoNativeVoices: "На вашем устройстве нет голосов на {language}. Показаны доступные голоса.",
    publicRoomInstallVoices: "Чтобы получить голоса на других языках, установите языковые пакеты в настройках системы.",
    publicRoomHowToInstallVoices: "Как установить голоса",
    publicRoomVoiceHelpTitle: "Как установить голоса на вашем устройстве",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. Откройте Параметры (Win + I)\n2. Перейдите в Время и язык → Речь\n3. Нажмите \"Добавить голоса\"\n4. Выберите нужные языки\n5. Перезапустите браузер",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. Откройте Системные настройки\n2. Перейдите в Универсальный доступ → Устный контент\n3. Нажмите \"Системный голос\"\n4. Выберите \"Настроить\"\n5. Загрузите нужные голоса",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. Откройте Настройки\n2. Перейдите в Специальные возможности → Синтез речи\n3. Нажмите \"Предпочтительный движок\"\n4. Установите дополнительные языки\n5. Перезапустите браузер",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. Откройте Настройки\n2. Перейдите в Универсальный доступ → Устный контент\n3. Нажмите \"Голоса\"\n4. Выберите нужный язык\n5. Загрузите доступные голоса",
    publicRoomVoiceHelpTip: "Совет: Google Chrome обычно предлагает больше голосов, чем другие браузеры.",
    publicRoomVoiceHelpClose: "Закрыть",
    
    // Auth page
    authSignIn: "Войти",
    authSignUp: "Регистрация",
    authSignInSubtitle: "Войдите, чтобы продолжить использование переводчика",
    authSignUpSubtitle: "Создайте аккаунт, чтобы начать",
    authEmail: "Email",
    authPassword: "Пароль",
    authName: "Имя",
    authEmailPlaceholder: "ваш@email.com",
    authPasswordPlaceholder: "Ваш пароль",
    authNamePlaceholder: "Ваше имя",
    authOrContinueWith: "ИЛИ ПРОДОЛЖИТЬ С",
    authContinueGoogle: "Продолжить с Google",
    authNoAccount: "Нет аккаунта?",
    authHasAccount: "Уже есть аккаунт?",
    authAccessAsGuest: "Войти как гость",
    authBackToHome: "Вернуться на главную",
    authDiagnostics: "Проблемы с доступом? Нажмите здесь для диагностики",
    authWallet: "Кошелёк",
    authConnectWallet: "Подключить Solana кошелёк",
    authConnectWalletDesc: "Подключите ваш Phantom кошелёк для доступа",
    authPhantomNotFound: "Phantom не найден",
    authInstallPhantom: "Установить Phantom",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },

  ja: {
    recordingAutoResumed: "ページ更新後、録音を自動的に再開しました。",
    recordingResumeNeedsClick: "更新前に録音が有効でした。再開するには「開始」をクリックしてください。システム音声の取得にはクリックが必要です。",
    authForgotPassword: "パスワードをお忘れですか？",
    authForgotTitle: "パスワードをリセット",
    authForgotDesc: "メールアドレスを入力すると、新しいパスワードを作成するリンクを送信します",
    authSendResetLink: "リセットリンクを送信",
    authResetEmailSent: "このメールが登録されていれば、まもなくリンクが届きます。迷惑メールフォルダもご確認ください。",
    authBackToLogin: "← ログインに戻る",
    authResetTitle: "新しいパスワードを作成",
    authResetDesc: "新しいパスワードを入力して確認してください",
    authNewPassword: "新しいパスワード",
    authConfirmPassword: "新しいパスワードを確認",
    authPasswordsMismatch: "パスワードが一致しません。",
    authPasswordTooShort: "パスワードは6文字以上にしてください。",
    authResetSuccess: "パスワードをリセットしました！ログインへ移動します...",
    authResetInvalidToken: "リンクが無効または期限切れです。新しいリンクを要求してください。",
    authResetButton: "新しいパスワードを保存",
    authGenericError: "エラーが発生しました。もう一度お試しください。",
    selectLanguage: "言語を選択してください。",
    selectLanguageEn: "Select your language.",
    continue: "続行",
    
    // Language Pair Selection page
    selectTranslationLanguages: "リアルタイム翻訳の2つの言語を選択",
    sourceLanguage: "ソース言語",
    targetLanguage: "ターゲット言語",
    selectTargetLanguage: "ターゲット言語を選択",
    startTranslation: "翻訳を開始",
    languagePairHint: "これら2つの言語間で自動的に翻訳されます",
    
    // Home button
    homeButton: "ホーム",
    
    appTitle: "リアルタイム翻訳",
    appSubtitle: "英語 ↔ ブラジルポルトガル語（自動検出）",
    controlTab: "コントロール",
    settingsTab: "設定",
    
    audioInput: "オーディオ入力",
    start: "開始",
    stop: "停止",
    status: "ステータス",
    statusIdle: "待機中",
    statusConnecting: "接続中...",
    statusRecording: "録音中",
    statusError: "エラー",
    clickToStart: "開始をクリックして始める",
    processingAudio: "リアルタイムで音声を処理中...",
    openTranslationWindow: "翻訳ウィンドウを開く",
    openSecondScreen: "セカンドスクリーンで開く",
    secondScreenDetected: "セカンドスクリーン検出",
    noSecondScreen: "セカンドスクリーンなし",
    detect: "検出",
    
    translationPreview: "翻訳プレビュー",
    original: "原文",
    translation: "翻訳",
    waitingAudio: "音声を待機中...",
    waitingTranslation: "翻訳を待機中...",
    detecting: "検出中...",
    portuguese: "ポルトガル語",
    english: "英語",
    
    audioDevice: "オーディオデバイス",
    selectAudioSource: "オーディオソースを選択",
    audioDeviceDescription: "音声をキャプチャするマイクまたはサウンドカードを選択します。",
    
    delayAdjustment: "遅延調整",
    translationDelay: "翻訳遅延",
    delayDescription: "音声キャプチャと翻訳の間の遅延を調整します。",
    
    audioGate: "オーディオゲート（ノイズフィルター）",
    gateThreshold: "ゲートしきい値",
    gateDescription: "ゲートは定義されたしきい値以下の音をフィルタリングします。",
    recommended: "推奨値：-30dBから-20dB。",
    sensitive: "敏感",
    loud: "大きい",

    readingSpeed: "読書速度",
    readingSpeedLabel: "速度",
    readingSpeedSlow: "遅い",
    readingSpeedNormal: "普通",
    readingSpeedFast: "速い",
    readingSpeedUnit: "字/秒",
    readingSpeedDescription: "各翻訳がウィンドウに表示される時間を制御します。低い = 読書時間が長い; 高い = ライブ音声によく追従する。",
    
    overlayMode: "オーバーレイモード",
    overlayOtherWindows: "他のウィンドウの上に表示",
    overlayDescription: "有効にすると、翻訳ウィンドウが常に表示されます。",
    overlayActive: "オーバーレイモード有効",
    overlayActiveDescription: "翻訳ウィンドウがポップアップモードで開きます。",
    
    slideTime: "翻訳スライド時間",
    slideDuration: "スライド表示時間",
    slideDescription: "各翻訳スライドの表示時間を設定します。",
    seconds: "秒",
    second: "秒",
    
    translationLines: "翻訳行数",
    maxLinesPerSlide: "スライドあたりの最大行数",
    linesDescription: "各スライドに表示されるテキストの最大行数を設定します。",
    line: "行",
    lines: "行",
    
    translationFontSize: "翻訳フォントサイズ",
    fontSize: "フォントサイズ",
    fontSizeDescription: "翻訳テキストのフォントサイズを設定します。",
    small: "小",
    large: "大",
    
    headerBox: "ヘッダーボックス",
    headerText: "ヘッダーテキスト",
    footerBox: "フッターボックス",
    footerText: "フッターテキスト",
    padding: "パディング",
    roundCorners: "角丸",
    colors: "色",
    text: "テキスト",
    background: "背景",
    preview: "プレビュー",
    on: "オン",
    off: "オフ",
    
    recentHistory: "最近の履歴",
    
    overlayActiveIndicator: "オーバーレイ有効",
    prevSlide: "前のスライド",
    nextSlide: "次のスライド",
    goToSlide: "スライドへ移動",
    exitFullscreen: "全画面終了",
    enterFullscreen: "全画面",
    closeWindow: "ウィンドウを閉じる",
    disableOverlay: "オーバーレイ無効",
    enableOverlay: "オーバーレイ有効",
    
    gateOpen: "ゲート開 - 録音中",
    gateClosed: "ゲート閉 - 信号待機中",

    // Header / Navigation
    plans: "プラン",
    account: "アカウント",
    logout: "ログアウト",
    signUp: "サインアップ",
    guest: "ゲスト",
    free: "無料",
    
    // Footer
    footerCopyright: "João Vitor Fernandes Farias により開発。全著作権所有。",
    backToDashboard: "ダッシュボードに戻る",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "OBS、Streamlabs、その他のストリーミングソフトウェアでライブ配信に翻訳を字幕として使用します。",
    obsProOnlyText: "この機能はPROプランでのみ利用可能です",
    obsCustomizeLabel: "カスタマイズ",
    obsPositionLabel: "位置",
    obsTextShadowLabel: "テキストシャドウ",
    obsTextShadowDesc: "動画上の読みやすさを向上させます",
    obsGenerateUrl: "OBS用URLを生成",
    obsGeneratedUrlLabel: "生成されたOBS URL：",
    obsCopied: "URLをコピーしました！",
    obsPreviewBtn: "プレビュー",
    obsParamsReference: "オプションのURLパラメータ（参考）",
    obsParamBg: "背景色",
    obsParamFontSize: "フォントサイズ（px）",
    obsParamColor: "テキスト色（#なしの16進数）",
    obsParamPosition: "位置",
    obsParamShadow: "テキストシャドウ",
    obsSettingsPlaceholder: "カスタマイズ設定...",
    
    // Audio section
    audioSource: "オーディオソース",
    microphone: "マイク",
    system: "システム",
    both: "両方",
    
    // Second Window
    secondTranslationWindow: "第2翻訳ウィンドウ",
    enableSecondWindow: "第2ウィンドウを有効にする",
    optional: "オプション",
    openSecondWindowFull: "第2ウィンドウを開く",
    splitScreenButton: "第2ウィンドウを有効にする（50/50分割）",
    splitScreenSuccess: "第2画面にウィンドウを並べて開きました（50/50）",
    splitScreenNoScreen: "第2画面が検出されませんでした",
    splitScreenPermission: "第2画面にウィンドウを配置するには、ブラウザが確認したときに「ウィンドウ管理」のアクセスを許可し（またはサイト設定で）、もう一度ボタンをクリックしてください。",
    splitScreenPopupBlocked: "ブラウザがウィンドウの表示をブロックしました。このサイトのポップアップを許可して、もう一度クリックしてください。",
    splitScreenBraveShields: "ブラウザが画面サイズをマスキングしています（フィンガープリント保護）。Braveの場合：アドレスバーのライオンアイコン → 詳細コントロール → 「フィンガープリンティングをブロック」→ このサイトでは無効に設定。再読み込みして再試行してください。",
    secondWindowProOnly: "この機能はPROプランでのみ利用可能です",
    upgradeProSecondWindow: "第3言語の翻訳を同時に表示します。多言語の観客がいるイベントに最適です。",
    upgradePro: "PROにアップグレード",
    
    // Pricing Page
    pricingTitle: "プランを選択",
    pricingSubtitle: "無料で始めるか、PROプランで無制限翻訳をアンロック",
    planFree: "無料プラン",
    planPro: "PROプラン",
    currentPlan: "現在のプラン",
    perfectToTry: "お試しに最適",
    forProfessionalUse: "プロフェッショナル向け",
    freePrice: "無料",
    perMonth: "/月",
    feature10Minutes: "月10分の翻訳",
    featureBidirectional: "双方向翻訳",
    feature20Languages: "20言語対応",
    featureUnlimited: "無制限翻訳",
    feature2Screens: "別画面で2言語に翻訳",
    featureOBS: "ストリーミング用OBS連携",
    featureQRCode: "QRコードで訪問者のスマホに直接翻訳",
    startFree: "無料で始める",
    alreadyPro: "すでにPROです！",
    creditCard: "カード",
    payWithCard: "カードで支払う",
    loginToPay: "支払いにログイン",
    verifyPayment: "支払いを確認",
    amount: "金額",
    noConversionNeeded: "正確な金額を送金",
    solanaNetwork: "Solanaネットワーク",
    sendTo: "送金先",
    tokenOnSolana: "Solanaネットワーク上",
    txSignatureLabel: "トランザクション署名（送金後）",
    txSignaturePlaceholder: "トランザクション署名をここに貼り付け",
    viewOnSolscan: "Solscanでトランザクションを確認",
    addressCopied: "アドレスをコピーしました！",
    errorRedirectPayment: "支払いへのリダイレクトエラー",
    errorEnterTxSignature: "トランザクション署名を入力してください",
    errorVerifyTx: "トランザクション確認エラー",
    
    // OBS Integration
    obsIntegration: "OBS連携",
    streaming: "ストリーミング",
    obsDescription: "ライブ配信で翻訳を字幕として使用します。OBSで「ブラウザソース」として追加してください。",
    customizeLegend: "字幕をカスタマイズ",
    backgroundColor: "背景色",
    transparent: "透明",
    green: "緑",
    blue: "青",
    magenta: "マゼンタ",
    black: "黒",
    textColor: "テキストの色",
    customize: "カスタマイズ",
    position: "位置",
    top: "上",
    center: "中央",
    bottom: "下",
    textShadow: "テキストシャドウ",
    textShadowDescription: "動画上での可読性を向上させます",
    generateObsUrl: "OBS URLを生成",
    optionalUrlParams: "オプションのURLパラメータ（参照）",
    obsStepByStep: "OBSステップバイステップ",
    obsProOnly: "この機能はPROプランでのみ利用可能です",
    
    // Translation Rooms
    translationRooms: "翻訳ルーム",
    events: "イベント",
    createRoom: "翻訳ルームを作成",
    roomDescription: "イベント、教会、会議の参加者がQRコードまたはリンクで自分のデバイスから翻訳にアクセスできるルームを作成します。",
    roomProOnly: "翻訳ルームはPROユーザー限定です",
    upgradeToProRooms: "ルームを作成してQRコード/リンクを共有し、訪問者が自分のデバイスで翻訳を見られるようにします。",
    
    // Permanent Links
    permanentLinks: "固定リンク",
    permanent: "永続",
    createPermanentLink: "固定リンクを作成",
    permanentLinkDescription: "教会、会議、定期イベント用の永続リンクを作成します。QRコードを一度印刷すれば、ずっと使えます！",
    roomName: "ルーム名",
    customCode: "カスタムコード",
    customCodeOptional: "オプション",
    leaveEmptyToGenerate: "自動生成するには空欄のままにしてください",
    linkPreview: "リンクプレビュー",
    noPermanentLinksYet: "固定リンクはまだ作成されていません。定期イベント用の固定リンクを作成してください。",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QRコード - 固定リンク",
    permanentLinkLabel: "固定リンク：",
    qrNeverChanges: "このQRコードとリンクは永遠に変わりません！印刷してずっと使えます。",
    copyLink: "リンクをコピー",
    openLink: "開く",
    
    // QR Code Modal - Translation Room  
    shareRoom: "ルームを共有",
    roomCode: "ルームコード：",
    shareLink: "共有リンク：",
    visitorsCanScan: "訪問者はQRコードをスキャンするか、リンクにアクセスしてリアルタイム翻訳を見ることができます",
    endRoomConfirm: "ルームを終了してもよろしいですか？すべての訪問者が切断されます。",
    share: "共有",
    
    // Room Config
    roomConfig: "ルーム設定",
    presenterLanguages: "プレゼンター言語",
    presenterLanguagesDescription: "このイベントでプレゼンターが話すすべての言語を選択してください。",
    presenterLanguagesTip: "ヒント：異なる言語を話すスピーカーがいる場合は、翻訳を最適化するためにすべて選択してください。",
    selected: "選択済み",
    close: "閉じる",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "翻訳ルーム",
    publicRoomBy: "提供",
    publicRoomSelectLanguage: "あなたの言語は何ですか？",
    publicRoomLanguageHint: "翻訳は選択した言語で表示されます",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "ルームは利用できません",
    publicRoomBackHome: "ホームに戻る",
    publicRoomConnecting: "ルームに接続中",
    publicRoomHeaderRoom: "ルーム",
    publicRoomConnected: "接続済み",
    publicRoomReconnecting: "再接続中...",
    publicRoomChangeLanguage: "言語を変更",
    publicRoomSettings: "設定",
    publicRoomReadingSpeed: "読書速度",
    publicRoomReadingSpeedSlow: "遅い",
    publicRoomReadingSpeedNormal: "普通",
    publicRoomReadingSpeedFast: "速い",
    publicRoomReadingSpeedUnit: "字/秒",
    publicRoomInQueue: "キュー内",
    publicRoomFontSize: "フォントサイズ",
    publicRoomBgColor: "背景色",
    publicRoomTextColor: "文字色",
    publicRoomShowOriginal: "原文を表示",
    publicRoomFullscreen: "フルスクリーン",
    publicRoomExitFullscreen: "フルスクリーンを終了",
    publicRoomWaitingTranslation: "翻訳を待っています...",
    publicRoomViewers: "視聴者",
    publicRoomViewer: "視聴者",
    publicRoomWaitingSession: "セッション開始を待っています...",
    publicRoomSessionWillStart: "プレゼンターが開始すると翻訳が自動的に始まります。",
    publicRoomTranslating: "翻訳中...",
    publicRoomErrorNotFound: "ルームが見つかりません。コードを確認して再試行してください。",
    publicRoomErrorServer: "サーバーへの接続に失敗しました。再試行してください。",
    publicRoomSessionEnded: "プレゼンターがセッションを終了しました",
    publicRoomDeleted: "このルームは完全に削除されました。",
    
    // Output mode selection
    publicRoomSelectMode: "翻訳をどのように受け取りたいですか？",
    publicRoomModeHint: "翻訳出力モードを選択",
    publicRoomTextOnly: "テキスト翻訳",
    publicRoomTextOnlyDesc: "画面で翻訳を読む",
    publicRoomTextVoice: "テキスト + 音声翻訳",
    publicRoomTextVoiceDesc: "翻訳を読んで聞く",
    publicRoomHeadphonesRequired: "ヘッドフォンが必要です",
    publicRoomHeadphonesOverride: "ヘッドフォンは接続されていますが検出されませんでした",
    publicRoomHeadphonesNotDetected: "このオプションを有効にするにはヘッドフォンを接続してください",
    publicRoomHeadphonesDetected: "ヘッドフォンを検出しました",
    publicRoomCheckingAudio: "オーディオデバイスを確認中...",
    publicRoomSpeaking: "再生中...",
    publicRoomVoiceEnabled: "音声有効",
    publicRoomChangeVoice: "翻訳者の声",
    publicRoomVoiceDisabled: "音声無効",
    publicRoomSelectVoice: "音声を選択",
    publicRoomSelectVoiceHint: "音声翻訳の声を選択してください",
    publicRoomVoicePreview: "プレビュー",
    publicRoomNoVoicesAvailable: "この言語の音声はありません",
    publicRoomVoiceSelected: "音声が選択されました",
    publicRoomConfirm: "確認",
    publicRoomTestVoice: "音声テスト",
    publicRoomNoNativeVoices: "お使いのデバイスには{language}の音声がありません。利用可能な音声を表示しています。",
    publicRoomInstallVoices: "他の言語の音声を取得するには、システム設定で言語パックをインストールしてください。",
    publicRoomHowToInstallVoices: "音声のインストール方法",
    publicRoomVoiceHelpTitle: "デバイスに音声をインストールする方法",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. 設定を開く (Win + I)\n2. 時刻と言語 → 音声認識 に移動\n3. \"音声を追加\" をクリック\n4. 必要な言語を選択\n5. ブラウザを再起動",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. システム環境設定を開く\n2. アクセシビリティ → 読み上げコンテンツ に移動\n3. \"システムの声\" をクリック\n4. \"カスタマイズ\" を選択\n5. 必要な音声をダウンロード",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. 設定を開く\n2. ユーザー補助 → テキスト読み上げ に移動\n3. \"優先エンジン\" をタップ\n4. 追加の言語をインストール\n5. ブラウザを再起動",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. 設定を開く\n2. アクセシビリティ → 読み上げコンテンツ に移動\n3. \"声\" をタップ\n4. 必要な言語を選択\n5. 利用可能な音声をダウンロード",
    publicRoomVoiceHelpTip: "ヒント：Google Chrome は通常、他のブラウザより多くの音声を提供しています。",
    publicRoomVoiceHelpClose: "閉じる",
    
    // Auth page
    authSignIn: "サインイン",
    authSignUp: "サインアップ",
    authSignInSubtitle: "翻訳機を引き続き使用するにはサインインしてください",
    authSignUpSubtitle: "アカウントを作成して開始しましょう",
    authEmail: "メール",
    authPassword: "パスワード",
    authName: "名前",
    authEmailPlaceholder: "your@email.com",
    authPasswordPlaceholder: "パスワード",
    authNamePlaceholder: "お名前",
    authOrContinueWith: "または以下で続行",
    authContinueGoogle: "Googleで続行",
    authNoAccount: "アカウントをお持ちでないですか？",
    authHasAccount: "すでにアカウントをお持ちですか？",
    authAccessAsGuest: "ゲストとしてアクセス",
    authBackToHome: "ホームに戻る",
    authDiagnostics: "アクセスに問題がありますか？診断はこちらをクリック",
    authWallet: "ウォレット",
    authConnectWallet: "Solanaウォレットを接続",
    authConnectWalletDesc: "アクセスするにはPhantomウォレットを接続してください",
    authPhantomNotFound: "Phantomが見つかりません",
    authInstallPhantom: "Phantomをインストール",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },

  ko: {
    recordingAutoResumed: "페이지 새로 고침 후 녹음이 자동으로 재개되었습니다.",
    recordingResumeNeedsClick: "새로 고침 전에 녹음이 활성화되어 있었습니다. 재개하려면 시작을 클릭하세요. 시스템 오디오 캡처에는 클릭이 필요합니다.",
    authForgotPassword: "비밀번호를 잊으셨나요?",
    authForgotTitle: "비밀번호 재설정",
    authForgotDesc: "이메일을 입력하시면 새 비밀번호 생성 링크를 보내드립니다",
    authSendResetLink: "재설정 링크 보내기",
    authResetEmailSent: "이 이메일이 등록되어 있다면 곧 링크를 받게 됩니다. 스팸 폴더도 확인해 주세요.",
    authBackToLogin: "← 로그인으로 돌아가기",
    authResetTitle: "새 비밀번호 만들기",
    authResetDesc: "새 비밀번호를 입력하고 확인하세요",
    authNewPassword: "새 비밀번호",
    authConfirmPassword: "새 비밀번호 확인",
    authPasswordsMismatch: "비밀번호가 일치하지 않습니다.",
    authPasswordTooShort: "비밀번호는 6자 이상이어야 합니다.",
    authResetSuccess: "비밀번호가 재설정되었습니다! 로그인으로 이동합니다...",
    authResetInvalidToken: "링크가 유효하지 않거나 만료되었습니다. 새 링크를 요청하세요.",
    authResetButton: "새 비밀번호 저장",
    authGenericError: "오류가 발생했습니다. 다시 시도해 주세요.",
    selectLanguage: "언어를 선택하세요.",
    selectLanguageEn: "Select your language.",
    continue: "계속",
    
    // Language Pair Selection page
    selectTranslationLanguages: "실시간 번역을 위한 2개 언어 선택",
    sourceLanguage: "원본 언어",
    targetLanguage: "대상 언어",
    selectTargetLanguage: "대상 언어 선택",
    startTranslation: "번역 시작",
    languagePairHint: "이 두 언어 간에 자동으로 번역됩니다",
    
    // Home button
    homeButton: "홈",
    
    appTitle: "실시간 번역기",
    appSubtitle: "영어 ↔ 브라질 포르투갈어 (자동 감지)",
    controlTab: "제어",
    settingsTab: "설정",
    
    audioInput: "오디오 입력",
    start: "시작",
    stop: "정지",
    status: "상태",
    statusIdle: "대기 중",
    statusConnecting: "연결 중...",
    statusRecording: "녹음 중",
    statusError: "오류",
    clickToStart: "시작을 클릭하세요",
    processingAudio: "실시간 오디오 처리 중...",
    openTranslationWindow: "번역 창 열기",
    openSecondScreen: "두 번째 화면에서 열기",
    secondScreenDetected: "두 번째 화면 감지됨",
    noSecondScreen: "두 번째 화면 없음",
    detect: "감지",
    
    translationPreview: "번역 미리보기",
    original: "원본",
    translation: "번역",
    waitingAudio: "오디오 대기 중...",
    waitingTranslation: "번역 대기 중...",
    detecting: "감지 중...",
    portuguese: "포르투갈어",
    english: "영어",
    
    audioDevice: "오디오 장치",
    selectAudioSource: "오디오 소스 선택",
    audioDeviceDescription: "오디오를 캡처할 마이크 또는 사운드 카드를 선택하세요.",
    
    delayAdjustment: "지연 조정",
    translationDelay: "번역 지연",
    delayDescription: "오디오 캡처와 번역 사이의 지연을 조정합니다.",
    
    audioGate: "오디오 게이트 (노이즈 필터)",
    gateThreshold: "게이트 임계값",
    gateDescription: "게이트는 정의된 임계값 이하의 소리를 필터링합니다.",
    recommended: "권장 값: -30dB ~ -20dB.",
    sensitive: "민감",
    loud: "큰 소리",

    readingSpeed: "읽기 속도",
    readingSpeedLabel: "속도",
    readingSpeedSlow: "느림",
    readingSpeedNormal: "보통",
    readingSpeedFast: "빠름",
    readingSpeedUnit: "자/초",
    readingSpeedDescription: "각 번역이 창에 표시되는 시간을 제어합니다. 낮음 = 더 많은 읽기 시간; 높음 = 실시간 오디오와 더 잘 동기화.",
    
    overlayMode: "오버레이 모드",
    overlayOtherWindows: "다른 창 위에 표시",
    overlayDescription: "활성화하면 번역 창이 항상 표시됩니다.",
    overlayActive: "오버레이 모드 활성화",
    overlayActiveDescription: "번역 창이 팝업 모드로 열립니다.",
    
    slideTime: "번역 슬라이드 시간",
    slideDuration: "슬라이드 지속 시간",
    slideDescription: "각 번역 슬라이드의 표시 시간을 설정합니다.",
    seconds: "초",
    second: "초",
    
    translationLines: "번역 줄 수",
    maxLinesPerSlide: "슬라이드당 최대 줄 수",
    linesDescription: "각 슬라이드에 표시되는 최대 텍스트 줄 수를 설정합니다.",
    line: "줄",
    lines: "줄",
    
    translationFontSize: "번역 글꼴 크기",
    fontSize: "글꼴 크기",
    fontSizeDescription: "번역된 텍스트의 글꼴 크기를 설정합니다.",
    small: "작게",
    large: "크게",
    
    headerBox: "헤더 박스",
    headerText: "헤더 텍스트",
    footerBox: "푸터 박스",
    footerText: "푸터 텍스트",
    padding: "패딩",
    roundCorners: "둥근 모서리",
    colors: "색상",
    text: "텍스트",
    background: "배경",
    preview: "미리보기",
    on: "켜기",
    off: "끄기",
    
    recentHistory: "최근 기록",
    
    overlayActiveIndicator: "오버레이 활성화",
    prevSlide: "이전 슬라이드",
    nextSlide: "다음 슬라이드",
    goToSlide: "슬라이드로 이동",
    exitFullscreen: "전체 화면 종료",
    enterFullscreen: "전체 화면",
    closeWindow: "창 닫기",
    disableOverlay: "오버레이 비활성화",
    enableOverlay: "오버레이 활성화",
    
    gateOpen: "게이트 열림 - 녹음 중",
    gateClosed: "게이트 닫힘 - 신호 대기 중",

    // Header / Navigation
    plans: "요금제",
    account: "계정",
    logout: "로그아웃",
    signUp: "가입하기",
    guest: "게스트",
    free: "무료",
    
    // Footer
    footerCopyright: "João Vitor Fernandes Farias 개발. 모든 권리 보유.",
    backToDashboard: "대시보드로 돌아가기",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "OBS, Streamlabs 및 기타 스트리밍 소프트웨어에서 라이브 방송에 번역을 자막으로 사용합니다.",
    obsProOnlyText: "이 기능은 PRO 플랜에서만 사용 가능합니다",
    obsCustomizeLabel: "사용자 정의",
    obsPositionLabel: "위치",
    obsTextShadowLabel: "텍스트 그림자",
    obsTextShadowDesc: "동영상에서의 가독성을 향상시킵니다",
    obsGenerateUrl: "OBS용 URL 생성",
    obsGeneratedUrlLabel: "생성된 OBS URL:",
    obsCopied: "URL이 복사되었습니다!",
    obsPreviewBtn: "미리보기",
    obsParamsReference: "선택적 URL 매개변수 (참조)",
    obsParamBg: "배경색",
    obsParamFontSize: "글꼴 크기 (px)",
    obsParamColor: "텍스트 색상 (# 없이 16진수)",
    obsParamPosition: "위치",
    obsParamShadow: "텍스트 그림자",
    obsSettingsPlaceholder: "사용자 정의 설정...",
    
    // Audio section
    audioSource: "오디오 소스",
    microphone: "마이크",
    system: "시스템",
    both: "둘 다",
    
    // Second Window
    secondTranslationWindow: "두 번째 번역 창",
    enableSecondWindow: "두 번째 창 활성화",
    optional: "선택사항",
    openSecondWindowFull: "두 번째 창 열기",
    splitScreenButton: "두 번째 창 활성화 (50/50 분할)",
    splitScreenSuccess: "두 번째 화면에 창이 나란히 열렸습니다 (50/50)",
    splitScreenNoScreen: "두 번째 화면이 감지되지 않았습니다",
    splitScreenPermission: "두 번째 화면에 창을 배치하려면 브라우저에서 '창 관리' 접근을 허용하고(또는 사이트 설정에서) 버튼을 다시 클릭하세요.",
    splitScreenPopupBlocked: "브라우저가 창 열기를 차단했습니다. 이 사이트의 팝업을 허용하고 다시 클릭하세요.",
    splitScreenBraveShields: "브라우저가 화면 크기를 가리고 있습니다(핑거프린트 방지 보호). Brave에서: 주소창의 사자 아이콘 클릭 → 고급 제어 → '핑거프린팅 차단' → 이 사이트에서 사용 안 함. 새로고침 후 다시 시도하세요.",
    secondWindowProOnly: "이 기능은 PRO 플랜에서만 사용 가능합니다",
    upgradeProSecondWindow: "제3언어 번역을 동시에 표시합니다. 다국어 청중이 있는 이벤트에 이상적입니다.",
    upgradePro: "PRO로 업그레이드",
    
    // Pricing Page
    pricingTitle: "플랜 선택",
    pricingSubtitle: "무료로 시작하거나 PRO 플랜으로 무제한 번역 잠금 해제",
    planFree: "무료 플랜",
    planPro: "PRO 플랜",
    currentPlan: "현재 플랜",
    perfectToTry: "체험에 딱 좋음",
    forProfessionalUse: "전문가용",
    freePrice: "무료",
    perMonth: "/월",
    feature10Minutes: "월 10분 번역",
    featureBidirectional: "양방향 번역",
    feature20Languages: "20개 언어 지원",
    featureUnlimited: "무제한 번역",
    feature2Screens: "별도 화면에서 2개 언어로 번역",
    featureOBS: "스트리밍용 OBS 통합",
    featureQRCode: "QR 코드로 방문자 휴대폰에 직접 번역",
    startFree: "무료로 시작",
    alreadyPro: "이미 PRO입니다!",
    creditCard: "카드",
    payWithCard: "카드로 결제",
    loginToPay: "결제를 위해 로그인",
    verifyPayment: "결제 확인",
    amount: "금액",
    noConversionNeeded: "환전 불필요 - 정확한 금액 전송",
    solanaNetwork: "Solana 네트워크",
    sendTo: "보내기",
    tokenOnSolana: "Solana 네트워크에서",
    txSignatureLabel: "거래 서명 (전송 후)",
    txSignaturePlaceholder: "거래 서명을 여기에 붙여넣기",
    viewOnSolscan: "Solscan에서 거래 보기",
    addressCopied: "주소가 복사되었습니다!",
    errorRedirectPayment: "결제 리디렉션 오류",
    errorEnterTxSignature: "거래 서명을 입력하세요",
    errorVerifyTx: "거래 확인 오류",
    
    // OBS Integration
    obsIntegration: "OBS 통합",
    streaming: "스트리밍",
    obsDescription: "라이브 스트림에서 번역을 자막으로 사용하세요. OBS에서 \"브라우저 소스\"로 추가하세요.",
    customizeLegend: "자막 사용자 지정",
    backgroundColor: "배경색",
    transparent: "투명",
    green: "녹색",
    blue: "파란색",
    magenta: "마젠타",
    black: "검정",
    textColor: "텍스트 색상",
    customize: "사용자 지정",
    position: "위치",
    top: "상단",
    center: "중앙",
    bottom: "하단",
    textShadow: "텍스트 그림자",
    textShadowDescription: "동영상에서 가독성을 향상시킵니다",
    generateObsUrl: "OBS URL 생성",
    optionalUrlParams: "선택적 URL 매개변수(참조)",
    obsStepByStep: "OBS 단계별 가이드",
    obsProOnly: "이 기능은 PRO 플랜에서만 사용 가능합니다",
    
    // Translation Rooms
    translationRooms: "번역 룸",
    events: "이벤트",
    createRoom: "번역 룸 만들기",
    roomDescription: "이벤트, 교회 또는 회의 참석자가 QR 코드 또는 링크를 통해 자신의 기기에서 번역에 액세스할 수 있는 룸을 만드세요.",
    roomProOnly: "번역 룸은 PRO 사용자 전용입니다",
    upgradeToProRooms: "룸을 만들고 QR 코드/링크를 공유하여 방문자가 자신의 기기에서 번역을 볼 수 있도록 하세요.",
    
    // Permanent Links
    permanentLinks: "고정 링크",
    permanent: "영구",
    createPermanentLink: "고정 링크 만들기",
    permanentLinkDescription: "교회, 회의 및 정기 이벤트를 위한 영구 링크를 만드세요. QR 코드를 한 번 인쇄하고 항상 사용하세요!",
    roomName: "룸 이름",
    customCode: "사용자 지정 코드",
    customCodeOptional: "선택사항",
    leaveEmptyToGenerate: "자동 생성하려면 비워두세요",
    linkPreview: "링크 미리보기",
    noPermanentLinksYet: "아직 고정 링크가 없습니다. 정기 이벤트를 위한 고정 링크를 만드세요.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR 코드 - 고정 링크",
    permanentLinkLabel: "고정 링크:",
    qrNeverChanges: "이 QR 코드와 링크는 영원히 변하지 않습니다! 인쇄해서 항상 사용하세요.",
    copyLink: "링크 복사",
    openLink: "열기",
    
    // QR Code Modal - Translation Room  
    shareRoom: "룸 공유",
    roomCode: "룸 코드:",
    shareLink: "공유 링크:",
    visitorsCanScan: "방문자는 QR 코드를 스캔하거나 링크에 접속하여 실시간 번역을 볼 수 있습니다",
    endRoomConfirm: "룸을 종료하시겠습니까? 모든 방문자의 연결이 끊어집니다.",
    share: "공유",
    
    // Room Config
    roomConfig: "룸 설정",
    presenterLanguages: "발표자 언어",
    presenterLanguagesDescription: "이 이벤트에서 발표자가 사용할 모든 언어를 선택하세요.",
    presenterLanguagesTip: "팁: 다른 언어를 사용하는 발표자가 있다면 번역을 최적화하기 위해 모두 선택하세요.",
    selected: "선택됨",
    close: "닫기",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "번역 룸",
    publicRoomBy: "제공",
    publicRoomSelectLanguage: "당신의 언어는 무엇인가요?",
    publicRoomLanguageHint: "번역이 선택한 언어로 표시됩니다",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "룸 사용 불가",
    publicRoomBackHome: "홈으로 돌아가기",
    publicRoomConnecting: "룸에 연결 중",
    publicRoomHeaderRoom: "룸",
    publicRoomConnected: "연결됨",
    publicRoomReconnecting: "재연결 중...",
    publicRoomChangeLanguage: "언어 변경",
    publicRoomSettings: "설정",
    publicRoomReadingSpeed: "읽기 속도",
    publicRoomReadingSpeedSlow: "느림",
    publicRoomReadingSpeedNormal: "보통",
    publicRoomReadingSpeedFast: "빠름",
    publicRoomReadingSpeedUnit: "자/초",
    publicRoomInQueue: "대기 중",
    publicRoomFontSize: "글꼴 크기",
    publicRoomBgColor: "배경색",
    publicRoomTextColor: "글자색",
    publicRoomShowOriginal: "원문 표시",
    publicRoomFullscreen: "전체 화면",
    publicRoomExitFullscreen: "전체 화면 종료",
    publicRoomWaitingTranslation: "번역 대기 중...",
    publicRoomViewers: "시청자",
    publicRoomViewer: "시청자",
    publicRoomWaitingSession: "세션 시작 대기 중...",
    publicRoomSessionWillStart: "발표자가 시작하면 번역이 자동으로 시작됩니다.",
    publicRoomTranslating: "번역 중...",
    publicRoomErrorNotFound: "방을 찾을 수 없습니다. 코드를 확인하고 다시 시도해 주세요.",
    publicRoomErrorServer: "서버 연결에 실패했습니다. 다시 시도해 주세요.",
    publicRoomSessionEnded: "발표자가 세션을 종료했습니다",
    publicRoomDeleted: "이 방은 영구적으로 삭제되었습니다.",
    
    // Output mode selection
    publicRoomSelectMode: "번역을 어떻게 받으시겠습니까?",
    publicRoomModeHint: "번역 출력 모드 선택",
    publicRoomTextOnly: "텍스트 번역",
    publicRoomTextOnlyDesc: "화면에서 번역 읽기",
    publicRoomTextVoice: "텍스트 + 음성 번역",
    publicRoomTextVoiceDesc: "번역을 읽고 듣기",
    publicRoomHeadphonesRequired: "이어폰 필요",
    publicRoomHeadphonesOverride: "이어폰이 연결되어 있지만 감지되지 않았습니다",
    publicRoomHeadphonesNotDetected: "이 옵션을 활성화하려면 이어폰을 연결하세요",
    publicRoomHeadphonesDetected: "이어폰 감지됨",
    publicRoomCheckingAudio: "오디오 장치 확인 중...",
    publicRoomSpeaking: "재생 중...",
    publicRoomVoiceEnabled: "음성 활성화",
    publicRoomChangeVoice: "번역기 음성",
    publicRoomVoiceDisabled: "음성 비활성화",
    publicRoomSelectVoice: "음성 선택",
    publicRoomSelectVoiceHint: "음성 번역에 사용할 목소리를 선택하세요",
    publicRoomVoicePreview: "미리보기",
    publicRoomNoVoicesAvailable: "이 언어에 사용할 수 있는 음성이 없습니다",
    publicRoomVoiceSelected: "음성 선택됨",
    publicRoomConfirm: "확인",
    publicRoomTestVoice: "음성 테스트",
    publicRoomNoNativeVoices: "기기에 {language} 음성이 없습니다. 사용 가능한 음성을 표시합니다.",
    publicRoomInstallVoices: "다른 언어의 음성을 얻으려면 시스템 설정에서 언어 팩을 설치하세요.",
    publicRoomHowToInstallVoices: "음성 설치 방법",
    publicRoomVoiceHelpTitle: "기기에 음성을 설치하는 방법",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. 설정 열기 (Win + I)\n2. 시간 및 언어 → 음성으로 이동\n3. \"음성 추가\" 클릭\n4. 원하는 언어 선택\n5. 브라우저 다시 시작",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. 시스템 환경설정 열기\n2. 손쉬운 사용 → 음성 콘텐츠로 이동\n3. \"시스템 음성\" 클릭\n4. \"사용자화\" 선택\n5. 원하는 음성 다운로드",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. 설정 열기\n2. 접근성 → 텍스트 음성 변환으로 이동\n3. \"선호하는 엔진\" 탭\n4. 추가 언어 설치\n5. 브라우저 다시 시작",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. 설정 열기\n2. 손쉬운 사용 → 음성 콘텐츠로 이동\n3. \"음성\" 탭\n4. 원하는 언어 선택\n5. 사용 가능한 음성 다운로드",
    publicRoomVoiceHelpTip: "팁: Google Chrome은 일반적으로 다른 브라우저보다 더 많은 음성을 제공합니다.",
    publicRoomVoiceHelpClose: "닫기",
    
    // Auth page
    authSignIn: "로그인",
    authSignUp: "가입",
    authSignInSubtitle: "번역기를 계속 사용하려면 로그인하세요",
    authSignUpSubtitle: "시작하려면 계정을 만드세요",
    authEmail: "이메일",
    authPassword: "비밀번호",
    authName: "이름",
    authEmailPlaceholder: "your@email.com",
    authPasswordPlaceholder: "비밀번호",
    authNamePlaceholder: "이름",
    authOrContinueWith: "또는 계속하기",
    authContinueGoogle: "Google로 계속하기",
    authNoAccount: "계정이 없으신가요?",
    authHasAccount: "이미 계정이 있으신가요?",
    authAccessAsGuest: "게스트로 접속하기",
    authBackToHome: "홈으로 돌아가기",
    authDiagnostics: "접속에 문제가 있나요? 진단을 위해 여기를 클릭하세요",
    authWallet: "지갑",
    authConnectWallet: "Solana 지갑 연결",
    authConnectWalletDesc: "접속하려면 Phantom 지갑을 연결하세요",
    authPhantomNotFound: "Phantom을 찾을 수 없습니다",
    authInstallPhantom: "Phantom 설치",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },

  ar: {
    recordingAutoResumed: "تم استئناف التسجيل تلقائيًا بعد تحديث الصفحة.",
    recordingResumeNeedsClick: "كان التسجيل نشطًا قبل التحديث. انقر على ابدأ للاستئناف — يتطلب المتصفح نقرة لالتقاط صوت النظام.",
    authForgotPassword: "هل نسيت كلمة المرور؟",
    authForgotTitle: "إعادة تعيين كلمة المرور",
    authForgotDesc: "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإنشاء كلمة مرور جديدة",
    authSendResetLink: "إرسال رابط إعادة التعيين",
    authResetEmailSent: "إذا كان هذا البريد مسجلاً، ستصلك رسالة برابط قريبًا. تحقق أيضًا من مجلد الرسائل غير المرغوبة.",
    authBackToLogin: "← العودة إلى تسجيل الدخول",
    authResetTitle: "إنشاء كلمة مرور جديدة",
    authResetDesc: "أدخل كلمة المرور الجديدة وأكدها",
    authNewPassword: "كلمة المرور الجديدة",
    authConfirmPassword: "تأكيد كلمة المرور الجديدة",
    authPasswordsMismatch: "كلمتا المرور غير متطابقتين.",
    authPasswordTooShort: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
    authResetSuccess: "تمت إعادة تعيين كلمة المرور! جارٍ التوجيه إلى تسجيل الدخول...",
    authResetInvalidToken: "الرابط غير صالح أو منتهي الصلاحية. اطلب رابطًا جديدًا.",
    authResetButton: "حفظ كلمة المرور الجديدة",
    authGenericError: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    selectLanguage: "اختر لغتك.",
    selectLanguageEn: "Select your language.",
    continue: "متابعة",
    
    // Language Pair Selection page
    selectTranslationLanguages: "اختر اللغتين للترجمة الفورية",
    sourceLanguage: "اللغة المصدر",
    targetLanguage: "اللغة الهدف",
    selectTargetLanguage: "اختر اللغة الهدف",
    startTranslation: "بدء الترجمة",
    languagePairHint: "ستتم الترجمة تلقائيًا بين هاتين اللغتين",
    
    // Home button
    homeButton: "الرئيسية",
    
    appTitle: "مترجم فوري",
    appSubtitle: "الإنجليزية ↔ البرتغالية البرازيلية (كشف تلقائي)",
    controlTab: "التحكم",
    settingsTab: "الإعدادات",
    
    audioInput: "إدخال الصوت",
    start: "بدء",
    stop: "إيقاف",
    status: "الحالة",
    statusIdle: "خامل",
    statusConnecting: "جاري الاتصال...",
    statusRecording: "تسجيل",
    statusError: "خطأ",
    clickToStart: "انقر على بدء للبدء",
    processingAudio: "معالجة الصوت في الوقت الفعلي...",
    openTranslationWindow: "فتح نافذة الترجمة",
    openSecondScreen: "فتح على الشاشة الثانية",
    secondScreenDetected: "تم اكتشاف شاشة ثانية",
    noSecondScreen: "لا توجد شاشة ثانية",
    detect: "اكتشاف",
    
    translationPreview: "معاينة الترجمة",
    original: "الأصلي",
    translation: "الترجمة",
    waitingAudio: "في انتظار الصوت...",
    waitingTranslation: "في انتظار الترجمة...",
    detecting: "جاري الكشف...",
    portuguese: "البرتغالية",
    english: "الإنجليزية",
    
    audioDevice: "جهاز الصوت",
    selectAudioSource: "اختر مصدر الصوت",
    audioDeviceDescription: "اختر الميكروفون أو بطاقة الصوت لالتقاط الصوت.",
    
    delayAdjustment: "ضبط التأخير",
    translationDelay: "تأخير الترجمة",
    delayDescription: "اضبط التأخير بين التقاط الصوت والترجمة.",
    
    audioGate: "بوابة الصوت (مرشح الضوضاء)",
    gateThreshold: "عتبة البوابة",
    gateDescription: "تقوم البوابة بتصفية الأصوات تحت العتبة المحددة.",
    recommended: "القيمة الموصى بها: -30dB إلى -20dB.",
    sensitive: "حساس",
    loud: "عالٍ",

    readingSpeed: "سرعة القراءة",
    readingSpeedLabel: "السرعة",
    readingSpeedSlow: "بطيء",
    readingSpeedNormal: "عادي",
    readingSpeedFast: "سريع",
    readingSpeedUnit: "حرف/ث",
    readingSpeedDescription: "يتحكم في المدة التي تبقى فيها كل ترجمة على النافذة. أقل = وقت قراءة أطول؛ أعلى = يواكب الصوت المباشر بشكل أفضل.",
    
    overlayMode: "وضع التراكب",
    overlayOtherWindows: "فوق النوافذ الأخرى",
    overlayDescription: "عند التفعيل، تبقى نافذة الترجمة مرئية.",
    overlayActive: "وضع التراكب نشط",
    overlayActiveDescription: "ستفتح نافذة الترجمة في وضع منبثق.",
    
    slideTime: "وقت شريحة الترجمة",
    slideDuration: "مدة الشريحة",
    slideDescription: "يحدد مدة عرض كل شريحة ترجمة.",
    seconds: "ثواني",
    second: "ثانية",
    
    translationLines: "أسطر الترجمة",
    maxLinesPerSlide: "الحد الأقصى للأسطر لكل شريحة",
    linesDescription: "يحدد الحد الأقصى لعدد أسطر النص لكل شريحة.",
    line: "سطر",
    lines: "أسطر",
    
    translationFontSize: "حجم خط الترجمة",
    fontSize: "حجم الخط",
    fontSizeDescription: "يحدد حجم خط النص المترجم.",
    small: "صغير",
    large: "كبير",
    
    headerBox: "صندوق الرأس",
    headerText: "نص الرأس",
    footerBox: "صندوق التذييل",
    footerText: "نص التذييل",
    padding: "الحشو",
    roundCorners: "زوايا دائرية",
    colors: "الألوان",
    text: "النص",
    background: "الخلفية",
    preview: "معاينة",
    on: "تشغيل",
    off: "إيقاف",
    
    recentHistory: "السجل الأخير",
    
    overlayActiveIndicator: "التراكب نشط",
    prevSlide: "الشريحة السابقة",
    nextSlide: "الشريحة التالية",
    goToSlide: "الذهاب إلى الشريحة",
    exitFullscreen: "الخروج من ملء الشاشة",
    enterFullscreen: "ملء الشاشة",
    closeWindow: "إغلاق النافذة",
    disableOverlay: "تعطيل التراكب",
    enableOverlay: "تفعيل التراكب",
    
    gateOpen: "البوابة مفتوحة - تسجيل",
    gateClosed: "البوابة مغلقة - في انتظار الإشارة",

    // Header / Navigation
    plans: "الخطط",
    account: "الحساب",
    logout: "تسجيل الخروج",
    signUp: "التسجيل",
    guest: "ضيف",
    free: "مجاني",
    
    // Footer
    footerCopyright: "طور بواسطة João Vitor Fernandes Farias. جميع الحقوق محفوظة.",
    backToDashboard: "العودة إلى لوحة التحكم",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "استخدم الترجمات كعناوين فرعية في البث المباشر على OBS وStreamlabs وبرامج البث الأخرى.",
    obsProOnlyText: "هذه الميزة متاحة فقط في خطة PRO",
    obsCustomizeLabel: "تخصيص",
    obsPositionLabel: "الموضع",
    obsTextShadowLabel: "ظل النص",
    obsTextShadowDesc: "يحسن قابلية القراءة على الفيديو",
    obsGenerateUrl: "إنشاء URL لـ OBS",
    obsGeneratedUrlLabel: "URL المُنشأ لـ OBS:",
    obsCopied: "تم نسخ URL!",
    obsPreviewBtn: "معاينة",
    obsParamsReference: "معلمات URL اختيارية (مرجع)",
    obsParamBg: "لون الخلفية",
    obsParamFontSize: "حجم الخط (px)",
    obsParamColor: "لون النص (hex بدون #)",
    obsParamPosition: "الموضع",
    obsParamShadow: "ظل النص",
    obsSettingsPlaceholder: "إعدادات التخصيص...",
    
    // Audio section
    audioSource: "مصدر الصوت",
    microphone: "الميكروفون",
    system: "النظام",
    both: "كلاهما",
    
    // Second Window
    secondTranslationWindow: "نافذة الترجمة الثانية",
    enableSecondWindow: "تفعيل النافذة الثانية",
    optional: "اختياري",
    openSecondWindowFull: "فتح النافذة الثانية",
    splitScreenButton: "تفعيل النافذة الثانية (تقسيم 50/50)",
    splitScreenSuccess: "تم فتح النوافذ جنبًا إلى جنب على الشاشة الثانية (50/50)",
    splitScreenNoScreen: "لم يتم اكتشاف الشاشة الثانية",
    splitScreenPermission: "لوضع النوافذ على الشاشة الثانية، اسمح بالوصول إلى 'إدارة النوافذ' عندما يطلب المتصفح (أو في إعدادات الموقع) وانقر على الزر مرة أخرى.",
    splitScreenPopupBlocked: "منع المتصفح فتح النوافذ. اسمح بالنوافذ المنبثقة لهذا الموقع وانقر مرة أخرى.",
    splitScreenBraveShields: "المتصفح يخفي أبعاد الشاشات (حماية ضد البصمة الرقمية). في Brave: انقر على أيقونة الأسد في شريط العناوين → عناصر التحكم المتقدمة → 'حظر البصمة الرقمية' → معطل لهذا الموقع. أعد التحميل وحاول مرة أخرى.",
    secondWindowProOnly: "هذه الميزة متاحة فقط في خطة PRO",
    upgradeProSecondWindow: "اعرض الترجمات بلغة ثالثة في وقت واحد. مثالي للفعاليات مع جمهور متعدد اللغات.",
    upgradePro: "ترقية إلى PRO",
    
    // Pricing Page
    pricingTitle: "اختر خطتك",
    pricingSubtitle: "ابدأ مجاناً أو افتح الترجمة غير المحدودة مع خطة PRO",
    planFree: "الخطة المجانية",
    planPro: "خطة PRO",
    currentPlan: "الخطة الحالية",
    perfectToTry: "مثالي للتجربة",
    forProfessionalUse: "للاستخدام المهني",
    freePrice: "مجاناً",
    perMonth: "/شهر",
    feature10Minutes: "10 دقائق ترجمة شهرياً",
    featureBidirectional: "ترجمة ثنائية الاتجاه",
    feature20Languages: "دعم 20 لغة",
    featureUnlimited: "ترجمة غير محدودة",
    feature2Screens: "ترجمة إلى لغتين على شاشات منفصلة",
    featureOBS: "تكامل OBS للبث المباشر",
    featureQRCode: "ترجمة مباشرة على هاتف الزائر عبر رمز QR",
    startFree: "ابدأ مجاناً",
    alreadyPro: "أنت بالفعل PRO!",
    creditCard: "بطاقة",
    payWithCard: "الدفع بالبطاقة",
    loginToPay: "سجل دخول للدفع",
    verifyPayment: "تحقق من الدفع",
    amount: "المبلغ",
    noConversionNeeded: "أرسل المبلغ الدقيق بـ",
    solanaNetwork: "شبكة Solana",
    sendTo: "أرسل إلى",
    tokenOnSolana: "على شبكة Solana",
    txSignatureLabel: "توقيع المعاملة (بعد الإرسال)",
    txSignaturePlaceholder: "الصق توقيع المعاملة هنا",
    viewOnSolscan: "عرض المعاملة على Solscan",
    addressCopied: "تم نسخ العنوان!",
    errorRedirectPayment: "خطأ في إعادة التوجيه للدفع",
    errorEnterTxSignature: "يرجى إدخال توقيع المعاملة",
    errorVerifyTx: "خطأ في التحقق من المعاملة",
    
    // OBS Integration
    obsIntegration: "تكامل OBS",
    streaming: "البث المباشر",
    obsDescription: "استخدم الترجمة كعناوين فرعية في البث المباشر. أضفها كـ \"Browser Source\" في OBS.",
    customizeLegend: "تخصيص العناوين الفرعية",
    backgroundColor: "لون الخلفية",
    transparent: "شفاف",
    green: "أخضر",
    blue: "أزرق",
    magenta: "أرجواني",
    black: "أسود",
    textColor: "لون النص",
    customize: "تخصيص",
    position: "الموضع",
    top: "أعلى",
    center: "وسط",
    bottom: "أسفل",
    textShadow: "ظل النص",
    textShadowDescription: "يحسن قابلية القراءة على الفيديو",
    generateObsUrl: "إنشاء رابط OBS",
    optionalUrlParams: "معلمات URL اختيارية (مرجع)",
    obsStepByStep: "OBS خطوة بخطوة",
    obsProOnly: "هذه الميزة متاحة فقط في خطة PRO",
    
    // Translation Rooms
    translationRooms: "غرف الترجمة",
    events: "الفعاليات",
    createRoom: "إنشاء غرفة ترجمة",
    roomDescription: "أنشئ غرفة ليتمكن الحاضرون في الفعاليات والكنائس أو المؤتمرات من الوصول إلى الترجمة على أجهزتهم عبر رمز QR أو رابط.",
    roomProOnly: "غرف الترجمة متاحة فقط لمستخدمي PRO",
    upgradeToProRooms: "أنشئ غرفة وشارك رمز QR/رابط ليتمكن الزوار من رؤية الترجمة على أجهزتهم.",
    
    // Permanent Links
    permanentLinks: "روابط ثابتة",
    permanent: "دائم",
    createPermanentLink: "إنشاء رابط ثابت",
    permanentLinkDescription: "أنشئ روابط دائمة للكنائس والمؤتمرات والفعاليات المتكررة. اطبع رمز QR مرة واحدة واستخدمه دائماً!",
    roomName: "اسم الغرفة",
    customCode: "رمز مخصص",
    customCodeOptional: "اختياري",
    leaveEmptyToGenerate: "اتركه فارغاً للإنشاء التلقائي",
    linkPreview: "معاينة الرابط",
    noPermanentLinksYet: "لم يتم إنشاء روابط ثابتة بعد. أنشئ رابطاً ثابتاً للفعاليات المتكررة.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "رمز QR - رابط ثابت",
    permanentLinkLabel: "الرابط الثابت:",
    qrNeverChanges: "رمز QR والرابط لا يتغيران أبداً! يمكنك طباعته واستخدامه دائماً.",
    copyLink: "نسخ الرابط",
    openLink: "فتح",
    
    // QR Code Modal - Translation Room  
    shareRoom: "مشاركة الغرفة",
    roomCode: "رمز الغرفة:",
    shareLink: "رابط المشاركة:",
    visitorsCanScan: "يمكن للزوار مسح رمز QR أو الوصول إلى الرابط لرؤية الترجمة المباشرة",
    endRoomConfirm: "هل أنت متأكد من إغلاق الغرفة؟ سيتم قطع اتصال جميع الزوار.",
    share: "مشاركة",
    
    // Room Config
    roomConfig: "إعدادات الغرفة",
    presenterLanguages: "لغات المقدمين",
    presenterLanguagesDescription: "حدد جميع اللغات التي سيتحدث بها المقدمون في هذا الحدث.",
    presenterLanguagesTip: "نصيحة: إذا كان هناك متحدثون يتحدثون لغات مختلفة، حدد الكل لتحسين الترجمة.",
    selected: "محدد",
    close: "إغلاق",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "غرفة الترجمة",
    publicRoomBy: "من",
    publicRoomSelectLanguage: "ما هي لغتك؟",
    publicRoomLanguageHint: "سيتم عرض الترجمة باللغة المختارة",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "الغرفة غير متاحة",
    publicRoomBackHome: "العودة للرئيسية",
    publicRoomConnecting: "جاري الاتصال بالغرفة",
    publicRoomHeaderRoom: "غرفة",
    publicRoomConnected: "متصل",
    publicRoomReconnecting: "إعادة الاتصال...",
    publicRoomChangeLanguage: "تغيير اللغة",
    publicRoomSettings: "الإعدادات",
    publicRoomReadingSpeed: "سرعة القراءة",
    publicRoomReadingSpeedSlow: "بطيء",
    publicRoomReadingSpeedNormal: "عادي",
    publicRoomReadingSpeedFast: "سريع",
    publicRoomReadingSpeedUnit: "حرف/ث",
    publicRoomInQueue: "في الطابور",
    publicRoomFontSize: "حجم الخط",
    publicRoomBgColor: "لون الخلفية",
    publicRoomTextColor: "لون النص",
    publicRoomShowOriginal: "إظهار النص الأصلي",
    publicRoomFullscreen: "ملء الشاشة",
    publicRoomExitFullscreen: "الخروج من ملء الشاشة",
    publicRoomWaitingTranslation: "في انتظار الترجمة...",
    publicRoomViewers: "مشاهدين",
    publicRoomViewer: "مشاهد",
    publicRoomWaitingSession: "في انتظار بدء الجلسة...",
    publicRoomSessionWillStart: "ستبدأ الترجمة تلقائياً عندما يبدأ المقدم.",
    publicRoomTranslating: "جاري الترجمة...",
    publicRoomErrorNotFound: "الغرفة غير موجودة. يرجى التحقق من الرمز والمحاولة مرة أخرى.",
    publicRoomErrorServer: "فشل الاتصال بالخادم. يرجى المحاولة مرة أخرى.",
    publicRoomSessionEnded: "أنهى المقدم الجلسة",
    publicRoomDeleted: "تم حذف هذه الغرفة بشكل دائم.",
    
    // Output mode selection
    publicRoomSelectMode: "كيف تريد استلام الترجمة؟",
    publicRoomModeHint: "اختر وضع إخراج الترجمة",
    publicRoomTextOnly: "ترجمة نصية",
    publicRoomTextOnlyDesc: "اقرأ الترجمة على الشاشة",
    publicRoomTextVoice: "ترجمة نصية + صوتية",
    publicRoomTextVoiceDesc: "اقرأ واستمع للترجمة",
    publicRoomHeadphonesRequired: "سماعات مطلوبة",
    publicRoomHeadphonesOverride: "لدي سماعات متصلة لكن لم يتم اكتشافها",
    publicRoomHeadphonesNotDetected: "قم بتوصيل سماعات لتفعيل هذا الخيار",
    publicRoomHeadphonesDetected: "تم اكتشاف سماعات",
    publicRoomCheckingAudio: "جاري فحص أجهزة الصوت...",
    publicRoomSpeaking: "يتحدث...",
    publicRoomVoiceEnabled: "الصوت مفعل",
    publicRoomChangeVoice: "صوت المترجم",
    publicRoomVoiceDisabled: "الصوت معطل",
    publicRoomSelectVoice: "اختر صوتًا",
    publicRoomSelectVoiceHint: "اختر الصوت للترجمة المنطوقة",
    publicRoomVoicePreview: "معاينة",
    publicRoomNoVoicesAvailable: "لا توجد أصوات متاحة لهذه اللغة",
    publicRoomVoiceSelected: "تم اختيار الصوت",
    publicRoomConfirm: "تأكيد",
    publicRoomTestVoice: "اختبار الصوت",
    publicRoomNoNativeVoices: "جهازك لا يحتوي على أصوات بـ{language}. عرض الأصوات المتاحة.",
    publicRoomInstallVoices: "للحصول على أصوات بلغات أخرى، قم بتثبيت حزم اللغات في إعدادات النظام.",
    publicRoomHowToInstallVoices: "كيفية تثبيت الأصوات",
    publicRoomVoiceHelpTitle: "كيفية تثبيت الأصوات على جهازك",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. افتح الإعدادات (Win + I)\n2. انتقل إلى الوقت واللغة → الكلام\n3. انقر على \"إضافة أصوات\"\n4. حدد اللغات المطلوبة\n5. أعد تشغيل المتصفح",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. افتح تفضيلات النظام\n2. انتقل إلى إمكانية الوصول → المحتوى المنطوق\n3. انقر على \"صوت النظام\"\n4. حدد \"تخصيص\"\n5. قم بتنزيل الأصوات المطلوبة",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. افتح الإعدادات\n2. انتقل إلى إمكانية الوصول → تحويل النص إلى كلام\n3. اضغط على \"المحرك المفضل\"\n4. قم بتثبيت لغات إضافية\n5. أعد تشغيل المتصفح",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. افتح الإعدادات\n2. انتقل إلى إمكانية الوصول → المحتوى المنطوق\n3. اضغط على \"الأصوات\"\n4. حدد اللغة المطلوبة\n5. قم بتنزيل الأصوات المتاحة",
    publicRoomVoiceHelpTip: "نصيحة: يوفر Google Chrome عادةً أصواتًا أكثر من المتصفحات الأخرى.",
    publicRoomVoiceHelpClose: "إغلاق",
    
    // Auth page
    authSignIn: "تسجيل الدخول",
    authSignUp: "إنشاء حساب",
    authSignInSubtitle: "سجل دخولك لمتابعة استخدام المترجم",
    authSignUpSubtitle: "أنشئ حسابك للبدء",
    authEmail: "البريد الإلكتروني",
    authPassword: "كلمة المرور",
    authName: "الاسم",
    authEmailPlaceholder: "your@email.com",
    authPasswordPlaceholder: "كلمة المرور",
    authNamePlaceholder: "اسمك",
    authOrContinueWith: "أو تابع باستخدام",
    authContinueGoogle: "المتابعة مع Google",
    authNoAccount: "ليس لديك حساب؟",
    authHasAccount: "لديك حساب بالفعل؟",
    authAccessAsGuest: "الدخول كضيف",
    authBackToHome: "العودة للرئيسية",
    authDiagnostics: "مشاكل في الوصول؟ انقر هنا للتشخيص",
    authWallet: "المحفظة",
    authConnectWallet: "ربط محفظة Solana",
    authConnectWalletDesc: "اربط محفظة Phantom للوصول",
    authPhantomNotFound: "Phantom غير موجود",
    authInstallPhantom: "تثبيت Phantom",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  },

  fil: {
    recordingAutoResumed: "Awtomatikong ipinagpatuloy ang recording pagkatapos i-refresh ang page.",
    recordingResumeNeedsClick: "Aktibo ang recording bago mag-refresh. I-click ang Start para ipagpatuloy — kailangan ng click ng browser para makuha ang system audio.",
    authForgotPassword: "Nakalimutan ang password?",
    authForgotTitle: "I-reset ang password",
    authForgotDesc: "Ilagay ang iyong email at magpapadala kami ng link para gumawa ng bagong password",
    authSendResetLink: "Ipadala ang reset link",
    authResetEmailSent: "Kung nakarehistro ang email na ito, makakatanggap ka ng link sa ilang sandali. Tingnan din ang spam folder.",
    authBackToLogin: "← Bumalik sa login",
    authResetTitle: "Gumawa ng bagong password",
    authResetDesc: "Ilagay at kumpirmahin ang bagong password",
    authNewPassword: "Bagong password",
    authConfirmPassword: "Kumpirmahin ang bagong password",
    authPasswordsMismatch: "Hindi magkatugma ang mga password.",
    authPasswordTooShort: "Dapat hindi bababa sa 6 na character ang password.",
    authResetSuccess: "Na-reset ang password! Inililipat sa login...",
    authResetInvalidToken: "Hindi wasto o expired na ang link. Humiling ng bago.",
    authResetButton: "I-save ang bagong password",
    authGenericError: "May naganap na error. Pakisubukan muli.",
    selectLanguage: "Piliin ang iyong wika.",
    selectLanguageEn: "Select your language.",
    continue: "Magpatuloy",
    
    // Language Pair Selection page
    selectTranslationLanguages: "Pumili ng 2 wika para sa Real-Time Translation",
    sourceLanguage: "Pinagmulang Wika",
    targetLanguage: "Target na Wika",
    selectTargetLanguage: "Piliin ang target na wika",
    startTranslation: "Simulan ang Pagsasalin",
    languagePairHint: "Awtomatikong isasalin sa pagitan ng dalawang wikang ito",
    
    // Home button
    homeButton: "Simula",
    
    appTitle: "Real-time na Tagasalin",
    appSubtitle: "Ingles ↔ Brazilian Portuguese (Auto detection)",
    controlTab: "Kontrol",
    settingsTab: "Mga Setting",
    
    audioInput: "Audio Input",
    start: "Simula",
    stop: "Itigil",
    status: "Katayuan",
    statusIdle: "Hindi aktibo",
    statusConnecting: "Kumokonekta...",
    statusRecording: "Nagre-record",
    statusError: "May Error",
    clickToStart: "I-click ang Simula para magsimula",
    processingAudio: "Pinoproseso ang audio sa real-time...",
    openTranslationWindow: "Buksan ang Translation Window",
    openSecondScreen: "Buksan sa Pangalawang Screen",
    secondScreenDetected: "May nakitang pangalawang screen",
    noSecondScreen: "Walang pangalawang screen",
    detect: "I-detect",
    
    translationPreview: "Preview ng Pagsasalin",
    original: "Orihinal",
    translation: "Pagsasalin",
    waitingAudio: "Naghihintay ng audio...",
    waitingTranslation: "Naghihintay ng pagsasalin...",
    detecting: "Dine-detect...",
    portuguese: "Portuguese",
    english: "Ingles",
    
    audioDevice: "Audio Device",
    selectAudioSource: "Pumili ng audio source",
    audioDeviceDescription: "Pumili ng mikropono o sound card para sa pagkuha ng audio.",
    
    delayAdjustment: "Pag-aayos ng Delay",
    translationDelay: "Delay ng pagsasalin",
    delayDescription: "I-adjust ang delay sa pagitan ng pagkuha ng audio at pagsasalin.",
    
    audioGate: "Audio Gate (Noise Filter)",
    gateThreshold: "Gate Threshold",
    gateDescription: "Ang gate ay nagfi-filter ng mga tunog sa ilalim ng tinukoy na threshold.",
    recommended: "Inirerekomendang halaga: -30dB hanggang -20dB.",
    sensitive: "sensitibo",
    loud: "malakas",

    readingSpeed: "Bilis ng pagbabasa",
    readingSpeedLabel: "Bilis",
    readingSpeedSlow: "Mabagal",
    readingSpeedNormal: "Normal",
    readingSpeedFast: "Mabilis",
    readingSpeedUnit: "char/s",
    readingSpeedDescription: "Kinokontrol kung gaano katagal nakikita ang bawat pagsasalin sa window. Mas mababa = mas maraming oras para basahin; Mas mataas = mas nakakasabay sa live audio.",
    
    overlayMode: "Overlay Mode",
    overlayOtherWindows: "I-overlay sa ibang mga window",
    overlayDescription: "Kapag pinagana, mananatiling nakikita ang translation window.",
    overlayActive: "Aktibo ang Overlay Mode",
    overlayActiveDescription: "Magbubukas ang translation window sa popup mode.",
    
    slideTime: "Oras ng Translation Slide",
    slideDuration: "Tagal ng slide",
    slideDescription: "Itinatakda kung gaano katagal ipapakita ang bawat translation slide.",
    seconds: "segundo",
    second: "segundo",
    
    translationLines: "Mga Linya ng Pagsasalin",
    maxLinesPerSlide: "Maximum na linya bawat slide",
    linesDescription: "Itinatakda ang maximum na bilang ng mga linya ng text bawat slide.",
    line: "linya",
    lines: "mga linya",
    
    translationFontSize: "Laki ng Font ng Pagsasalin",
    fontSize: "Laki ng font",
    fontSizeDescription: "Itinatakda ang laki ng font ng isinaling text.",
    small: "maliit",
    large: "malaki",
    
    headerBox: "Header Box",
    headerText: "Header Text",
    footerBox: "Footer Box",
    footerText: "Footer Text",
    padding: "Padding",
    roundCorners: "Bilugang mga Sulok",
    colors: "Mga Kulay",
    text: "Text",
    background: "Background",
    preview: "Preview",
    on: "ON",
    off: "OFF",
    
    recentHistory: "Kamakailang Kasaysayan",
    
    overlayActiveIndicator: "Aktibo ang Overlay",
    prevSlide: "Nakaraang slide",
    nextSlide: "Susunod na slide",
    goToSlide: "Pumunta sa slide",
    exitFullscreen: "Lumabas sa fullscreen",
    enterFullscreen: "Fullscreen",
    closeWindow: "Isara ang window",
    disableOverlay: "I-disable ang overlay",
    enableOverlay: "I-enable ang overlay",
    
    gateOpen: "Bukas ang Gate - Nagre-record",
    gateClosed: "Sarado ang Gate - Naghihintay ng signal",

    // Translation Rooms
    translationRooms: "Mga Translation Room",
    events: "Mga Event",
    createRoom: "Gumawa ng Translation Room",
    roomDescription: "Gumawa ng room para ma-access ng mga attendee sa events, simbahan o conference ang translation sa kanilang device gamit ang QR code o link.",
    roomProOnly: "Ang mga translation room ay para lamang sa PRO users",
    upgradeToProRooms: "Gumawa ng room at i-share ang QR code/link para makita ng mga bisita ang translation sa kanilang device.",
    
    // Permanent Links
    permanentLinks: "Mga Fixed Link",
    permanent: "Permanente",
    createPermanentLink: "Gumawa ng Fixed Link",
    permanentLinkDescription: "Gumawa ng mga permanenteng link para sa mga simbahan, conference at regular na events. I-print ang QR code isang beses at gamitin palagi!",
    roomName: "Pangalan ng Room",
    customCode: "Custom Code",
    customCodeOptional: "opsyonal",
    leaveEmptyToGenerate: "Iwanang blangko para auto-generate",
    linkPreview: "Link Preview",
    noPermanentLinksYet: "Wala pang fixed link. Gumawa ng permanenteng link para sa mga regular na event.",
    
    // QR Code Modal - Permanent Room
    qrCodeFixedLink: "QR Code - Fixed Link",
    permanentLinkLabel: "Permanenteng link:",
    qrNeverChanges: "Ang QR Code at link na ito ay hindi nagbabago! Pwede mong i-print at gamitin palagi.",
    copyLink: "Kopyahin ang Link",
    openLink: "Buksan",
    
    // QR Code Modal - Translation Room  
    shareRoom: "I-share ang Room",
    roomCode: "Room code:",
    shareLink: "Link para i-share:",
    visitorsCanScan: "Pwedeng i-scan ng mga bisita ang QR Code o i-access ang link para makita ang live translation",
    endRoomConfirm: "Sigurado ka bang gusto mong isara ang room? Madi-disconnect ang lahat ng bisita.",
    share: "I-share",

    // Room Config
    roomConfig: "Mga Setting ng Room",
    presenterLanguages: "Mga Wika ng Presenter",
    presenterLanguagesDescription: "Piliin ang lahat ng wikang sasabihin ng mga presenter sa event na ito.",
    presenterLanguagesTip: "Tip: Kung may mga speaker na nagsasalita ng iba't ibang wika, piliin lahat para ma-optimize ang translation.",
    selected: "napili",
    close: "Isara",
    
    // Public Room Page (Viewer)
    publicRoomTitle: "Translation Room",
    publicRoomBy: "ng",
    publicRoomSelectLanguage: "Ano ang iyong wika?",
    publicRoomLanguageHint: "Ipapakita ang translation sa napiling wika",
    publicRoomPoweredBy: "Powered by LCF Translator",
    publicRoomUnavailable: "Hindi Available ang Room",
    publicRoomBackHome: "Bumalik sa Home",
    publicRoomConnecting: "Kumokonekta sa room",
    publicRoomHeaderRoom: "Room",
    publicRoomConnected: "Konektado",
    publicRoomReconnecting: "Muling kumokonekta...",
    publicRoomChangeLanguage: "Palitan ang wika",
    publicRoomSettings: "Mga Setting",
    publicRoomReadingSpeed: "Bilis ng pagbabasa",
    publicRoomReadingSpeedSlow: "Mabagal",
    publicRoomReadingSpeedNormal: "Normal",
    publicRoomReadingSpeedFast: "Mabilis",
    publicRoomReadingSpeedUnit: "char/s",
    publicRoomInQueue: "sa pila",
    publicRoomFontSize: "Laki ng font",
    publicRoomBgColor: "Kulay ng background",
    publicRoomTextColor: "Kulay ng text",
    publicRoomShowOriginal: "Ipakita ang orihinal na text",
    publicRoomFullscreen: "Fullscreen",
    publicRoomExitFullscreen: "Lumabas sa fullscreen",
    publicRoomWaitingTranslation: "Naghihintay ng translation...",
    publicRoomViewers: "mga manonood",
    publicRoomViewer: "manonood",
    publicRoomWaitingSession: "Naghihintay ng simula ng session...",
    publicRoomSessionWillStart: "Magsisimula ang translation kapag nagsimula ang presenter.",
    publicRoomTranslating: "Nagta-translate...",
    publicRoomErrorNotFound: "Hindi nahanap ang kwarto. Pakisuri ang code at subukan muli.",
    publicRoomErrorServer: "Nabigo ang koneksyon sa server. Pakisubukan muli.",
    publicRoomSessionEnded: "Natapos na ng presenter ang session",
    publicRoomDeleted: "Permanenteng tinanggal na ang kwartong ito.",
    
    // Output mode selection
    publicRoomSelectMode: "Paano mo gustong matanggap ang translation?",
    publicRoomModeHint: "Piliin ang translation output mode",
    publicRoomTextOnly: "Text Translation",
    publicRoomTextOnlyDesc: "Basahin ang translation sa screen",
    publicRoomTextVoice: "Text + Voice Translation",
    publicRoomTextVoiceDesc: "Basahin at pakinggan ang translation",
    publicRoomHeadphonesRequired: "Kailangan ng earphones",
    publicRoomHeadphonesOverride: "May earphones akong nakakonekta pero hindi nakita",
    publicRoomHeadphonesNotDetected: "Ikonekta ang earphones para ma-enable ang opsyon na ito",
    publicRoomHeadphonesDetected: "Nakita ang earphones",
    publicRoomCheckingAudio: "Sinusuri ang audio devices...",
    publicRoomSpeaking: "Nagsasalita...",
    publicRoomVoiceEnabled: "Voice enabled",
    publicRoomChangeVoice: "Translator Voice",
    publicRoomVoiceDisabled: "Voice disabled",
    publicRoomSelectVoice: "Pumili ng boses",
    publicRoomSelectVoiceHint: "Piliin ang boses para sa sinasalitang pagsasalin",
    publicRoomVoicePreview: "Preview",
    publicRoomNoVoicesAvailable: "Walang boses na available para sa wikang ito",
    publicRoomVoiceSelected: "Napili ang boses",
    publicRoomConfirm: "Kumpirmahin",
    publicRoomTestVoice: "Subukan ang boses",
    publicRoomNoNativeVoices: "Walang boses sa {language} ang iyong device. Ipinapakita ang mga available na boses.",
    publicRoomInstallVoices: "Para makakuha ng mga boses sa ibang wika, mag-install ng language packs sa system settings.",
    publicRoomHowToInstallVoices: "Paano Mag-install ng Boses",
    publicRoomVoiceHelpTitle: "Paano Mag-install ng Boses sa Iyong Device",
    publicRoomVoiceHelpWindows: "Windows",
    publicRoomVoiceHelpWindowsSteps: "1. Buksan ang Settings (Win + I)\n2. Pumunta sa Time & Language → Speech\n3. I-click ang \"Add voices\"\n4. Piliin ang mga gustong wika\n5. I-restart ang browser",
    publicRoomVoiceHelpMac: "macOS",
    publicRoomVoiceHelpMacSteps: "1. Buksan ang System Preferences\n2. Pumunta sa Accessibility → Spoken Content\n3. I-click ang \"System Voice\"\n4. Piliin ang \"Customize\"\n5. I-download ang mga gustong boses",
    publicRoomVoiceHelpAndroid: "Android",
    publicRoomVoiceHelpAndroidSteps: "1. Buksan ang Settings\n2. Pumunta sa Accessibility → Text-to-Speech\n3. I-tap ang \"Preferred engine\"\n4. Mag-install ng karagdagang wika\n5. I-restart ang browser",
    publicRoomVoiceHelpIOS: "iPhone/iPad",
    publicRoomVoiceHelpIOSSteps: "1. Buksan ang Settings\n2. Pumunta sa Accessibility → Spoken Content\n3. I-tap ang \"Voices\"\n4. Piliin ang gustong wika\n5. I-download ang mga available na boses",
    publicRoomVoiceHelpTip: "Tip: Ang Google Chrome ay karaniwang may mas maraming boses kaysa sa ibang browser.",
    publicRoomVoiceHelpClose: "Isara",

    // Header / Navigation
    plans: "Mga Plano",
    account: "Account",
    logout: "Mag-logout",
    signUp: "Mag-sign Up",
    guest: "Bisita",
    free: "Libre",
    
    // Footer
    footerCopyright: "Ginawa ni João Vitor Fernandes Farias. Lahat ng karapatan ay nakalaan.",
    backToDashboard: "Bumalik sa Dashboard",
    
    // OBS Card (non-PRO overlay)
    obsProOverlayDesc: "Gamitin ang mga pagsasalin bilang mga subtitle sa iyong live na broadcast sa OBS, Streamlabs at iba pang streaming software.",
    obsProOnlyText: "Available lang ang feature na ito sa PRO Plan",
    obsCustomizeLabel: "I-customize",
    obsPositionLabel: "Posisyon",
    obsTextShadowLabel: "Text Shadow",
    obsTextShadowDesc: "Pinapabuti ang kakayahang mabasa sa video",
    obsGenerateUrl: "I-generate ang URL para sa OBS",
    obsGeneratedUrlLabel: "Na-generate na URL para sa OBS:",
    obsCopied: "Nakopya ang URL!",
    obsPreviewBtn: "Preview",
    obsParamsReference: "Opsyonal na URL parameters (reference)",
    obsParamBg: "Kulay ng background",
    obsParamFontSize: "Laki ng font (px)",
    obsParamColor: "Kulay ng text (hex walang #)",
    obsParamPosition: "Posisyon",
    obsParamShadow: "Text shadow",
    obsSettingsPlaceholder: "Mga setting ng customization...",

    // Pricing Page
    pricingTitle: "Piliin ang iyong Plan",
    pricingSubtitle: "Magsimula ng libre o i-unlock ang unlimited translation sa PRO Plan",
    planFree: "Libreng Plan",
    planPro: "PRO Plan",
    currentPlan: "Kasalukuyang Plan",
    perfectToTry: "Perpekto para subukan",
    forProfessionalUse: "Para sa propesyonal na paggamit",
    freePrice: "Libre",
    perMonth: "/buwan",
    feature10Minutes: "10 minuto ng translation bawat buwan",
    featureBidirectional: "Bidirectional translation",
    feature20Languages: "20 wika ang sinusuportahan",
    featureUnlimited: "UNLIMITED Translation",
    feature2Screens: "Translation sa 2 wika sa magkahiwalay na screen",
    featureOBS: "OBS integration para sa streaming",
    featureQRCode: "Direktang translation sa telepono ng bisita via QR Code",
    startFree: "Magsimula ng Libre",
    alreadyPro: "PRO ka na!",
    creditCard: "Card",
    payWithCard: "Magbayad gamit Card",
    loginToPay: "Mag-login para Magbayad",
    verifyPayment: "I-verify ang Bayad",
    amount: "Halaga",
    noConversionNeeded: "Ipadala ang eksaktong halaga sa",
    solanaNetwork: "Solana Network",
    sendTo: "Ipadala sa",
    tokenOnSolana: "sa Solana network",
    txSignatureLabel: "Transaction Signature (pagkatapos ipadala)",
    txSignaturePlaceholder: "I-paste ang transaction signature dito",
    viewOnSolscan: "Tingnan ang transaction sa Solscan",
    addressCopied: "Nakopya ang address!",
    errorRedirectPayment: "Error sa pag-redirect sa payment",
    errorEnterTxSignature: "Pakiusap maglagay ng transaction signature",
    errorVerifyTx: "Error sa pag-verify ng transaction",

    languagePortuguese: "Português",
    languageEnglish: "English",
    languageSpanish: "Español",
    languageFrench: "Français",
    languageMandarin: "中文",
    languageHindi: "हिन्दी",
    languageGerman: "Deutsch",
    languageRussian: "Русский",
    languageJapanese: "日本語",
    languageKorean: "한국어",
    languageArabic: "العربية",
    languageFilipino: "Filipino",
  }
};

export default translations;
